// Novos Templates Profissionais - Parte 1
// Baseados em landing pages premiadas (Dribbble, Awwwards, Landingfolio)

export const newTemplates = [
  // ============================================
  // 1. LEAD CAPTURE PRO - Ebook/Material Rico
  // ============================================
  {
    id: 'lead-capture-pro',
    name: 'Captura de Leads Pro',
    description: 'Página completa para captura de leads com design premium e alta conversão',
    thumbnail: 'https://images.unsplash.com/photo-1586281380349-632531db7ed4?w=400&h=300&fit=crop',
    category: 'lead-magnet',
    gjsHtml: `
<style>
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif; }

  /* Container */
  .lcp-container { max-width: 1200px; margin: 0 auto; padding: 0 24px; }

  /* Hero */
  .lcp-hero { min-height: 100vh; display: flex; align-items: center; padding: 80px 0; background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%); }
  .lcp-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: center; }
  .lcp-badge { display: inline-flex; align-items: center; gap: 8px; padding: 10px 20px; background: rgba(99, 102, 241, 0.1); border: 1px solid rgba(99, 102, 241, 0.2); border-radius: 100px; color: #6366f1; font-size: 14px; font-weight: 600; margin-bottom: 24px; }
  .lcp-title { font-size: 3.25rem; font-weight: 800; color: #0f172a; line-height: 1.1; margin: 0 0 24px 0; }
  .lcp-title span { background: linear-gradient(135deg, #6366f1, #8b5cf6); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; }
  .lcp-subtitle { font-size: 1.25rem; color: #64748b; line-height: 1.7; margin: 0 0 32px 0; }
  .lcp-benefits { list-style: none; padding: 0; margin: 0 0 40px 0; }
  .lcp-benefits li { display: flex; align-items: flex-start; gap: 16px; padding: 16px 0; border-bottom: 1px solid #f1f5f9; }
  .lcp-benefits li:last-child { border: none; }
  .lcp-check { width: 28px; height: 28px; background: linear-gradient(135deg, #10b981, #059669); border-radius: 50%; display: flex; align-items: center; justify-content: center; color: white; font-size: 14px; flex-shrink: 0; }
  .lcp-benefit-text { font-size: 1.05rem; color: #334155; font-weight: 500; }

  /* Form Card */
  .lcp-form-card { background: white; padding: 48px; border-radius: 24px; box-shadow: 0 25px 60px rgba(0,0,0,0.12); border: 1px solid #e2e8f0; position: relative; }
  .lcp-form-card::before { content: ''; position: absolute; top: -2px; left: -2px; right: -2px; bottom: -2px; background: linear-gradient(135deg, #6366f1, #8b5cf6); border-radius: 26px; z-index: -1; opacity: 0.5; }
  .lcp-form-title { font-size: 1.5rem; font-weight: 700; color: #0f172a; text-align: center; margin: 0 0 8px 0; }
  .lcp-form-desc { color: #64748b; text-align: center; margin: 0 0 32px 0; font-size: 15px; }
  .lcp-input { width: 100%; padding: 16px 20px; border: 2px solid #e2e8f0; border-radius: 12px; font-size: 1rem; margin-bottom: 16px; transition: border-color 0.2s, box-shadow 0.2s; outline: none; }
  .lcp-input:focus { border-color: #6366f1; box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.1); }
  .lcp-btn { width: 100%; padding: 18px; background: linear-gradient(135deg, #6366f1, #8b5cf6); color: white; font-weight: 700; font-size: 1.1rem; border: none; border-radius: 12px; cursor: pointer; transition: transform 0.2s, box-shadow 0.2s; }
  .lcp-btn:hover { transform: translateY(-2px); box-shadow: 0 10px 30px rgba(99, 102, 241, 0.4); }
  .lcp-privacy { text-align: center; color: #94a3b8; font-size: 13px; margin-top: 20px; display: flex; align-items: center; justify-content: center; gap: 6px; }

  /* Logos Section */
  .lcp-logos { padding: 60px 24px; background: white; border-bottom: 1px solid #f1f5f9; }
  .lcp-logos-title { text-align: center; color: #94a3b8; font-size: 14px; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 32px; }
  .lcp-logos-grid { display: flex; justify-content: center; align-items: center; gap: 60px; flex-wrap: wrap; opacity: 0.6; }
  .lcp-logo { font-size: 24px; font-weight: 700; color: #64748b; }

  /* Content Preview */
  .lcp-content { padding: 100px 24px; background: #f8fafc; }
  .lcp-section-title { font-size: 2.5rem; font-weight: 800; color: #0f172a; text-align: center; margin-bottom: 16px; }
  .lcp-section-subtitle { font-size: 1.2rem; color: #64748b; text-align: center; max-width: 600px; margin: 0 auto 60px; line-height: 1.7; }
  .lcp-content-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 32px; }
  .lcp-content-card { background: white; padding: 40px 32px; border-radius: 20px; box-shadow: 0 4px 20px rgba(0,0,0,0.06); transition: transform 0.3s, box-shadow 0.3s; }
  .lcp-content-card:hover { transform: translateY(-8px); box-shadow: 0 20px 40px rgba(0,0,0,0.1); }
  .lcp-content-icon { width: 64px; height: 64px; background: linear-gradient(135deg, #6366f1, #8b5cf6); border-radius: 16px; display: flex; align-items: center; justify-content: center; font-size: 28px; margin-bottom: 24px; }
  .lcp-content-title { font-size: 1.25rem; font-weight: 700; color: #0f172a; margin-bottom: 12px; }
  .lcp-content-desc { color: #64748b; line-height: 1.7; font-size: 15px; }

  /* Target Audience */
  .lcp-audience { padding: 100px 24px; background: white; }
  .lcp-audience-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: center; }
  .lcp-audience-image { width: 100%; border-radius: 24px; box-shadow: 0 25px 50px rgba(0,0,0,0.15); }
  .lcp-audience-list { list-style: none; padding: 0; }
  .lcp-audience-item { display: flex; align-items: flex-start; gap: 20px; padding: 24px 0; border-bottom: 1px solid #f1f5f9; }
  .lcp-audience-item:last-child { border: none; }
  .lcp-audience-icon { width: 48px; height: 48px; background: rgba(99, 102, 241, 0.1); border-radius: 12px; display: flex; align-items: center; justify-content: center; font-size: 24px; flex-shrink: 0; }
  .lcp-audience-text h4 { font-size: 1.1rem; font-weight: 700; color: #0f172a; margin-bottom: 4px; }
  .lcp-audience-text p { color: #64748b; font-size: 15px; line-height: 1.6; }

  /* Author Section */
  .lcp-author-section { padding: 100px 24px; background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%); }
  .lcp-author-grid { display: grid; grid-template-columns: 300px 1fr; gap: 60px; align-items: center; }
  .lcp-author-image { width: 300px; height: 300px; border-radius: 24px; object-fit: cover; box-shadow: 0 25px 50px rgba(0,0,0,0.3); }
  .lcp-author-content h3 { color: #6366f1; font-size: 14px; text-transform: uppercase; letter-spacing: 2px; margin-bottom: 16px; }
  .lcp-author-content h2 { color: white; font-size: 2.5rem; font-weight: 800; margin-bottom: 24px; }
  .lcp-author-content p { color: #94a3b8; font-size: 1.1rem; line-height: 1.8; margin-bottom: 16px; }
  .lcp-author-stats { display: flex; gap: 40px; margin-top: 32px; }
  .lcp-stat { text-align: left; }
  .lcp-stat-value { font-size: 2rem; font-weight: 800; color: #6366f1; }
  .lcp-stat-label { color: #94a3b8; font-size: 14px; }

  /* Testimonials */
  .lcp-testimonials-section { padding: 100px 24px; background: #f8fafc; }
  .lcp-testimonials-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 32px; }
  .lcp-testimonial { background: white; padding: 40px; border-radius: 20px; box-shadow: 0 4px 20px rgba(0,0,0,0.06); }
  .lcp-stars { color: #fbbf24; font-size: 20px; margin-bottom: 20px; }
  .lcp-quote { color: #334155; font-size: 1rem; line-height: 1.8; margin-bottom: 24px; }
  .lcp-author-info { display: flex; align-items: center; gap: 16px; }
  .lcp-avatar { width: 56px; height: 56px; border-radius: 50%; object-fit: cover; }
  .lcp-author-name { font-weight: 700; color: #0f172a; font-size: 16px; }
  .lcp-author-role { color: #64748b; font-size: 14px; }

  /* FAQ */
  .lcp-faq { padding: 100px 24px; background: white; }
  .lcp-faq-grid { max-width: 800px; margin: 0 auto; }
  .lcp-faq-item { border-bottom: 1px solid #e2e8f0; }
  .lcp-faq-question { padding: 24px 0; font-size: 1.1rem; font-weight: 600; color: #0f172a; cursor: pointer; display: flex; justify-content: space-between; align-items: center; }
  .lcp-faq-question::after { content: '+'; font-size: 24px; color: #6366f1; }
  .lcp-faq-answer { padding: 0 0 24px; color: #64748b; line-height: 1.8; display: block; }

  /* Final CTA */
  .lcp-final-cta { padding: 100px 24px; background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%); text-align: center; }
  .lcp-final-cta h2 { font-size: 3rem; font-weight: 800; color: white; margin-bottom: 20px; }
  .lcp-final-cta p { font-size: 1.25rem; color: rgba(255,255,255,0.9); margin-bottom: 40px; max-width: 600px; margin-left: auto; margin-right: auto; }
  .lcp-final-form { max-width: 500px; margin: 0 auto; display: flex; gap: 12px; }
  .lcp-final-input { flex: 1; padding: 18px 24px; border: none; border-radius: 12px; font-size: 1rem; }
  .lcp-final-btn { padding: 18px 32px; background: #0f172a; color: white; font-weight: 700; border: none; border-radius: 12px; cursor: pointer; white-space: nowrap; transition: transform 0.2s; }
  .lcp-final-btn:hover { transform: scale(1.05); }

  /* Footer */
  .lcp-footer { padding: 60px 24px 80px; background: #0f172a; text-align: center; }
  .lcp-footer p { color: #64748b; font-size: 14px; margin-bottom: 16px; }
  .lcp-footer-links { display: flex; justify-content: center; gap: 32px; }
  .lcp-footer-links a { color: #94a3b8; font-size: 14px; text-decoration: none; transition: color 0.2s; }
  .lcp-footer-links a:hover { color: white; }

  /* Responsive */
  @media (max-width: 968px) {
    .lcp-grid, .lcp-audience-grid, .lcp-author-grid { grid-template-columns: 1fr; gap: 48px; }
    .lcp-title { font-size: 2.5rem; }
    .lcp-content-grid, .lcp-testimonials-grid { grid-template-columns: 1fr; }
    .lcp-hero { padding: 60px 0; min-height: auto; }
    .lcp-section-title { font-size: 2rem; }
    .lcp-author-image { width: 200px; height: 200px; margin: 0 auto; }
    .lcp-final-form { flex-direction: column; }
    .lcp-final-cta h2 { font-size: 2rem; }
    .lcp-logos-grid { gap: 30px; }
  }
</style>

<!-- HERO -->
<section class="lcp-hero">
  <div class="lcp-container">
    <div class="lcp-grid">
      <div>
        <div class="lcp-badge">
          <span>📘</span> E-book Gratuito - Edição 2025
        </div>
        <h1 class="lcp-title">
          O Guia Definitivo para <span>Dobrar Suas Vendas</span> em 90 Dias
        </h1>
        <p class="lcp-subtitle">
          Descubra o método passo a passo que já ajudou mais de 15.000 empreendedores a escalar seus resultados de forma previsível e sustentável.
        </p>
        <ul class="lcp-benefits">
          <li>
            <span class="lcp-check">✓</span>
            <span class="lcp-benefit-text">47 estratégias testadas e comprovadas em diferentes mercados</span>
          </li>
          <li>
            <span class="lcp-check">✓</span>
            <span class="lcp-benefit-text">Planilhas e templates prontos para usar imediatamente</span>
          </li>
          <li>
            <span class="lcp-check">✓</span>
            <span class="lcp-benefit-text">Estudos de caso reais com resultados documentados</span>
          </li>
          <li>
            <span class="lcp-check">✓</span>
            <span class="lcp-benefit-text">Bônus: Checklist de implementação em 30 dias</span>
          </li>
        </ul>
      </div>
      <div>
        <div class="lcp-form-card">
          <h2 class="lcp-form-title">Baixe Agora - 100% Grátis</h2>
          <p class="lcp-form-desc">Preencha abaixo para receber seu exemplar</p>
          <form data-success-message="E-book enviado para seu e-mail! Verifique sua caixa de entrada.">
            <input type="text" name="name" class="lcp-input" placeholder="Seu nome completo" required />
            <input type="email" name="email" class="lcp-input" placeholder="Seu melhor e-mail" required />
            <input type="tel" name="phone" class="lcp-input" placeholder="WhatsApp (opcional)" />
            <button type="submit" class="lcp-btn">QUERO MEU E-BOOK GRÁTIS →</button>
          </form>
          <p class="lcp-privacy">🔒 Seus dados estão seguros e protegidos</p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- LOGOS -->
<section class="lcp-logos">
  <div class="lcp-container">
    <p class="lcp-logos-title">Método utilizado por profissionais de</p>
    <div class="lcp-logos-grid">
      <span class="lcp-logo">Google</span>
      <span class="lcp-logo">Meta</span>
      <span class="lcp-logo">Nubank</span>
      <span class="lcp-logo">iFood</span>
      <span class="lcp-logo">Mercado Livre</span>
    </div>
  </div>
</section>

<!-- CONTENT PREVIEW -->
<section class="lcp-content">
  <div class="lcp-container">
    <h2 class="lcp-section-title">O Que Você Vai Aprender</h2>
    <p class="lcp-section-subtitle">Conteúdo 100% prático e aplicável, desenvolvido para gerar resultados reais no seu negócio</p>
    <div class="lcp-content-grid">
      <div class="lcp-content-card">
        <div class="lcp-content-icon">🎯</div>
        <h3 class="lcp-content-title">Capítulo 1: Fundamentos</h3>
        <p class="lcp-content-desc">Entenda a psicologia por trás das decisões de compra e como usar isso a seu favor para aumentar conversões.</p>
      </div>
      <div class="lcp-content-card">
        <div class="lcp-content-icon">📈</div>
        <h3 class="lcp-content-title">Capítulo 2: Estratégias</h3>
        <p class="lcp-content-desc">47 táticas comprovadas para atrair, engajar e converter mais clientes em qualquer nicho de mercado.</p>
      </div>
      <div class="lcp-content-card">
        <div class="lcp-content-icon">🚀</div>
        <h3 class="lcp-content-title">Capítulo 3: Escala</h3>
        <p class="lcp-content-desc">Como automatizar e escalar seu processo de vendas mantendo a qualidade e aumentando o faturamento.</p>
      </div>
      <div class="lcp-content-card">
        <div class="lcp-content-icon">💡</div>
        <h3 class="lcp-content-title">Capítulo 4: Otimização</h3>
        <p class="lcp-content-desc">Técnicas avançadas de teste A/B e otimização contínua para maximizar seus resultados.</p>
      </div>
      <div class="lcp-content-card">
        <div class="lcp-content-icon">📊</div>
        <h3 class="lcp-content-title">Capítulo 5: Métricas</h3>
        <p class="lcp-content-desc">Quais números acompanhar e como interpretar dados para tomar decisões mais inteligentes.</p>
      </div>
      <div class="lcp-content-card">
        <div class="lcp-content-icon">🎁</div>
        <h3 class="lcp-content-title">Bônus: Templates</h3>
        <p class="lcp-content-desc">Planilhas, scripts e modelos prontos para você implementar imediatamente no seu negócio.</p>
      </div>
    </div>
  </div>
</section>

<!-- TARGET AUDIENCE -->
<section class="lcp-audience">
  <div class="lcp-container">
    <div class="lcp-audience-grid">
      <div>
        <img src="https://images.unsplash.com/photo-1552581234-26160f608093?w=600&h=500&fit=crop" alt="Profissional trabalhando" class="lcp-audience-image" />
      </div>
      <div>
        <h2 class="lcp-section-title" style="text-align: left;">Para Quem É Este E-book?</h2>
        <p class="lcp-section-subtitle" style="text-align: left; margin-left: 0;">Este material foi criado especialmente para:</p>
        <ul class="lcp-audience-list">
          <li class="lcp-audience-item">
            <div class="lcp-audience-icon">👨‍💼</div>
            <div class="lcp-audience-text">
              <h4>Empreendedores</h4>
              <p>Que querem aumentar o faturamento sem depender apenas de indicações</p>
            </div>
          </li>
          <li class="lcp-audience-item">
            <div class="lcp-audience-icon">📱</div>
            <div class="lcp-audience-text">
              <h4>Profissionais de Marketing</h4>
              <p>Que buscam estratégias comprovadas para melhorar resultados</p>
            </div>
          </li>
          <li class="lcp-audience-item">
            <div class="lcp-audience-icon">🏪</div>
            <div class="lcp-audience-text">
              <h4>Donos de Negócios Locais</h4>
              <p>Que precisam atrair mais clientes de forma consistente</p>
            </div>
          </li>
          <li class="lcp-audience-item">
            <div class="lcp-audience-icon">💻</div>
            <div class="lcp-audience-text">
              <h4>Freelancers e Consultores</h4>
              <p>Que querem sair da montanha-russa financeira</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>

<!-- AUTHOR -->
<section class="lcp-author-section">
  <div class="lcp-container">
    <div class="lcp-author-grid">
      <img src="https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&h=400&fit=crop" alt="Autor" class="lcp-author-image" />
      <div class="lcp-author-content">
        <h3>Sobre o Autor</h3>
        <h2>João Silva</h2>
        <p>Especialista em vendas e marketing digital com mais de 15 anos de experiência. Já ajudou mais de 500 empresas a multiplicarem seus resultados através de estratégias comprovadas.</p>
        <p>Fundador da Agência XYZ e palestrante reconhecido nacionalmente, João compartilha neste e-book todo o conhecimento que acumulou ao longo de sua carreira.</p>
        <div class="lcp-author-stats">
          <div class="lcp-stat">
            <div class="lcp-stat-value">500+</div>
            <div class="lcp-stat-label">Empresas atendidas</div>
          </div>
          <div class="lcp-stat">
            <div class="lcp-stat-value">15.000+</div>
            <div class="lcp-stat-label">Downloads do e-book</div>
          </div>
          <div class="lcp-stat">
            <div class="lcp-stat-value">R$50M+</div>
            <div class="lcp-stat-label">Gerados para clientes</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- TESTIMONIALS -->
<section class="lcp-testimonials-section">
  <div class="lcp-container">
    <h2 class="lcp-section-title">O Que Dizem Sobre o E-book</h2>
    <p class="lcp-section-subtitle">Depoimentos reais de pessoas que já aplicaram o método</p>
    <div class="lcp-testimonials-grid">
      <div class="lcp-testimonial">
        <div class="lcp-stars">★★★★★</div>
        <p class="lcp-quote">"Implementei apenas 3 estratégias do e-book e aumentei minhas vendas em 40% no primeiro mês. O conteúdo é extremamente prático e vai direto ao ponto."</p>
        <div class="lcp-author-info">
          <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop" class="lcp-avatar" alt="Avatar" />
          <div>
            <div class="lcp-author-name">Maria Silva</div>
            <div class="lcp-author-role">Empreendedora Digital</div>
          </div>
        </div>
      </div>
      <div class="lcp-testimonial">
        <div class="lcp-stars">★★★★★</div>
        <p class="lcp-quote">"O melhor material gratuito que já baixei. As planilhas sozinhas já valem muito mais do que muitos cursos pagos que já comprei."</p>
        <div class="lcp-author-info">
          <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop" class="lcp-avatar" alt="Avatar" />
          <div>
            <div class="lcp-author-name">Pedro Santos</div>
            <div class="lcp-author-role">CEO, TechStartup</div>
          </div>
        </div>
      </div>
      <div class="lcp-testimonial">
        <div class="lcp-stars">★★★★★</div>
        <p class="lcp-quote">"Finalmente um conteúdo que entrega o que promete. Sem enrolação, só estratégias que funcionam de verdade. Recomendo demais!"</p>
        <div class="lcp-author-info">
          <img src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop" class="lcp-avatar" alt="Avatar" />
          <div>
            <div class="lcp-author-name">Ana Costa</div>
            <div class="lcp-author-role">Marketing Manager</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- FAQ -->
<section class="lcp-faq">
  <div class="lcp-container">
    <h2 class="lcp-section-title">Perguntas Frequentes</h2>
    <p class="lcp-section-subtitle">Tire suas dúvidas sobre o e-book</p>
    <div class="lcp-faq-grid">
      <div class="lcp-faq-item">
        <div class="lcp-faq-question">O e-book é realmente gratuito?</div>
        <div class="lcp-faq-answer">Sim, 100% gratuito! Você só precisa informar seu e-mail para receber o material completo. Não existe nenhum custo oculto.</div>
      </div>
      <div class="lcp-faq-item">
        <div class="lcp-faq-question">Para qual tipo de negócio serve?</div>
        <div class="lcp-faq-answer">O conteúdo foi desenvolvido para ser aplicável em qualquer tipo de negócio - serviços, produtos físicos, digitais, B2B ou B2C. Os princípios são universais.</div>
      </div>
      <div class="lcp-faq-item">
        <div class="lcp-faq-question">Em quanto tempo vou ver resultados?</div>
        <div class="lcp-faq-answer">Depende da sua dedicação na implementação. Alguns leitores relatam resultados já nas primeiras semanas, outros em 30-60 dias. O importante é aplicar o método consistentemente.</div>
      </div>
      <div class="lcp-faq-item">
        <div class="lcp-faq-question">Vou receber spam depois de baixar?</div>
        <div class="lcp-faq-answer">Não! Você receberá apenas conteúdos relevantes sobre vendas e marketing. Pode cancelar a inscrição a qualquer momento com um clique.</div>
      </div>
      <div class="lcp-faq-item">
        <div class="lcp-faq-question">Como recebo o e-book?</div>
        <div class="lcp-faq-answer">Imediatamente após o cadastro, você receberá um e-mail com o link para download. Verifique também sua caixa de spam/promoções.</div>
      </div>
    </div>
  </div>
</section>

<!-- FINAL CTA -->
<section class="lcp-final-cta">
  <div class="lcp-container">
    <h2>Pronto Para Dobrar Suas Vendas?</h2>
    <p>Junte-se a mais de 15.000 empreendedores que já transformaram seus resultados com este método comprovado.</p>
    <form class="lcp-final-form" data-success-message="E-book enviado para seu e-mail!">
      <input type="email" name="email" class="lcp-final-input" placeholder="Digite seu melhor e-mail" required />
      <button type="submit" class="lcp-final-btn">BAIXAR E-BOOK GRÁTIS</button>
    </form>
  </div>
</section>

<!-- FOOTER -->
<footer class="lcp-footer">
  <div class="lcp-container">
    <p>© 2025 SuaEmpresa. Todos os direitos reservados.</p>
    <div class="lcp-footer-links">
      <a href="#">Política de Privacidade</a>
      <a href="#">Termos de Uso</a>
      <a href="#">Contato</a>
    </div>
  </div>
</footer>
`,
    gjsCss: '',
    gjsComponents: '',
    gjsStyles: ''
  },

  // ============================================
  // 2. NEWSLETTER PREMIUM
  // ============================================
  {
    id: 'newsletter-premium',
    name: 'Newsletter Premium',
    description: 'Página completa para captura de inscritos em newsletter com design dark mode',
    thumbnail: 'https://images.unsplash.com/photo-1579275542618-a1dfed5f54ba?w=400&h=300&fit=crop',
    category: 'lead-magnet',
    gjsHtml: `
<style>
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif; }

  /* Page */
  .nl-page { background: #0a0a0a; color: white; }

  /* Hero */
  .nl-hero { min-height: 100vh; display: flex; align-items: center; justify-content: center; padding: 80px 24px; position: relative; overflow: hidden; }
  .nl-bg-gradient { position: absolute; top: -50%; left: -50%; width: 200%; height: 200%; background: radial-gradient(circle at 30% 30%, rgba(124, 58, 237, 0.15) 0%, transparent 50%), radial-gradient(circle at 70% 70%, rgba(236, 72, 153, 0.1) 0%, transparent 50%); animation: rotate 20s linear infinite; }
  @keyframes rotate { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
  .nl-content { max-width: 600px; text-align: center; position: relative; z-index: 1; }
  .nl-badge { display: inline-flex; align-items: center; gap: 8px; padding: 10px 20px; background: rgba(124, 58, 237, 0.2); border: 1px solid rgba(124, 58, 237, 0.3); border-radius: 100px; color: #a78bfa; font-size: 14px; font-weight: 500; margin-bottom: 32px; }
  .nl-badge-dot { width: 8px; height: 8px; background: #22c55e; border-radius: 50%; animation: pulse 2s infinite; }
  @keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.5; } }
  .nl-title { font-size: 4rem; font-weight: 800; color: white; line-height: 1.1; margin-bottom: 24px; letter-spacing: -0.02em; }
  .nl-title span { background: linear-gradient(135deg, #a78bfa, #f472b6); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; }
  .nl-desc { font-size: 1.25rem; color: #a1a1aa; line-height: 1.7; margin-bottom: 48px; }
  .nl-form { display: flex; gap: 12px; margin-bottom: 24px; }
  .nl-input { flex: 1; padding: 18px 24px; background: rgba(255,255,255,0.05); border: 2px solid rgba(255,255,255,0.1); border-radius: 12px; color: white; font-size: 16px; outline: none; transition: all 0.2s; }
  .nl-input::placeholder { color: #71717a; }
  .nl-input:focus { border-color: #7c3aed; background: rgba(255,255,255,0.08); }
  .nl-btn { padding: 18px 36px; background: linear-gradient(135deg, #7c3aed, #a855f7); color: white; font-weight: 700; font-size: 16px; border: none; border-radius: 12px; cursor: pointer; transition: transform 0.2s, box-shadow 0.2s; white-space: nowrap; }
  .nl-btn:hover { transform: translateY(-2px); box-shadow: 0 10px 30px rgba(124, 58, 237, 0.4); }
  .nl-meta { display: flex; align-items: center; justify-content: center; gap: 24px; color: #71717a; font-size: 14px; }
  .nl-meta span { display: flex; align-items: center; gap: 6px; }

  /* Stats */
  .nl-stats { padding: 60px 24px; background: #111111; border-top: 1px solid #1f1f1f; border-bottom: 1px solid #1f1f1f; }
  .nl-stats-grid { max-width: 800px; margin: 0 auto; display: grid; grid-template-columns: repeat(4, 1fr); gap: 40px; text-align: center; }
  .nl-stat-value { font-size: 2.5rem; font-weight: 800; background: linear-gradient(135deg, #a78bfa, #f472b6); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; margin-bottom: 8px; }
  .nl-stat-label { color: #71717a; font-size: 14px; }

  /* Features */
  .nl-features { padding: 100px 24px; background: #0a0a0a; }
  .nl-container { max-width: 1100px; margin: 0 auto; }
  .nl-section-title { font-size: 2.5rem; font-weight: 800; text-align: center; margin-bottom: 16px; }
  .nl-section-subtitle { color: #71717a; text-align: center; font-size: 1.1rem; margin-bottom: 60px; }
  .nl-features-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 32px; }
  .nl-feature { background: #111111; border: 1px solid #1f1f1f; border-radius: 20px; padding: 40px 32px; transition: all 0.3s; }
  .nl-feature:hover { border-color: #7c3aed; transform: translateY(-4px); }
  .nl-feature-icon { width: 64px; height: 64px; background: linear-gradient(135deg, rgba(124, 58, 237, 0.2), rgba(168, 85, 247, 0.1)); border-radius: 16px; display: flex; align-items: center; justify-content: center; margin-bottom: 24px; font-size: 28px; }
  .nl-feature-title { color: white; font-size: 1.25rem; font-weight: 700; margin-bottom: 12px; }
  .nl-feature-desc { color: #71717a; font-size: 15px; line-height: 1.7; }

  /* Sample Issue */
  .nl-sample { padding: 100px 24px; background: #111111; }
  .nl-sample-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: center; }
  .nl-sample-content h2 { font-size: 2.5rem; font-weight: 800; margin-bottom: 24px; }
  .nl-sample-content p { color: #a1a1aa; font-size: 1.1rem; line-height: 1.8; margin-bottom: 32px; }
  .nl-sample-list { list-style: none; }
  .nl-sample-list li { display: flex; align-items: center; gap: 16px; padding: 16px 0; border-bottom: 1px solid #1f1f1f; color: #d4d4d8; }
  .nl-sample-list li:last-child { border: none; }
  .nl-sample-check { width: 24px; height: 24px; background: linear-gradient(135deg, #7c3aed, #a855f7); border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 12px; flex-shrink: 0; }
  .nl-sample-preview { background: #0a0a0a; border: 1px solid #1f1f1f; border-radius: 20px; padding: 32px; }
  .nl-sample-header { display: flex; align-items: center; gap: 16px; margin-bottom: 24px; padding-bottom: 24px; border-bottom: 1px solid #1f1f1f; }
  .nl-sample-avatar { width: 48px; height: 48px; background: linear-gradient(135deg, #7c3aed, #a855f7); border-radius: 12px; }
  .nl-sample-from { font-weight: 600; }
  .nl-sample-subject { color: #71717a; font-size: 14px; }
  .nl-sample-body h4 { font-size: 1.5rem; font-weight: 700; margin-bottom: 16px; }
  .nl-sample-body p { color: #a1a1aa; line-height: 1.8; font-size: 15px; }

  /* Testimonials */
  .nl-testimonials { padding: 100px 24px; background: #0a0a0a; }
  .nl-testimonials-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; }
  .nl-testimonial { background: #111111; border: 1px solid #1f1f1f; border-radius: 20px; padding: 32px; }
  .nl-testimonial-quote { color: #d4d4d8; font-size: 1rem; line-height: 1.8; margin-bottom: 24px; font-style: italic; }
  .nl-testimonial-author { display: flex; align-items: center; gap: 16px; }
  .nl-testimonial-avatar { width: 48px; height: 48px; border-radius: 50%; object-fit: cover; }
  .nl-testimonial-name { font-weight: 600; font-size: 15px; }
  .nl-testimonial-role { color: #71717a; font-size: 13px; }

  /* Archive */
  .nl-archive { padding: 100px 24px; background: #111111; }
  .nl-archive-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 24px; max-width: 900px; margin: 0 auto; }
  .nl-archive-item { display: flex; align-items: center; gap: 20px; background: #0a0a0a; border: 1px solid #1f1f1f; border-radius: 16px; padding: 24px; transition: all 0.3s; }
  .nl-archive-item:hover { border-color: #7c3aed; }
  .nl-archive-date { background: linear-gradient(135deg, #7c3aed, #a855f7); color: white; padding: 12px 16px; border-radius: 12px; text-align: center; flex-shrink: 0; }
  .nl-archive-day { font-size: 1.5rem; font-weight: 800; display: block; }
  .nl-archive-month { font-size: 12px; text-transform: uppercase; }
  .nl-archive-title { font-weight: 600; margin-bottom: 4px; }
  .nl-archive-preview { color: #71717a; font-size: 14px; }

  /* Final CTA */
  .nl-final-cta { padding: 100px 24px; background: linear-gradient(135deg, #7c3aed 0%, #a855f7 100%); text-align: center; }
  .nl-final-cta h2 { font-size: 3rem; font-weight: 800; margin-bottom: 20px; }
  .nl-final-cta p { font-size: 1.25rem; opacity: 0.9; margin-bottom: 40px; max-width: 500px; margin-left: auto; margin-right: auto; }
  .nl-final-form { max-width: 480px; margin: 0 auto; display: flex; gap: 12px; }
  .nl-final-input { flex: 1; padding: 18px 24px; border: none; border-radius: 12px; font-size: 16px; background: white; }
  .nl-final-btn { padding: 18px 32px; background: #0a0a0a; color: white; font-weight: 700; border: none; border-radius: 12px; cursor: pointer; white-space: nowrap; transition: transform 0.2s; }
  .nl-final-btn:hover { transform: scale(1.05); }

  /* Footer */
  .nl-footer { padding: 60px 24px; background: #0a0a0a; text-align: center; border-top: 1px solid #1f1f1f; }
  .nl-footer p { color: #52525b; font-size: 14px; margin-bottom: 16px; }
  .nl-footer-links { display: flex; justify-content: center; gap: 32px; }
  .nl-footer-links a { color: #71717a; font-size: 14px; text-decoration: none; transition: color 0.2s; }
  .nl-footer-links a:hover { color: white; }

  /* Responsive */
  @media (max-width: 968px) {
    .nl-title { font-size: 2.75rem; }
    .nl-form { flex-direction: column; }
    .nl-stats-grid { grid-template-columns: repeat(2, 1fr); gap: 24px; }
    .nl-features-grid, .nl-testimonials-grid { grid-template-columns: 1fr; }
    .nl-sample-grid { grid-template-columns: 1fr; gap: 48px; }
    .nl-archive-grid { grid-template-columns: 1fr; }
    .nl-final-form { flex-direction: column; }
    .nl-final-cta h2 { font-size: 2rem; }
    .nl-meta { flex-direction: column; gap: 12px; }
  }
</style>

<div class="nl-page">
  <!-- HERO -->
  <section class="nl-hero">
    <div class="nl-bg-gradient"></div>
    <div class="nl-content">
      <div class="nl-badge">
        <span class="nl-badge-dot"></span>
        Mais de 25.000 leitores semanais
      </div>
      <h1 class="nl-title">
        Insights de <span>negócios</span> direto no seu inbox
      </h1>
      <p class="nl-desc">
        Toda terça-feira, enviamos as melhores estratégias, tendências e análises do mercado. Leitura de 5 minutos que vale horas de pesquisa.
      </p>
      <form class="nl-form" data-success-message="Inscricao confirmada! Verifique seu e-mail.">
        <input type="email" name="email" class="nl-input" placeholder="Digite seu melhor e-mail" required />
        <button type="submit" class="nl-btn">Inscrever-se Grátis</button>
      </form>
      <div class="nl-meta">
        <span>✓ 100% gratuito</span>
        <span>✓ Cancele quando quiser</span>
        <span>✓ Sem spam, prometemos</span>
      </div>
    </div>
  </section>

  <!-- STATS -->
  <section class="nl-stats">
    <div class="nl-stats-grid">
      <div>
        <div class="nl-stat-value">25K+</div>
        <div class="nl-stat-label">Assinantes</div>
      </div>
      <div>
        <div class="nl-stat-value">52%</div>
        <div class="nl-stat-label">Taxa de abertura</div>
      </div>
      <div>
        <div class="nl-stat-value">150+</div>
        <div class="nl-stat-label">Edições enviadas</div>
      </div>
      <div>
        <div class="nl-stat-value">4.9/5</div>
        <div class="nl-stat-label">Avaliação média</div>
      </div>
    </div>
  </section>

  <!-- FEATURES -->
  <section class="nl-features">
    <div class="nl-container">
      <h2 class="nl-section-title">O Que Você Vai Receber</h2>
      <p class="nl-section-subtitle">Conteúdo curado semanalmente para impulsionar seus resultados</p>
      <div class="nl-features-grid">
        <div class="nl-feature">
          <div class="nl-feature-icon">📊</div>
          <h3 class="nl-feature-title">Análises Exclusivas</h3>
          <p class="nl-feature-desc">Dados e insights aprofundados sobre tendências de mercado que você não encontra em outro lugar.</p>
        </div>
        <div class="nl-feature">
          <div class="nl-feature-icon">🎯</div>
          <h3 class="nl-feature-title">Direto ao Ponto</h3>
          <p class="nl-feature-desc">Conteúdo objetivo e bem estruturado. Leitura de apenas 5 minutos que vale horas de pesquisa.</p>
        </div>
        <div class="nl-feature">
          <div class="nl-feature-icon">🚀</div>
          <h3 class="nl-feature-title">100% Acionável</h3>
          <p class="nl-feature-desc">Estratégias práticas que você pode implementar imediatamente no seu negócio.</p>
        </div>
        <div class="nl-feature">
          <div class="nl-feature-icon">💡</div>
          <h3 class="nl-feature-title">Cases Reais</h3>
          <p class="nl-feature-desc">Estudos de caso detalhados de empresas que estão inovando e crescendo.</p>
        </div>
        <div class="nl-feature">
          <div class="nl-feature-icon">🔮</div>
          <h3 class="nl-feature-title">Tendências</h3>
          <p class="nl-feature-desc">Fique à frente da concorrência com previsões e análises de para onde o mercado está indo.</p>
        </div>
        <div class="nl-feature">
          <div class="nl-feature-icon">🎁</div>
          <h3 class="nl-feature-title">Recursos Exclusivos</h3>
          <p class="nl-feature-desc">Templates, checklists e ferramentas gratuitas disponíveis apenas para assinantes.</p>
        </div>
      </div>
    </div>
  </section>

  <!-- SAMPLE ISSUE -->
  <section class="nl-sample">
    <div class="nl-container">
      <div class="nl-sample-grid">
        <div class="nl-sample-content">
          <h2>Veja Uma Prévia do Conteúdo</h2>
          <p>Cada edição é cuidadosamente preparada para entregar valor real. Sem enrolação, sem conteúdo de preenchimento.</p>
          <ul class="nl-sample-list">
            <li>
              <span class="nl-sample-check">✓</span>
              Resumo executivo das principais notícias da semana
            </li>
            <li>
              <span class="nl-sample-check">✓</span>
              Uma estratégia detalhada para implementar
            </li>
            <li>
              <span class="nl-sample-check">✓</span>
              Case de sucesso com análise completa
            </li>
            <li>
              <span class="nl-sample-check">✓</span>
              Ferramenta ou recurso recomendado da semana
            </li>
            <li>
              <span class="nl-sample-check">✓</span>
              Dica rápida para aplicar hoje mesmo
            </li>
          </ul>
        </div>
        <div class="nl-sample-preview">
          <div class="nl-sample-header">
            <div class="nl-sample-avatar"></div>
            <div>
              <div class="nl-sample-from">Newsletter Premium</div>
              <div class="nl-sample-subject">Edição #147 • O futuro do trabalho remoto</div>
            </div>
          </div>
          <div class="nl-sample-body">
            <h4>🚀 Esta semana: Como a IA está transformando vendas B2B</h4>
            <p>Empresas que adotaram ferramentas de IA em seus processos de vendas viram um aumento médio de 35% na taxa de conversão. Nesta edição, vamos explorar exatamente quais ferramentas estão gerando esses resultados e como você pode implementá-las...</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- TESTIMONIALS -->
  <section class="nl-testimonials">
    <div class="nl-container">
      <h2 class="nl-section-title">O Que Nossos Leitores Dizem</h2>
      <p class="nl-section-subtitle">Milhares de profissionais já transformaram suas terças-feiras</p>
      <div class="nl-testimonials-grid">
        <div class="nl-testimonial">
          <p class="nl-testimonial-quote">"A única newsletter que eu realmente leio toda semana. Conteúdo relevante e insights que já apliquei várias vezes no meu negócio."</p>
          <div class="nl-testimonial-author">
            <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop" class="nl-testimonial-avatar" alt="Avatar" />
            <div>
              <div class="nl-testimonial-name">Carolina Mendes</div>
              <div class="nl-testimonial-role">CEO, TechStart</div>
            </div>
          </div>
        </div>
        <div class="nl-testimonial">
          <p class="nl-testimonial-quote">"Me sinto mais preparado para as reuniões de diretoria. Os insights desta newsletter me deram argumentos que impressionaram o board."</p>
          <div class="nl-testimonial-author">
            <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop" class="nl-testimonial-avatar" alt="Avatar" />
            <div>
              <div class="nl-testimonial-name">Ricardo Oliveira</div>
              <div class="nl-testimonial-role">Diretor de Marketing</div>
            </div>
          </div>
        </div>
        <div class="nl-testimonial">
          <p class="nl-testimonial-quote">"5 minutos de leitura que valem mais que muitos cursos. Cancelei outras 3 newsletters depois de assinar esta."</p>
          <div class="nl-testimonial-author">
            <img src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop" class="nl-testimonial-avatar" alt="Avatar" />
            <div>
              <div class="nl-testimonial-name">Juliana Costa</div>
              <div class="nl-testimonial-role">Fundadora, AgênciaX</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ARCHIVE -->
  <section class="nl-archive">
    <div class="nl-container">
      <h2 class="nl-section-title">Edições Recentes</h2>
      <p class="nl-section-subtitle">Confira alguns dos temas que já abordamos</p>
      <div class="nl-archive-grid">
        <div class="nl-archive-item">
          <div class="nl-archive-date">
            <span class="nl-archive-day">28</span>
            <span class="nl-archive-month">Jan</span>
          </div>
          <div>
            <div class="nl-archive-title">O Futuro da IA Generativa nos Negócios</div>
            <div class="nl-archive-preview">Como empresas estão usando ChatGPT e similares...</div>
          </div>
        </div>
        <div class="nl-archive-item">
          <div class="nl-archive-date">
            <span class="nl-archive-day">21</span>
            <span class="nl-archive-month">Jan</span>
          </div>
          <div>
            <div class="nl-archive-title">Tendências de E-commerce para 2025</div>
            <div class="nl-archive-preview">As 5 mudanças que vão definir o varejo online...</div>
          </div>
        </div>
        <div class="nl-archive-item">
          <div class="nl-archive-date">
            <span class="nl-archive-day">14</span>
            <span class="nl-archive-month">Jan</span>
          </div>
          <div>
            <div class="nl-archive-title">Como Escalar Sem Perder Qualidade</div>
            <div class="nl-archive-preview">Lições de empresas que triplicaram de tamanho...</div>
          </div>
        </div>
        <div class="nl-archive-item">
          <div class="nl-archive-date">
            <span class="nl-archive-day">07</span>
            <span class="nl-archive-month">Jan</span>
          </div>
          <div>
            <div class="nl-archive-title">Planejamento Estratégico que Funciona</div>
            <div class="nl-archive-preview">Framework usado pelas maiores empresas...</div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- FINAL CTA -->
  <section class="nl-final-cta">
    <h2>Junte-se a 25.000+ Leitores</h2>
    <p>Receba insights valiosos toda terça-feira. Grátis para sempre.</p>
    <form class="nl-final-form" data-success-message="Inscricao confirmada!">
      <input type="email" name="email" class="nl-final-input" placeholder="Seu melhor e-mail" required />
      <button type="submit" class="nl-final-btn">Quero Receber</button>
    </form>
  </section>

  <!-- FOOTER -->
  <footer class="nl-footer">
    <p>© 2025 Newsletter Premium. Todos os direitos reservados.</p>
    <div class="nl-footer-links">
      <a href="#">Política de Privacidade</a>
      <a href="#">Termos de Uso</a>
      <a href="#">Edições Anteriores</a>
      <a href="#">Contato</a>
    </div>
  </footer>
</div>
`,
    gjsCss: '',
    gjsComponents: '',
    gjsStyles: ''
  },

  // ============================================
  // 3. WAITLIST / COMING SOON PRO
  // ============================================
  {
    id: 'waitlist-pro',
    name: 'Waitlist / Em Breve',
    description: 'Página de lista de espera com design minimalista e elegante',
    thumbnail: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&h=300&fit=crop',
    category: 'lead-magnet',
    gjsHtml: `
<style>
  * { box-sizing: border-box; margin: 0; padding: 0; }
  .wl-page { min-height: 100vh; background: linear-gradient(135deg, #0f172a 0%, #1e1b4b 100%); display: flex; flex-direction: column; }
  .wl-header { padding: 24px 40px; display: flex; justify-content: space-between; align-items: center; }
  .wl-logo { font-size: 1.5rem; font-weight: 800; color: white; }
  .wl-status { display: flex; align-items: center; gap: 8px; padding: 8px 16px; background: rgba(34, 197, 94, 0.1); border: 1px solid rgba(34, 197, 94, 0.2); border-radius: 100px; color: #4ade80; font-size: 13px; font-weight: 500; }
  .wl-status-dot { width: 8px; height: 8px; background: #22c55e; border-radius: 50%; }
  .wl-main { flex: 1; display: flex; align-items: center; justify-content: center; padding: 40px; }
  .wl-content { max-width: 600px; text-align: center; }
  .wl-badge { display: inline-block; padding: 8px 20px; background: linear-gradient(135deg, rgba(99, 102, 241, 0.2), rgba(168, 85, 247, 0.2)); border-radius: 100px; color: #a5b4fc; font-size: 14px; font-weight: 600; margin-bottom: 32px; text-transform: uppercase; letter-spacing: 1px; }
  .wl-title { font-size: 4rem; font-weight: 800; color: white; line-height: 1.05; margin-bottom: 24px; letter-spacing: -0.03em; }
  .wl-title span { display: block; background: linear-gradient(135deg, #818cf8, #c084fc); -webkit-background-clip: text; -webkit-text-fill-color: transparent; }
  .wl-desc { font-size: 1.25rem; color: #94a3b8; line-height: 1.7; margin-bottom: 48px; }
  .wl-form { display: flex; gap: 12px; max-width: 480px; margin: 0 auto 24px; }
  .wl-input { flex: 1; padding: 18px 24px; background: rgba(255,255,255,0.05); border: 2px solid rgba(255,255,255,0.1); border-radius: 14px; color: white; font-size: 16px; outline: none; transition: all 0.2s; }
  .wl-input:focus { border-color: #6366f1; background: rgba(255,255,255,0.08); }
  .wl-input::placeholder { color: #64748b; }
  .wl-btn { padding: 18px 36px; background: white; color: #0f172a; font-weight: 700; font-size: 16px; border: none; border-radius: 14px; cursor: pointer; transition: all 0.2s; }
  .wl-btn:hover { transform: scale(1.02); box-shadow: 0 10px 40px rgba(255,255,255,0.2); }
  .wl-counter { display: flex; justify-content: center; gap: 32px; margin-top: 48px; padding-top: 48px; border-top: 1px solid rgba(255,255,255,0.1); }
  .wl-counter-item { text-align: center; }
  .wl-counter-value { font-size: 2.5rem; font-weight: 800; color: white; margin-bottom: 4px; }
  .wl-counter-label { font-size: 14px; color: #64748b; text-transform: uppercase; letter-spacing: 1px; }
  .wl-footer { padding: 24px 40px; text-align: center; color: #475569; font-size: 14px; }
  @media (max-width: 768px) {
    .wl-title { font-size: 2.75rem; }
    .wl-form { flex-direction: column; }
    .wl-counter { gap: 24px; }
    .wl-counter-value { font-size: 2rem; }
    .wl-header { padding: 20px; }
    .wl-main { padding: 24px; }
  }
</style>

<div class="wl-page">
  <header class="wl-header">
    <div class="wl-logo">SuaMarca</div>
    <div class="wl-status">
      <span class="wl-status-dot"></span>
      Em desenvolvimento
    </div>
  </header>

  <main class="wl-main">
    <div class="wl-content">
      <div class="wl-badge">Em breve</div>
      <h1 class="wl-title">
        Algo incrível <span>está chegando</span>
      </h1>
      <p class="wl-desc">
        Estamos trabalhando em algo revolucionário. Entre na lista de espera para ter acesso antecipado e benefícios exclusivos de fundador.
      </p>
      <form class="wl-form" data-success-message="Voce esta na lista! Enviaremos novidades em primeira mao.">
        <input type="email" name="email" class="wl-input" placeholder="Seu melhor e-mail" required />
        <button type="submit" class="wl-btn">Entrar na Lista</button>
      </form>
      <div class="wl-counter">
        <div class="wl-counter-item">
          <div class="wl-counter-value">2.847</div>
          <div class="wl-counter-label">Na lista</div>
        </div>
        <div class="wl-counter-item">
          <div class="wl-counter-value">15</div>
          <div class="wl-counter-label">Dias</div>
        </div>
        <div class="wl-counter-item">
          <div class="wl-counter-value">50%</div>
          <div class="wl-counter-label">Desconto</div>
        </div>
      </div>
    </div>
  </main>

  <footer class="wl-footer">
    © 2025 SuaMarca. Todos os direitos reservados.
  </footer>
</div>
`,
    gjsCss: '',
    gjsComponents: '',
    gjsStyles: ''
  },

  // ============================================
  // 4. COACHING / MENTORIA
  // ============================================
  {
    id: 'coaching-mentoria',
    name: 'Coaching & Mentoria',
    description: 'Página completa para coaches, mentores e consultores com seções de serviços, depoimentos e agendamento',
    thumbnail: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&h=300&fit=crop',
    category: 'agency',
    gjsHtml: `
<style>
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif; }

  /* Container */
  .coach-container { max-width: 1200px; margin: 0 auto; padding: 0 24px; }

  /* Hero */
  .coach-hero { padding: 100px 24px; background: linear-gradient(180deg, #fffbeb 0%, #fef3c7 100%); }
  .coach-hero-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: center; }
  .coach-badge { display: inline-flex; align-items: center; gap: 8px; padding: 10px 20px; background: white; border-radius: 100px; color: #92400e; font-size: 14px; font-weight: 600; margin-bottom: 24px; box-shadow: 0 2px 8px rgba(0,0,0,0.06); }
  .coach-title { font-size: 3.5rem; font-weight: 800; color: #1c1917; line-height: 1.1; margin-bottom: 24px; }
  .coach-title span { color: #d97706; }
  .coach-desc { font-size: 1.2rem; color: #57534e; line-height: 1.7; margin-bottom: 32px; }
  .coach-ctas { display: flex; gap: 16px; flex-wrap: wrap; }
  .coach-btn-primary { padding: 18px 36px; background: #1c1917; color: white; font-weight: 700; font-size: 16px; border: none; border-radius: 12px; cursor: pointer; text-decoration: none; display: inline-flex; align-items: center; gap: 8px; transition: all 0.2s; }
  .coach-btn-primary:hover { transform: translateY(-2px); box-shadow: 0 10px 30px rgba(0,0,0,0.2); }
  .coach-btn-secondary { padding: 18px 36px; background: transparent; color: #1c1917; font-weight: 600; font-size: 16px; border: 2px solid #1c1917; border-radius: 12px; cursor: pointer; text-decoration: none; transition: all 0.2s; }
  .coach-btn-secondary:hover { background: #1c1917; color: white; }
  .coach-image { position: relative; }
  .coach-image img { width: 100%; border-radius: 24px; box-shadow: 0 25px 50px rgba(0,0,0,0.15); }
  .coach-image-badge { position: absolute; bottom: -20px; left: -20px; background: white; padding: 20px 24px; border-radius: 16px; box-shadow: 0 10px 30px rgba(0,0,0,0.1); }
  .coach-image-badge-value { font-size: 2rem; font-weight: 800; color: #d97706; }
  .coach-image-badge-label { font-size: 14px; color: #78716c; }

  /* Stats */
  .coach-stats { padding: 60px 24px; background: white; border-top: 1px solid #f5f5f4; border-bottom: 1px solid #f5f5f4; }
  .coach-stats-grid { display: flex; justify-content: center; align-items: center; gap: 60px; flex-wrap: wrap; }
  .coach-stat { text-align: center; }
  .coach-stat-value { font-size: 2.5rem; font-weight: 800; color: #1c1917; }
  .coach-stat-label { color: #78716c; font-size: 14px; margin-top: 4px; }

  /* Section Common */
  .coach-section { padding: 100px 24px; }
  .coach-section-title { font-size: 2.5rem; font-weight: 800; color: #1c1917; text-align: center; margin-bottom: 16px; }
  .coach-section-subtitle { color: #78716c; text-align: center; font-size: 1.1rem; margin-bottom: 60px; max-width: 600px; margin-left: auto; margin-right: auto; }

  /* Services */
  .coach-services { background: #fafaf9; }
  .coach-services-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 32px; }
  .coach-service { background: white; padding: 40px 32px; border-radius: 20px; box-shadow: 0 4px 20px rgba(0,0,0,0.04); border: 1px solid #f5f5f4; transition: all 0.3s; }
  .coach-service:hover { transform: translateY(-8px); box-shadow: 0 20px 40px rgba(0,0,0,0.1); }
  .coach-service-icon { width: 64px; height: 64px; background: linear-gradient(135deg, #fef3c7, #fde68a); border-radius: 16px; display: flex; align-items: center; justify-content: center; font-size: 28px; margin-bottom: 24px; }
  .coach-service-title { font-size: 1.25rem; font-weight: 700; color: #1c1917; margin-bottom: 12px; }
  .coach-service-desc { color: #78716c; line-height: 1.7; margin-bottom: 20px; }
  .coach-service-price { font-size: 1.5rem; font-weight: 800; color: #d97706; }
  .coach-service-price span { font-size: 14px; font-weight: 500; color: #a8a29e; }

  /* Process */
  .coach-process { background: white; }
  .coach-process-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 40px; }
  .coach-process-step { text-align: center; position: relative; }
  .coach-process-step::after { content: '→'; position: absolute; right: -28px; top: 40px; font-size: 24px; color: #d4d4d4; }
  .coach-process-step:last-child::after { display: none; }
  .coach-process-number { width: 80px; height: 80px; background: linear-gradient(135deg, #d97706, #f59e0b); border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 2rem; font-weight: 800; color: white; margin: 0 auto 24px; }
  .coach-process-title { font-size: 1.1rem; font-weight: 700; color: #1c1917; margin-bottom: 8px; }
  .coach-process-desc { color: #78716c; font-size: 14px; line-height: 1.6; }

  /* About */
  .coach-about { background: #fafaf9; }
  .coach-about-grid { display: grid; grid-template-columns: 1fr 1.5fr; gap: 80px; align-items: center; }
  .coach-about-image { width: 100%; border-radius: 24px; box-shadow: 0 25px 50px rgba(0,0,0,0.1); }
  .coach-about-title { font-size: 2.5rem; font-weight: 800; color: #1c1917; margin-bottom: 24px; text-align: left; }
  .coach-about-text { color: #57534e; line-height: 1.8; margin-bottom: 16px; font-size: 1.1rem; }
  .coach-about-credentials { display: flex; flex-wrap: wrap; gap: 12px; margin-top: 32px; }
  .coach-credential { padding: 10px 20px; background: white; border-radius: 100px; font-size: 14px; font-weight: 600; color: #78716c; border: 1px solid #e7e5e4; }

  /* Testimonials */
  .coach-testimonials { background: white; }
  .coach-testimonials-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 32px; }
  .coach-testimonial { background: #fafaf9; padding: 40px; border-radius: 20px; }
  .coach-testimonial-stars { color: #f59e0b; font-size: 20px; margin-bottom: 20px; }
  .coach-testimonial-quote { color: #44403c; font-size: 1rem; line-height: 1.8; margin-bottom: 24px; font-style: italic; }
  .coach-testimonial-result { background: linear-gradient(135deg, #fef3c7, #fde68a); padding: 16px 20px; border-radius: 12px; margin-bottom: 24px; }
  .coach-testimonial-result-label { font-size: 12px; color: #92400e; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 4px; }
  .coach-testimonial-result-value { font-size: 1.25rem; font-weight: 800; color: #78350f; }
  .coach-testimonial-author { display: flex; align-items: center; gap: 16px; }
  .coach-testimonial-avatar { width: 56px; height: 56px; border-radius: 50%; object-fit: cover; }
  .coach-testimonial-name { font-weight: 700; color: #1c1917; }
  .coach-testimonial-role { color: #78716c; font-size: 14px; }

  /* FAQ */
  .coach-faq { background: #fafaf9; }
  .coach-faq-grid { max-width: 800px; margin: 0 auto; }
  .coach-faq-item { background: white; border-radius: 16px; margin-bottom: 16px; overflow: hidden; }
  .coach-faq-question { padding: 24px 32px; font-size: 1.1rem; font-weight: 600; color: #1c1917; display: flex; justify-content: space-between; align-items: center; cursor: pointer; }
  .coach-faq-question::after { content: '+'; font-size: 24px; color: #d97706; }
  .coach-faq-answer { padding: 0 32px 24px; color: #78716c; line-height: 1.8; }

  /* Contact Form */
  .coach-contact { background: white; }
  .coach-contact-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: start; }
  .coach-contact-info h3 { font-size: 1.5rem; font-weight: 700; color: #1c1917; margin-bottom: 16px; }
  .coach-contact-info p { color: #78716c; line-height: 1.8; margin-bottom: 32px; }
  .coach-contact-item { display: flex; align-items: center; gap: 16px; padding: 16px 0; border-bottom: 1px solid #f5f5f4; }
  .coach-contact-icon { width: 48px; height: 48px; background: #fef3c7; border-radius: 12px; display: flex; align-items: center; justify-content: center; font-size: 20px; }
  .coach-contact-label { font-size: 14px; color: #a8a29e; }
  .coach-contact-value { font-weight: 600; color: #1c1917; }
  .coach-form { background: #fafaf9; padding: 48px; border-radius: 24px; }
  .coach-form-title { font-size: 1.5rem; font-weight: 700; color: #1c1917; margin-bottom: 8px; }
  .coach-form-subtitle { color: #78716c; margin-bottom: 32px; }
  .coach-form-input { width: 100%; padding: 16px 20px; border: 2px solid #e7e5e4; border-radius: 12px; font-size: 1rem; margin-bottom: 16px; outline: none; transition: all 0.2s; }
  .coach-form-input:focus { border-color: #d97706; }
  .coach-form-textarea { min-height: 120px; resize: vertical; }
  .coach-form-btn { width: 100%; padding: 18px; background: #d97706; color: white; font-weight: 700; font-size: 1rem; border: none; border-radius: 12px; cursor: pointer; transition: all 0.2s; }
  .coach-form-btn:hover { background: #b45309; }

  /* Final CTA */
  .coach-final-cta { padding: 100px 24px; background: #1c1917; text-align: center; }
  .coach-final-cta h2 { font-size: 3rem; font-weight: 800; color: white; margin-bottom: 20px; }
  .coach-final-cta p { color: #a8a29e; font-size: 1.25rem; margin-bottom: 40px; max-width: 600px; margin-left: auto; margin-right: auto; }
  .coach-final-btn { padding: 20px 48px; background: #d97706; color: white; font-weight: 700; font-size: 18px; border: none; border-radius: 12px; cursor: pointer; text-decoration: none; display: inline-block; transition: all 0.2s; }
  .coach-final-btn:hover { background: #b45309; transform: translateY(-2px); }

  /* Footer */
  .coach-footer { padding: 60px 24px; background: #0c0a09; text-align: center; }
  .coach-footer p { color: #57534e; font-size: 14px; margin-bottom: 16px; }
  .coach-footer-links { display: flex; justify-content: center; gap: 32px; }
  .coach-footer-links a { color: #78716c; font-size: 14px; text-decoration: none; transition: color 0.2s; }
  .coach-footer-links a:hover { color: white; }

  /* Responsive */
  @media (max-width: 968px) {
    .coach-hero-grid, .coach-about-grid, .coach-contact-grid { grid-template-columns: 1fr; gap: 48px; }
    .coach-title { font-size: 2.5rem; }
    .coach-services-grid, .coach-testimonials-grid { grid-template-columns: 1fr; }
    .coach-process-grid { grid-template-columns: repeat(2, 1fr); }
    .coach-process-step::after { display: none; }
    .coach-stats-grid { gap: 32px; }
    .coach-final-cta h2 { font-size: 2rem; }
  }
</style>

<!-- HERO -->
<section class="coach-hero">
  <div class="coach-container">
    <div class="coach-hero-grid">
      <div>
        <div class="coach-badge">⭐ Mentor de Alta Performance</div>
        <h1 class="coach-title">
          Desbloqueie seu <span>potencial máximo</span> e alcance resultados extraordinários
        </h1>
        <p class="coach-desc">
          Metodologia comprovada que já ajudou mais de 500 profissionais a conquistarem promoções, aumentos e reconhecimento na carreira.
        </p>
        <div class="coach-ctas">
          <a href="#contato" class="coach-btn-primary">Agendar Sessão Gratuita →</a>
          <a href="#metodologia" class="coach-btn-secondary">Conhecer Metodologia</a>
        </div>
      </div>
      <div class="coach-image">
        <img src="https://images.unsplash.com/photo-1560250097-0b93528c311a?w=600&h=700&fit=crop" alt="Coach" />
        <div class="coach-image-badge">
          <div class="coach-image-badge-value">500+</div>
          <div class="coach-image-badge-label">Profissionais transformados</div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- STATS -->
<section class="coach-stats">
  <div class="coach-container">
    <div class="coach-stats-grid">
      <div class="coach-stat">
        <div class="coach-stat-value">98%</div>
        <div class="coach-stat-label">Taxa de satisfação</div>
      </div>
      <div class="coach-stat">
        <div class="coach-stat-value">500+</div>
        <div class="coach-stat-label">Clientes atendidos</div>
      </div>
      <div class="coach-stat">
        <div class="coach-stat-value">15 anos</div>
        <div class="coach-stat-label">De experiência</div>
      </div>
      <div class="coach-stat">
        <div class="coach-stat-value">4.9/5</div>
        <div class="coach-stat-label">Avaliação média</div>
      </div>
    </div>
  </div>
</section>

<!-- SERVICES -->
<section class="coach-section coach-services">
  <div class="coach-container">
    <h2 class="coach-section-title">Programas de Mentoria</h2>
    <p class="coach-section-subtitle">Escolha o programa ideal para o seu momento de carreira</p>
    <div class="coach-services-grid">
      <div class="coach-service">
        <div class="coach-service-icon">🎯</div>
        <h3 class="coach-service-title">Mentoria Individual</h3>
        <p class="coach-service-desc">Sessões personalizadas 1:1 focadas nos seus objetivos específicos. Ideal para quem busca acompanhamento próximo e resultados acelerados.</p>
        <div class="coach-service-price">R$ 997<span>/mês</span></div>
      </div>
      <div class="coach-service">
        <div class="coach-service-icon">👥</div>
        <h3 class="coach-service-title">Mentoria em Grupo</h3>
        <p class="coach-service-desc">Encontros semanais com grupo seleto de profissionais. Networking poderoso + conteúdo exclusivo + suporte contínuo.</p>
        <div class="coach-service-price">R$ 497<span>/mês</span></div>
      </div>
      <div class="coach-service">
        <div class="coach-service-icon">🚀</div>
        <h3 class="coach-service-title">Programa Intensivo</h3>
        <p class="coach-service-desc">Imersão de 90 dias com acompanhamento diário. Para quem precisa de uma transformação profunda e rápida na carreira.</p>
        <div class="coach-service-price">R$ 4.997<span>/único</span></div>
      </div>
    </div>
  </div>
</section>

<!-- PROCESS -->
<section class="coach-section coach-process" id="metodologia">
  <div class="coach-container">
    <h2 class="coach-section-title">Como Funciona</h2>
    <p class="coach-section-subtitle">Uma metodologia estruturada para garantir seus resultados</p>
    <div class="coach-process-grid">
      <div class="coach-process-step">
        <div class="coach-process-number">1</div>
        <h3 class="coach-process-title">Diagnóstico</h3>
        <p class="coach-process-desc">Sessão gratuita para entender seus desafios e objetivos</p>
      </div>
      <div class="coach-process-step">
        <div class="coach-process-number">2</div>
        <h3 class="coach-process-title">Plano Personalizado</h3>
        <p class="coach-process-desc">Estratégia sob medida baseada no seu perfil e metas</p>
      </div>
      <div class="coach-process-step">
        <div class="coach-process-number">3</div>
        <h3 class="coach-process-title">Implementação</h3>
        <p class="coach-process-desc">Sessões práticas com ferramentas e frameworks</p>
      </div>
      <div class="coach-process-step">
        <div class="coach-process-number">4</div>
        <h3 class="coach-process-title">Resultados</h3>
        <p class="coach-process-desc">Acompanhamento de métricas e ajustes contínuos</p>
      </div>
    </div>
  </div>
</section>

<!-- ABOUT -->
<section class="coach-section coach-about">
  <div class="coach-container">
    <div class="coach-about-grid">
      <div>
        <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=500&h=600&fit=crop" alt="About" class="coach-about-image" />
      </div>
      <div>
        <h2 class="coach-about-title">Minha missão é ajudar você a se tornar a melhor versão de si mesmo</h2>
        <p class="coach-about-text">
          Com mais de 15 anos de experiência em desenvolvimento de lideranças em grandes corporações como Google, Nubank e XP Inc., criei uma metodologia única que combina ciência comportamental com estratégias práticas.
        </p>
        <p class="coach-about-text">
          Meus clientes conquistaram promoções, aumentos de até 40% no salário, e principalmente, clareza e confiança para tomar as melhores decisões em suas carreiras.
        </p>
        <p class="coach-about-text">
          Acredito que todo profissional tem um potencial único que, quando desbloqueado corretamente, pode gerar resultados extraordinários.
        </p>
        <div class="coach-about-credentials">
          <span class="coach-credential">📜 ICF Certified Coach</span>
          <span class="coach-credential">🎓 MBA FGV</span>
          <span class="coach-credential">🧠 Master PNL</span>
          <span class="coach-credential">📊 15+ anos experiência</span>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- TESTIMONIALS -->
<section class="coach-section coach-testimonials">
  <div class="coach-container">
    <h2 class="coach-section-title">Histórias de Transformação</h2>
    <p class="coach-section-subtitle">Veja os resultados reais de quem passou pelo programa</p>
    <div class="coach-testimonials-grid">
      <div class="coach-testimonial">
        <div class="coach-testimonial-stars">★★★★★</div>
        <p class="coach-testimonial-quote">"Em 6 meses de mentoria, consegui a promoção para gerente que buscava há 3 anos. A clareza que ganhei sobre meus pontos fortes mudou completamente minha abordagem."</p>
        <div class="coach-testimonial-result">
          <div class="coach-testimonial-result-label">Resultado</div>
          <div class="coach-testimonial-result-value">Promoção para Gerente</div>
        </div>
        <div class="coach-testimonial-author">
          <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop" class="coach-testimonial-avatar" alt="Avatar" />
          <div>
            <div class="coach-testimonial-name">Carolina Mendes</div>
            <div class="coach-testimonial-role">Gerente de Marketing, Nubank</div>
          </div>
        </div>
      </div>
      <div class="coach-testimonial">
        <div class="coach-testimonial-stars">★★★★★</div>
        <p class="coach-testimonial-quote">"O programa intensivo foi divisor de águas. Negociei um aumento de 45% e mudei para uma empresa que sempre sonhei. Investimento que se pagou em menos de 2 meses."</p>
        <div class="coach-testimonial-result">
          <div class="coach-testimonial-result-label">Resultado</div>
          <div class="coach-testimonial-result-value">+45% de aumento salarial</div>
        </div>
        <div class="coach-testimonial-author">
          <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop" class="coach-testimonial-avatar" alt="Avatar" />
          <div>
            <div class="coach-testimonial-name">Ricardo Oliveira</div>
            <div class="coach-testimonial-role">Tech Lead, Google</div>
          </div>
        </div>
      </div>
      <div class="coach-testimonial">
        <div class="coach-testimonial-stars">★★★★★</div>
        <p class="coach-testimonial-quote">"Estava completamente perdida sobre qual rumo tomar na carreira. A mentoria me ajudou a encontrar meu propósito e hoje lidero uma equipe de 20 pessoas."</p>
        <div class="coach-testimonial-result">
          <div class="coach-testimonial-result-label">Resultado</div>
          <div class="coach-testimonial-result-value">De IC para Liderança</div>
        </div>
        <div class="coach-testimonial-author">
          <img src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop" class="coach-testimonial-avatar" alt="Avatar" />
          <div>
            <div class="coach-testimonial-name">Juliana Santos</div>
            <div class="coach-testimonial-role">Head de Produto, iFood</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- FAQ -->
<section class="coach-section coach-faq">
  <div class="coach-container">
    <h2 class="coach-section-title">Perguntas Frequentes</h2>
    <p class="coach-section-subtitle">Tire suas dúvidas sobre o programa de mentoria</p>
    <div class="coach-faq-grid">
      <div class="coach-faq-item">
        <div class="coach-faq-question">Para quem é indicada a mentoria?</div>
        <div class="coach-faq-answer">A mentoria é indicada para profissionais que buscam crescimento acelerado na carreira, seja uma promoção, transição de área, aumento salarial ou desenvolvimento de liderança. Atendo principalmente profissionais com 5+ anos de experiência.</div>
      </div>
      <div class="coach-faq-item">
        <div class="coach-faq-question">Qual a diferença entre coaching e mentoria?</div>
        <div class="coach-faq-answer">No coaching, facilito seu processo de autodescoberta através de perguntas. Na mentoria, além disso, compartilho minha experiência prática, dou conselhos diretos e ensino frameworks específicos. Meu trabalho combina os dois.</div>
      </div>
      <div class="coach-faq-item">
        <div class="coach-faq-question">Em quanto tempo verei resultados?</div>
        <div class="coach-faq-answer">A maioria dos clientes reporta mudanças significativas já no primeiro mês (clareza, confiança, melhores decisões). Resultados tangíveis como promoções e aumentos costumam vir entre 3-6 meses, dependendo do contexto.</div>
      </div>
      <div class="coach-faq-item">
        <div class="coach-faq-question">Como funcionam as sessões?</div>
        <div class="coach-faq-answer">As sessões são online, com 1 hora de duração, e acontecem semanalmente ou quinzenalmente. Além disso, você tem acesso a materiais exclusivos e suporte via WhatsApp para dúvidas entre as sessões.</div>
      </div>
      <div class="coach-faq-item">
        <div class="coach-faq-question">E se eu não gostar?</div>
        <div class="coach-faq-answer">Ofereço garantia de satisfação no primeiro mês. Se você não sentir que está evoluindo, devolvo 100% do investimento. Meu compromisso é com seu resultado.</div>
      </div>
    </div>
  </div>
</section>

<!-- CONTACT -->
<section class="coach-section coach-contact" id="contato">
  <div class="coach-container">
    <h2 class="coach-section-title">Agende Sua Sessão Gratuita</h2>
    <p class="coach-section-subtitle">30 minutos para entender seus desafios e ver se posso te ajudar</p>
    <div class="coach-contact-grid">
      <div class="coach-contact-info">
        <h3>Vamos conversar?</h3>
        <p>Preencha o formulário ao lado e entrarei em contato em até 24 horas para agendarmos sua sessão de diagnóstico gratuita.</p>
        <div class="coach-contact-item">
          <div class="coach-contact-icon">📧</div>
          <div>
            <div class="coach-contact-label">E-mail</div>
            <div class="coach-contact-value">contato@seucoach.com</div>
          </div>
        </div>
        <div class="coach-contact-item">
          <div class="coach-contact-icon">📱</div>
          <div>
            <div class="coach-contact-label">WhatsApp</div>
            <div class="coach-contact-value">(11) 99999-9999</div>
          </div>
        </div>
        <div class="coach-contact-item">
          <div class="coach-contact-icon">📍</div>
          <div>
            <div class="coach-contact-label">Atendimento</div>
            <div class="coach-contact-value">100% Online</div>
          </div>
        </div>
      </div>
      <div class="coach-form">
        <h3 class="coach-form-title">Solicite Sua Sessão</h3>
        <p class="coach-form-subtitle">Sem compromisso. Totalmente gratuita.</p>
        <form data-success-message="Solicitacao enviada! Entraremos em contato em ate 24h.">
          <input type="text" name="name" class="coach-form-input" placeholder="Seu nome completo" required />
          <input type="email" name="email" class="coach-form-input" placeholder="Seu melhor e-mail" required />
          <input type="tel" name="phone" class="coach-form-input" placeholder="WhatsApp" required />
          <input type="text" name="position" class="coach-form-input" placeholder="Cargo atual" />
          <textarea name="message" class="coach-form-input coach-form-textarea" placeholder="Qual seu maior desafio na carreira hoje?"></textarea>
          <button type="submit" class="coach-form-btn">Quero Minha Sessão Gratuita →</button>
        </form>
      </div>
    </div>
  </div>
</section>

<!-- FINAL CTA -->
<section class="coach-final-cta">
  <div class="coach-container">
    <h2>Pronto para transformar sua carreira?</h2>
    <p>Junte-se a mais de 500 profissionais que já alcançaram resultados extraordinários com a mentoria.</p>
    <a href="#contato" class="coach-final-btn">Agendar Sessão Gratuita</a>
  </div>
</section>

<!-- FOOTER -->
<footer class="coach-footer">
  <div class="coach-container">
    <p>© 2025 Seu Nome Coach. Todos os direitos reservados.</p>
    <div class="coach-footer-links">
      <a href="#">Política de Privacidade</a>
      <a href="#">Termos de Uso</a>
      <a href="#">Instagram</a>
      <a href="#">LinkedIn</a>
    </div>
  </div>
</footer>
`,
    gjsCss: '',
    gjsComponents: '',
    gjsStyles: ''
  },

  // ============================================
  // 5. SAAS MINIMALISTA
  // ============================================
  {
    id: 'saas-minimal',
    name: 'SaaS Minimalista',
    description: 'Landing page completa para produtos SaaS com pricing, depoimentos e FAQ',
    thumbnail: 'https://images.unsplash.com/photo-1551434678-e076c223a692?w=400&h=300&fit=crop',
    category: 'saas',
    gjsHtml: `
<style>
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif; }
  .sm-container { max-width: 1200px; margin: 0 auto; padding: 0 24px; }

  /* Nav */
  .sm-nav { padding: 20px 40px; display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #f1f5f9; background: white; position: sticky; top: 0; z-index: 100; }
  .sm-logo { font-size: 1.5rem; font-weight: 800; color: #0f172a; }
  .sm-nav-links { display: flex; gap: 32px; align-items: center; }
  .sm-nav-link { color: #64748b; text-decoration: none; font-size: 15px; font-weight: 500; transition: color 0.2s; }
  .sm-nav-link:hover { color: #0f172a; }
  .sm-nav-btn { padding: 10px 20px; background: #0f172a; color: white; border-radius: 8px; text-decoration: none; font-weight: 600; font-size: 14px; transition: all 0.2s; }
  .sm-nav-btn:hover { background: #1e293b; }

  /* Hero */
  .sm-hero { padding: 100px 24px 80px; text-align: center; background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%); }
  .sm-badge { display: inline-flex; align-items: center; gap: 8px; padding: 8px 16px; background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 100px; color: #15803d; font-size: 13px; font-weight: 600; margin-bottom: 32px; }
  .sm-title { font-size: 4rem; font-weight: 800; color: #0f172a; line-height: 1.05; margin-bottom: 24px; letter-spacing: -0.03em; }
  .sm-desc { font-size: 1.25rem; color: #64748b; line-height: 1.7; margin-bottom: 48px; max-width: 600px; margin-left: auto; margin-right: auto; }
  .sm-ctas { display: flex; gap: 16px; justify-content: center; margin-bottom: 48px; }
  .sm-btn-primary { padding: 16px 32px; background: #0f172a; color: white; font-weight: 700; font-size: 16px; border: none; border-radius: 10px; cursor: pointer; text-decoration: none; transition: all 0.2s; }
  .sm-btn-primary:hover { transform: translateY(-2px); box-shadow: 0 10px 30px rgba(0,0,0,0.15); }
  .sm-btn-secondary { padding: 16px 32px; background: white; color: #0f172a; font-weight: 600; font-size: 16px; border: 1px solid #e2e8f0; border-radius: 10px; cursor: pointer; text-decoration: none; display: inline-flex; align-items: center; gap: 8px; transition: all 0.2s; }
  .sm-btn-secondary:hover { border-color: #cbd5e1; }
  .sm-demo img { width: 100%; max-width: 1000px; margin: 0 auto; display: block; border-radius: 16px; box-shadow: 0 25px 80px rgba(0,0,0,0.15); border: 1px solid #e2e8f0; }

  /* Logos */
  .sm-logos { padding: 60px 24px; background: white; border-bottom: 1px solid #f1f5f9; }
  .sm-logos-title { text-align: center; color: #94a3b8; font-size: 14px; margin-bottom: 32px; }
  .sm-logos-grid { display: flex; justify-content: center; align-items: center; gap: 60px; flex-wrap: wrap; opacity: 0.5; }
  .sm-logo-item { font-size: 24px; font-weight: 700; color: #64748b; }

  /* Features */
  .sm-section { padding: 100px 24px; }
  .sm-section-header { text-align: center; margin-bottom: 60px; }
  .sm-section-label { color: #6366f1; font-weight: 600; font-size: 14px; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 12px; }
  .sm-section-title { font-size: 2.5rem; font-weight: 800; color: #0f172a; margin-bottom: 16px; }
  .sm-section-subtitle { color: #64748b; font-size: 1.1rem; max-width: 600px; margin: 0 auto; }
  .sm-features { background: white; }
  .sm-features-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 32px; }
  .sm-feature { padding: 40px; background: #f8fafc; border-radius: 20px; transition: all 0.3s; }
  .sm-feature:hover { transform: translateY(-4px); box-shadow: 0 20px 40px rgba(0,0,0,0.08); }
  .sm-feature-icon { width: 56px; height: 56px; background: white; border-radius: 14px; display: flex; align-items: center; justify-content: center; font-size: 24px; margin-bottom: 24px; box-shadow: 0 4px 12px rgba(0,0,0,0.06); }
  .sm-feature-title { font-size: 1.25rem; font-weight: 700; color: #0f172a; margin-bottom: 12px; }
  .sm-feature-desc { color: #64748b; line-height: 1.7; }

  /* How it works */
  .sm-how { background: #f8fafc; }
  .sm-how-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 40px; }
  .sm-how-step { text-align: center; }
  .sm-how-number { width: 64px; height: 64px; background: #0f172a; color: white; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 1.5rem; font-weight: 800; margin: 0 auto 24px; }
  .sm-how-title { font-size: 1.1rem; font-weight: 700; color: #0f172a; margin-bottom: 8px; }
  .sm-how-desc { color: #64748b; font-size: 14px; line-height: 1.6; }

  /* Pricing */
  .sm-pricing { background: white; }
  .sm-pricing-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 32px; max-width: 1000px; margin: 0 auto; }
  .sm-pricing-card { background: #f8fafc; border-radius: 24px; padding: 40px; border: 2px solid transparent; transition: all 0.3s; }
  .sm-pricing-card.popular { background: #0f172a; border-color: #6366f1; transform: scale(1.05); }
  .sm-pricing-card.popular * { color: white; }
  .sm-pricing-card.popular .sm-pricing-feature { color: #94a3b8; }
  .sm-pricing-badge { display: inline-block; padding: 6px 12px; background: #6366f1; color: white; border-radius: 100px; font-size: 12px; font-weight: 600; margin-bottom: 16px; }
  .sm-pricing-name { font-size: 1.25rem; font-weight: 700; color: #0f172a; margin-bottom: 8px; }
  .sm-pricing-desc { color: #64748b; font-size: 14px; margin-bottom: 24px; }
  .sm-pricing-price { font-size: 3rem; font-weight: 800; color: #0f172a; margin-bottom: 8px; }
  .sm-pricing-price span { font-size: 1rem; font-weight: 500; color: #64748b; }
  .sm-pricing-period { color: #94a3b8; font-size: 14px; margin-bottom: 32px; }
  .sm-pricing-btn { width: 100%; padding: 14px; background: #0f172a; color: white; font-weight: 600; border: none; border-radius: 10px; cursor: pointer; margin-bottom: 32px; transition: all 0.2s; }
  .sm-pricing-card.popular .sm-pricing-btn { background: white; color: #0f172a; }
  .sm-pricing-features { list-style: none; }
  .sm-pricing-feature { display: flex; align-items: center; gap: 12px; padding: 12px 0; color: #64748b; font-size: 14px; }

  /* Testimonials */
  .sm-testimonials { background: #f8fafc; }
  .sm-testimonials-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 32px; }
  .sm-testimonial { background: white; padding: 32px; border-radius: 20px; box-shadow: 0 4px 20px rgba(0,0,0,0.04); }
  .sm-testimonial-stars { color: #fbbf24; font-size: 18px; margin-bottom: 16px; }
  .sm-testimonial-quote { color: #334155; line-height: 1.8; margin-bottom: 24px; }
  .sm-testimonial-author { display: flex; align-items: center; gap: 16px; }
  .sm-testimonial-avatar { width: 48px; height: 48px; border-radius: 50%; object-fit: cover; }
  .sm-testimonial-name { font-weight: 600; color: #0f172a; }
  .sm-testimonial-role { color: #64748b; font-size: 14px; }

  /* FAQ */
  .sm-faq { background: white; }
  .sm-faq-grid { max-width: 700px; margin: 0 auto; }
  .sm-faq-item { border-bottom: 1px solid #e2e8f0; }
  .sm-faq-question { padding: 24px 0; font-size: 1.1rem; font-weight: 600; color: #0f172a; cursor: pointer; display: flex; justify-content: space-between; align-items: center; }
  .sm-faq-question::after { content: '+'; font-size: 24px; color: #6366f1; }
  .sm-faq-answer { padding-bottom: 24px; color: #64748b; line-height: 1.8; }

  /* CTA */
  .sm-cta { padding: 100px 24px; background: #0f172a; text-align: center; }
  .sm-cta h2 { font-size: 3rem; font-weight: 800; color: white; margin-bottom: 16px; }
  .sm-cta p { color: #94a3b8; font-size: 1.25rem; margin-bottom: 40px; }
  .sm-cta-btn { padding: 18px 40px; background: white; color: #0f172a; font-weight: 700; font-size: 16px; border: none; border-radius: 10px; cursor: pointer; text-decoration: none; transition: all 0.2s; display: inline-block; }
  .sm-cta-btn:hover { transform: scale(1.05); }

  /* Footer */
  .sm-footer { padding: 60px 24px; background: #0f172a; border-top: 1px solid #1e293b; }
  .sm-footer-grid { display: grid; grid-template-columns: 2fr 1fr 1fr 1fr; gap: 60px; margin-bottom: 60px; }
  .sm-footer-brand { color: white; font-size: 1.5rem; font-weight: 800; margin-bottom: 16px; }
  .sm-footer-desc { color: #64748b; line-height: 1.7; }
  .sm-footer-title { color: white; font-weight: 600; margin-bottom: 20px; }
  .sm-footer-links { list-style: none; }
  .sm-footer-links li { margin-bottom: 12px; }
  .sm-footer-links a { color: #64748b; text-decoration: none; font-size: 14px; transition: color 0.2s; }
  .sm-footer-links a:hover { color: white; }
  .sm-footer-bottom { padding-top: 32px; border-top: 1px solid #1e293b; display: flex; justify-content: space-between; align-items: center; }
  .sm-footer-copy { color: #64748b; font-size: 14px; }

  /* Responsive */
  @media (max-width: 968px) {
    .sm-title { font-size: 2.5rem; }
    .sm-features-grid, .sm-testimonials-grid { grid-template-columns: 1fr; }
    .sm-pricing-grid { grid-template-columns: 1fr; }
    .sm-pricing-card.popular { transform: none; }
    .sm-how-grid { grid-template-columns: repeat(2, 1fr); }
    .sm-nav-links { display: none; }
    .sm-ctas { flex-direction: column; align-items: center; }
    .sm-footer-grid { grid-template-columns: 1fr; gap: 40px; }
    .sm-cta h2 { font-size: 2rem; }
  }
</style>

<!-- NAV -->
<nav class="sm-nav">
  <div class="sm-logo">Acme</div>
  <div class="sm-nav-links">
    <a href="#features" class="sm-nav-link">Recursos</a>
    <a href="#pricing" class="sm-nav-link">Preços</a>
    <a href="#faq" class="sm-nav-link">FAQ</a>
    <a href="#" class="sm-nav-btn">Começar Grátis</a>
  </div>
</nav>

<!-- HERO -->
<section class="sm-hero">
  <div class="sm-container">
    <div class="sm-badge">✨ Versão 3.0 lançada</div>
    <h1 class="sm-title">A maneira mais simples de gerenciar seu negócio</h1>
    <p class="sm-desc">
      Automatize processos, acompanhe métricas e escale sua operação com a plataforma mais intuitiva do mercado.
    </p>
    <div class="sm-ctas">
      <a href="#" class="sm-btn-primary">Começar gratuitamente →</a>
      <a href="#" class="sm-btn-secondary">
        <span>▶</span> Ver demo
      </a>
    </div>
    <div class="sm-demo">
      <img src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&h=700&fit=crop" alt="Dashboard" />
    </div>
  </div>
</section>

<!-- LOGOS -->
<section class="sm-logos">
  <div class="sm-container">
    <p class="sm-logos-title">Usado por mais de 10.000 empresas</p>
    <div class="sm-logos-grid">
      <span class="sm-logo-item">Google</span>
      <span class="sm-logo-item">Microsoft</span>
      <span class="sm-logo-item">Spotify</span>
      <span class="sm-logo-item">Slack</span>
      <span class="sm-logo-item">Airbnb</span>
    </div>
  </div>
</section>

<!-- FEATURES -->
<section class="sm-section sm-features" id="features">
  <div class="sm-container">
    <div class="sm-section-header">
      <div class="sm-section-label">Recursos</div>
      <h2 class="sm-section-title">Tudo que você precisa, nada que não precisa</h2>
      <p class="sm-section-subtitle">Ferramentas poderosas com interface simples para você focar no que importa</p>
    </div>
    <div class="sm-features-grid">
      <div class="sm-feature">
        <div class="sm-feature-icon">📊</div>
        <h3 class="sm-feature-title">Analytics em Tempo Real</h3>
        <p class="sm-feature-desc">Acompanhe todas as métricas do seu negócio em dashboards atualizados em tempo real.</p>
      </div>
      <div class="sm-feature">
        <div class="sm-feature-icon">⚡</div>
        <h3 class="sm-feature-title">Automações Inteligentes</h3>
        <p class="sm-feature-desc">Automatize tarefas repetitivas e foque no que realmente importa para crescer.</p>
      </div>
      <div class="sm-feature">
        <div class="sm-feature-icon">🔗</div>
        <h3 class="sm-feature-title">+100 Integrações</h3>
        <p class="sm-feature-desc">Conecte com todas as ferramentas que você já usa no dia a dia.</p>
      </div>
      <div class="sm-feature">
        <div class="sm-feature-icon">🔒</div>
        <h3 class="sm-feature-title">Segurança Enterprise</h3>
        <p class="sm-feature-desc">Seus dados protegidos com criptografia de ponta e compliance LGPD.</p>
      </div>
      <div class="sm-feature">
        <div class="sm-feature-icon">📱</div>
        <h3 class="sm-feature-title">App Mobile</h3>
        <p class="sm-feature-desc">Acesse de qualquer lugar com nossos apps para iOS e Android.</p>
      </div>
      <div class="sm-feature">
        <div class="sm-feature-icon">💬</div>
        <h3 class="sm-feature-title">Suporte 24/7</h3>
        <p class="sm-feature-desc">Equipe dedicada para te ajudar quando você precisar.</p>
      </div>
    </div>
  </div>
</section>

<!-- HOW IT WORKS -->
<section class="sm-section sm-how">
  <div class="sm-container">
    <div class="sm-section-header">
      <div class="sm-section-label">Como Funciona</div>
      <h2 class="sm-section-title">Comece em menos de 5 minutos</h2>
    </div>
    <div class="sm-how-grid">
      <div class="sm-how-step">
        <div class="sm-how-number">1</div>
        <h3 class="sm-how-title">Crie sua conta</h3>
        <p class="sm-how-desc">Cadastro rápido e sem cartão de crédito</p>
      </div>
      <div class="sm-how-step">
        <div class="sm-how-number">2</div>
        <h3 class="sm-how-title">Configure</h3>
        <p class="sm-how-desc">Personalize para seu negócio em minutos</p>
      </div>
      <div class="sm-how-step">
        <div class="sm-how-number">3</div>
        <h3 class="sm-how-title">Integre</h3>
        <p class="sm-how-desc">Conecte suas ferramentas favoritas</p>
      </div>
      <div class="sm-how-step">
        <div class="sm-how-number">4</div>
        <h3 class="sm-how-title">Escale</h3>
        <p class="sm-how-desc">Veja seus resultados crescerem</p>
      </div>
    </div>
  </div>
</section>

<!-- PRICING -->
<section class="sm-section sm-pricing" id="pricing">
  <div class="sm-container">
    <div class="sm-section-header">
      <div class="sm-section-label">Preços</div>
      <h2 class="sm-section-title">Planos para cada momento do seu negócio</h2>
      <p class="sm-section-subtitle">Comece grátis e escale conforme você cresce</p>
    </div>
    <div class="sm-pricing-grid">
      <div class="sm-pricing-card">
        <h3 class="sm-pricing-name">Starter</h3>
        <p class="sm-pricing-desc">Para quem está começando</p>
        <div class="sm-pricing-price">Grátis</div>
        <p class="sm-pricing-period">Para sempre</p>
        <button class="sm-pricing-btn">Começar grátis</button>
        <ul class="sm-pricing-features">
          <li class="sm-pricing-feature">✓ Até 100 contatos</li>
          <li class="sm-pricing-feature">✓ 1 usuário</li>
          <li class="sm-pricing-feature">✓ Dashboard básico</li>
          <li class="sm-pricing-feature">✓ Suporte por email</li>
        </ul>
      </div>
      <div class="sm-pricing-card popular">
        <span class="sm-pricing-badge">Mais Popular</span>
        <h3 class="sm-pricing-name">Pro</h3>
        <p class="sm-pricing-desc">Para negócios em crescimento</p>
        <div class="sm-pricing-price">R$97<span>/mês</span></div>
        <p class="sm-pricing-period">Cobrado mensalmente</p>
        <button class="sm-pricing-btn">Começar teste grátis</button>
        <ul class="sm-pricing-features">
          <li class="sm-pricing-feature">✓ Contatos ilimitados</li>
          <li class="sm-pricing-feature">✓ 5 usuários</li>
          <li class="sm-pricing-feature">✓ Automações avançadas</li>
          <li class="sm-pricing-feature">✓ Integrações premium</li>
          <li class="sm-pricing-feature">✓ Suporte prioritário</li>
        </ul>
      </div>
      <div class="sm-pricing-card">
        <h3 class="sm-pricing-name">Enterprise</h3>
        <p class="sm-pricing-desc">Para grandes operações</p>
        <div class="sm-pricing-price">Sob consulta</div>
        <p class="sm-pricing-period">Personalizado</p>
        <button class="sm-pricing-btn">Falar com vendas</button>
        <ul class="sm-pricing-features">
          <li class="sm-pricing-feature">✓ Tudo do Pro</li>
          <li class="sm-pricing-feature">✓ Usuários ilimitados</li>
          <li class="sm-pricing-feature">✓ API dedicada</li>
          <li class="sm-pricing-feature">✓ SLA garantido</li>
          <li class="sm-pricing-feature">✓ Gerente de conta</li>
        </ul>
      </div>
    </div>
  </div>
</section>

<!-- TESTIMONIALS -->
<section class="sm-section sm-testimonials">
  <div class="sm-container">
    <div class="sm-section-header">
      <div class="sm-section-label">Depoimentos</div>
      <h2 class="sm-section-title">O que nossos clientes dizem</h2>
    </div>
    <div class="sm-testimonials-grid">
      <div class="sm-testimonial">
        <div class="sm-testimonial-stars">★★★★★</div>
        <p class="sm-testimonial-quote">"Reduzimos o tempo gasto em tarefas manuais em 70%. A equipe finalmente pode focar no que realmente importa."</p>
        <div class="sm-testimonial-author">
          <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop" class="sm-testimonial-avatar" alt="Avatar" />
          <div>
            <div class="sm-testimonial-name">Carolina Mendes</div>
            <div class="sm-testimonial-role">CEO, TechStart</div>
          </div>
        </div>
      </div>
      <div class="sm-testimonial">
        <div class="sm-testimonial-stars">★★★★★</div>
        <p class="sm-testimonial-quote">"A melhor decisão que tomamos foi migrar para o Acme. ROI positivo em menos de 3 meses."</p>
        <div class="sm-testimonial-author">
          <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop" class="sm-testimonial-avatar" alt="Avatar" />
          <div>
            <div class="sm-testimonial-name">Ricardo Oliveira</div>
            <div class="sm-testimonial-role">COO, GrowthCo</div>
          </div>
        </div>
      </div>
      <div class="sm-testimonial">
        <div class="sm-testimonial-stars">★★★★★</div>
        <p class="sm-testimonial-quote">"O suporte é incrível. Qualquer dúvida é resolvida em minutos. Recomendo muito!"</p>
        <div class="sm-testimonial-author">
          <img src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop" class="sm-testimonial-avatar" alt="Avatar" />
          <div>
            <div class="sm-testimonial-name">Juliana Costa</div>
            <div class="sm-testimonial-role">Head de Marketing</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- FAQ -->
<section class="sm-section sm-faq" id="faq">
  <div class="sm-container">
    <div class="sm-section-header">
      <div class="sm-section-label">FAQ</div>
      <h2 class="sm-section-title">Perguntas Frequentes</h2>
    </div>
    <div class="sm-faq-grid">
      <div class="sm-faq-item">
        <div class="sm-faq-question">Posso testar antes de assinar?</div>
        <div class="sm-faq-answer">Sim! Oferecemos 7 dias de teste grátis em todos os planos pagos. Não pedimos cartão de crédito para começar.</div>
      </div>
      <div class="sm-faq-item">
        <div class="sm-faq-question">Posso cancelar a qualquer momento?</div>
        <div class="sm-faq-answer">Absolutamente. Sem multas, sem burocracia. Você pode cancelar direto pelo painel.</div>
      </div>
      <div class="sm-faq-item">
        <div class="sm-faq-question">Meus dados estão seguros?</div>
        <div class="sm-faq-answer">Usamos criptografia de ponta a ponta e somos compliance com LGPD. Seus dados nunca são compartilhados.</div>
      </div>
      <div class="sm-faq-item">
        <div class="sm-faq-question">Vocês oferecem suporte em português?</div>
        <div class="sm-faq-answer">Sim! Nossa equipe de suporte é 100% brasileira e está disponível 24/7 para te ajudar.</div>
      </div>
      <div class="sm-faq-item">
        <div class="sm-faq-question">Consigo importar dados de outra ferramenta?</div>
        <div class="sm-faq-answer">Sim! Temos importadores prontos para as principais ferramentas do mercado. Nossa equipe também pode ajudar na migração.</div>
      </div>
    </div>
  </div>
</section>

<!-- CTA -->
<section class="sm-cta">
  <div class="sm-container">
    <h2>Pronto para transformar seu negócio?</h2>
    <p>Junte-se a mais de 10.000 empresas que já estão crescendo com o Acme</p>
    <a href="#" class="sm-cta-btn">Começar gratuitamente →</a>
  </div>
</section>

<!-- FOOTER -->
<footer class="sm-footer">
  <div class="sm-container">
    <div class="sm-footer-grid">
      <div>
        <div class="sm-footer-brand">Acme</div>
        <p class="sm-footer-desc">A plataforma mais simples para gerenciar e escalar seu negócio.</p>
      </div>
      <div>
        <h4 class="sm-footer-title">Produto</h4>
        <ul class="sm-footer-links">
          <li><a href="#">Recursos</a></li>
          <li><a href="#">Preços</a></li>
          <li><a href="#">Integrações</a></li>
          <li><a href="#">API</a></li>
        </ul>
      </div>
      <div>
        <h4 class="sm-footer-title">Empresa</h4>
        <ul class="sm-footer-links">
          <li><a href="#">Sobre</a></li>
          <li><a href="#">Blog</a></li>
          <li><a href="#">Carreiras</a></li>
          <li><a href="#">Contato</a></li>
        </ul>
      </div>
      <div>
        <h4 class="sm-footer-title">Legal</h4>
        <ul class="sm-footer-links">
          <li><a href="#">Privacidade</a></li>
          <li><a href="#">Termos</a></li>
          <li><a href="#">LGPD</a></li>
        </ul>
      </div>
    </div>
    <div class="sm-footer-bottom">
      <p class="sm-footer-copy">© 2025 Acme. Todos os direitos reservados.</p>
    </div>
  </div>
</footer>
`,
    gjsCss: '',
    gjsComponents: '',
    gjsStyles: ''
  },

  // ============================================
  // 6. WEBINAR PRO
  // ============================================
  {
    id: 'webinar-pro',
    name: 'Webinar Profissional',
    description: 'Página de inscrição para webinars e eventos com urgência',
    thumbnail: 'https://images.unsplash.com/photo-1591115765373-5207764f72e7?w=400&h=300&fit=crop',
    category: 'webinar',
    gjsHtml: `
<style>
  * { box-sizing: border-box; margin: 0; padding: 0; }
  .wb-page { background: #0f0f23; min-height: 100vh; }
  .wb-hero { padding: 60px 24px; }
  .wb-container { max-width: 1100px; margin: 0 auto; }
  .wb-grid { display: grid; grid-template-columns: 1.2fr 1fr; gap: 60px; align-items: start; }
  .wb-live { display: inline-flex; align-items: center; gap: 10px; padding: 10px 20px; background: rgba(239, 68, 68, 0.15); border: 1px solid rgba(239, 68, 68, 0.3); border-radius: 100px; margin-bottom: 24px; }
  .wb-live-dot { width: 10px; height: 10px; background: #ef4444; border-radius: 50%; animation: pulse 1.5s infinite; }
  @keyframes pulse { 0%, 100% { opacity: 1; transform: scale(1); } 50% { opacity: 0.7; transform: scale(1.1); } }
  .wb-live-text { color: #fca5a5; font-weight: 600; font-size: 14px; text-transform: uppercase; letter-spacing: 1px; }
  .wb-title { font-size: 2.75rem; font-weight: 800; color: white; line-height: 1.15; margin-bottom: 20px; }
  .wb-title span { color: #fbbf24; }
  .wb-desc { color: #a1a1aa; font-size: 1.15rem; line-height: 1.7; margin-bottom: 32px; }
  .wb-host { display: flex; align-items: center; gap: 16px; padding: 24px; background: rgba(255,255,255,0.05); border-radius: 16px; margin-bottom: 32px; }
  .wb-host-img { width: 64px; height: 64px; border-radius: 50%; object-fit: cover; }
  .wb-host-name { color: white; font-weight: 700; font-size: 1.1rem; }
  .wb-host-role { color: #71717a; font-size: 14px; }
  .wb-topics { margin-bottom: 32px; }
  .wb-topics-title { color: white; font-weight: 600; margin-bottom: 16px; }
  .wb-topics-list { list-style: none; }
  .wb-topics-list li { display: flex; align-items: center; gap: 12px; padding: 12px 0; color: #d4d4d8; border-bottom: 1px solid rgba(255,255,255,0.05); }
  .wb-topics-list li:last-child { border: none; }
  .wb-check { color: #22c55e; }
  .wb-form-card { background: white; padding: 40px; border-radius: 24px; position: sticky; top: 40px; }
  .wb-form-header { text-align: center; margin-bottom: 32px; }
  .wb-form-badge { display: inline-block; padding: 8px 16px; background: #fef3c7; color: #92400e; border-radius: 8px; font-size: 13px; font-weight: 700; margin-bottom: 16px; }
  .wb-form-title { font-size: 1.5rem; font-weight: 800; color: #0f172a; margin-bottom: 8px; }
  .wb-form-date { color: #64748b; font-size: 15px; }
  .wb-countdown { display: flex; justify-content: center; gap: 16px; margin-bottom: 32px; }
  .wb-countdown-item { text-align: center; }
  .wb-countdown-value { width: 56px; height: 56px; background: #0f172a; color: white; border-radius: 12px; display: flex; align-items: center; justify-content: center; font-size: 1.5rem; font-weight: 800; }
  .wb-countdown-label { font-size: 12px; color: #64748b; margin-top: 8px; text-transform: uppercase; }
  .wb-input { width: 100%; padding: 16px 20px; border: 2px solid #e5e7eb; border-radius: 12px; font-size: 16px; margin-bottom: 16px; outline: none; transition: border-color 0.2s; }
  .wb-input:focus { border-color: #6366f1; }
  .wb-btn { width: 100%; padding: 18px; background: linear-gradient(135deg, #ef4444, #dc2626); color: white; font-weight: 700; font-size: 1.1rem; border: none; border-radius: 12px; cursor: pointer; }
  .wb-spots { text-align: center; margin-top: 16px; color: #ef4444; font-size: 14px; font-weight: 600; }
  @media (max-width: 968px) {
    .wb-grid { grid-template-columns: 1fr; }
    .wb-title { font-size: 2rem; }
    .wb-form-card { position: static; }
  }
</style>

<div class="wb-page">
  <section class="wb-hero">
    <div class="wb-container">
      <div class="wb-grid">
        <div>
          <div class="wb-live">
            <span class="wb-live-dot"></span>
            <span class="wb-live-text">Evento ao vivo</span>
          </div>
          <h1 class="wb-title">Como Criar um Negócio de <span>6 Dígitos</span> do Zero em 2025</h1>
          <p class="wb-desc">
            Descubra o método passo a passo que usei para sair do zero e faturar mais de R$100.000 mensais. Vou revelar tudo nesta masterclass exclusiva.
          </p>
          <div class="wb-host">
            <img src="https://images.unsplash.com/photo-1560250097-0b93528c311a?w=150&h=150&fit=crop" class="wb-host-img" alt="Host" />
            <div>
              <div class="wb-host-name">João Silva</div>
              <div class="wb-host-role">Empreendedor Serial • +R$10M faturados</div>
            </div>
          </div>
          <div class="wb-topics">
            <div class="wb-topics-title">O que você vai aprender:</div>
            <ul class="wb-topics-list">
              <li><span class="wb-check">✓</span> Os 3 pilares de um negócio lucrativo</li>
              <li><span class="wb-check">✓</span> Como validar uma ideia em 7 dias</li>
              <li><span class="wb-check">✓</span> Estratégias de vendas que funcionam em qualquer nicho</li>
              <li><span class="wb-check">✓</span> Como escalar sem queimar dinheiro</li>
            </ul>
          </div>
        </div>
        <div>
          <div class="wb-form-card">
            <div class="wb-form-header">
              <div class="wb-form-badge">🎁 GRATUITO</div>
              <h2 class="wb-form-title">Reserve sua vaga agora</h2>
              <p class="wb-form-date">Terça, 15 de Janeiro • 20h (Brasília)</p>
            </div>
            <div class="wb-countdown">
              <div class="wb-countdown-item">
                <div class="wb-countdown-value">02</div>
                <div class="wb-countdown-label">Dias</div>
              </div>
              <div class="wb-countdown-item">
                <div class="wb-countdown-value">14</div>
                <div class="wb-countdown-label">Horas</div>
              </div>
              <div class="wb-countdown-item">
                <div class="wb-countdown-value">37</div>
                <div class="wb-countdown-label">Min</div>
              </div>
            </div>
            <form data-success-message="Inscricao confirmada! Enviamos os detalhes para seu e-mail.">
              <input type="text" name="name" class="wb-input" placeholder="Seu nome completo" required />
              <input type="email" name="email" class="wb-input" placeholder="Seu melhor e-mail" required />
              <input type="tel" name="phone" class="wb-input" placeholder="WhatsApp com DDD" required />
              <button type="submit" class="wb-btn">GARANTIR MINHA VAGA →</button>
            </form>
            <p class="wb-spots">⚠️ Apenas 147 vagas disponíveis</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
`,
    gjsCss: '',
    gjsComponents: '',
    gjsStyles: ''
  },

  // ============================================
  // 7. RESTAURANTE / FOOD
  // ============================================
  {
    id: 'restaurant-food',
    name: 'Restaurante & Food',
    description: 'Landing page completa para restaurantes com cardápio, reservas, delivery e avaliações',
    thumbnail: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=400&h=300&fit=crop',
    category: 'ecommerce',
    gjsHtml: `
<style>
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { font-family: 'Inter', -apple-system, sans-serif; }
  .rst-container { max-width: 1200px; margin: 0 auto; padding: 0 24px; }

  /* Nav */
  .rst-nav { position: fixed; top: 0; left: 0; right: 0; padding: 20px 40px; display: flex; justify-content: space-between; align-items: center; z-index: 100; background: transparent; transition: all 0.3s; }
  .rst-nav.scrolled { background: rgba(10, 10, 10, 0.95); backdrop-filter: blur(10px); }
  .rst-logo { font-size: 1.5rem; font-weight: 700; color: white; font-family: Georgia, serif; }
  .rst-nav-links { display: flex; gap: 32px; align-items: center; }
  .rst-nav-link { color: rgba(255,255,255,0.8); text-decoration: none; font-size: 14px; font-weight: 500; transition: color 0.2s; }
  .rst-nav-link:hover { color: #eab308; }
  .rst-nav-btn { padding: 12px 24px; background: #eab308; color: #0a0a0a; border-radius: 8px; text-decoration: none; font-weight: 600; font-size: 14px; }

  /* Hero */
  .rst-hero { min-height: 100vh; background: linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.6)), url('https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=1920&h=1080&fit=crop') center/cover fixed; display: flex; align-items: center; justify-content: center; text-align: center; padding: 120px 24px 80px; }
  .rst-hero-content { max-width: 800px; }
  .rst-badge { display: inline-block; padding: 12px 28px; background: rgba(234, 179, 8, 0.15); border: 1px solid rgba(234, 179, 8, 0.4); border-radius: 100px; color: #fcd34d; font-size: 14px; font-weight: 600; letter-spacing: 3px; text-transform: uppercase; margin-bottom: 32px; }
  .rst-title { font-size: 4.5rem; font-weight: 700; color: white; line-height: 1.05; margin-bottom: 24px; font-family: Georgia, serif; }
  .rst-desc { font-size: 1.3rem; color: rgba(255,255,255,0.85); line-height: 1.7; margin-bottom: 48px; }
  .rst-ctas { display: flex; gap: 20px; justify-content: center; flex-wrap: wrap; }
  .rst-btn-primary { padding: 18px 40px; background: #eab308; color: #0a0a0a; font-weight: 700; font-size: 16px; border: none; border-radius: 8px; cursor: pointer; text-decoration: none; transition: all 0.2s; }
  .rst-btn-primary:hover { background: #ca8a04; transform: translateY(-2px); }
  .rst-btn-secondary { padding: 18px 40px; background: transparent; color: white; font-weight: 600; font-size: 16px; border: 2px solid rgba(255,255,255,0.5); border-radius: 8px; cursor: pointer; text-decoration: none; transition: all 0.2s; }
  .rst-btn-secondary:hover { background: rgba(255,255,255,0.1); border-color: white; }

  /* Features */
  .rst-features { padding: 80px 24px; background: #0a0a0a; }
  .rst-features-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 40px; text-align: center; }
  .rst-feature-icon { font-size: 48px; margin-bottom: 20px; }
  .rst-feature-title { color: white; font-size: 1.1rem; font-weight: 600; margin-bottom: 8px; }
  .rst-feature-desc { color: #71717a; font-size: 14px; }

  /* About */
  .rst-about { padding: 100px 24px; background: #fafaf9; }
  .rst-about-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: center; }
  .rst-about-image { width: 100%; border-radius: 20px; box-shadow: 0 25px 50px rgba(0,0,0,0.15); }
  .rst-section-label { color: #eab308; font-size: 14px; font-weight: 600; letter-spacing: 2px; text-transform: uppercase; margin-bottom: 16px; }
  .rst-section-title { font-size: 2.5rem; font-weight: 700; color: #0a0a0a; font-family: Georgia, serif; margin-bottom: 24px; line-height: 1.2; }
  .rst-about-text { color: #57534e; font-size: 1.1rem; line-height: 1.8; margin-bottom: 16px; }

  /* Menu */
  .rst-menu { padding: 100px 24px; background: white; }
  .rst-menu-header { text-align: center; margin-bottom: 60px; }
  .rst-menu-categories { display: flex; justify-content: center; gap: 16px; margin-bottom: 48px; flex-wrap: wrap; }
  .rst-menu-cat { padding: 12px 28px; background: transparent; border: 2px solid #e7e5e4; border-radius: 100px; color: #57534e; font-weight: 600; cursor: pointer; transition: all 0.2s; }
  .rst-menu-cat.active, .rst-menu-cat:hover { background: #0a0a0a; border-color: #0a0a0a; color: white; }
  .rst-menu-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 32px; }
  .rst-menu-item { background: #fafaf9; border-radius: 20px; overflow: hidden; transition: all 0.3s; }
  .rst-menu-item:hover { transform: translateY(-8px); box-shadow: 0 20px 40px rgba(0,0,0,0.1); }
  .rst-menu-img { width: 100%; height: 220px; object-fit: cover; }
  .rst-menu-content { padding: 28px; }
  .rst-menu-name { font-size: 1.25rem; font-weight: 700; color: #0a0a0a; margin-bottom: 8px; }
  .rst-menu-desc-text { color: #78716c; font-size: 14px; margin-bottom: 16px; line-height: 1.6; }
  .rst-menu-footer { display: flex; justify-content: space-between; align-items: center; }
  .rst-menu-price { font-size: 1.5rem; font-weight: 800; color: #0a0a0a; }
  .rst-menu-add { width: 44px; height: 44px; background: #eab308; border: none; border-radius: 50%; color: white; font-size: 24px; cursor: pointer; transition: all 0.2s; }
  .rst-menu-add:hover { background: #ca8a04; transform: scale(1.1); }

  /* Testimonials */
  .rst-reviews { padding: 100px 24px; background: #0a0a0a; }
  .rst-reviews-header { text-align: center; margin-bottom: 60px; }
  .rst-reviews-header .rst-section-title { color: white; }
  .rst-reviews-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 32px; }
  .rst-review { background: #171717; border-radius: 20px; padding: 32px; }
  .rst-review-stars { color: #eab308; font-size: 20px; margin-bottom: 16px; }
  .rst-review-text { color: #d4d4d8; line-height: 1.8; margin-bottom: 24px; font-style: italic; }
  .rst-review-author { display: flex; align-items: center; gap: 16px; }
  .rst-review-avatar { width: 48px; height: 48px; border-radius: 50%; object-fit: cover; }
  .rst-review-name { color: white; font-weight: 600; }
  .rst-review-date { color: #71717a; font-size: 13px; }

  /* Reservation */
  .rst-reservation { padding: 100px 24px; background: linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.8)), url('https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=1920&h=800&fit=crop') center/cover fixed; }
  .rst-reservation-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: center; }
  .rst-reservation-content .rst-section-title { color: white; }
  .rst-reservation-content p { color: rgba(255,255,255,0.8); font-size: 1.1rem; line-height: 1.8; margin-bottom: 32px; }
  .rst-reservation-info { display: grid; gap: 16px; }
  .rst-info-item { display: flex; align-items: center; gap: 16px; color: white; }
  .rst-info-icon { width: 48px; height: 48px; background: rgba(234, 179, 8, 0.2); border-radius: 12px; display: flex; align-items: center; justify-content: center; font-size: 20px; }
  .rst-reservation-form { background: white; padding: 48px; border-radius: 24px; }
  .rst-form-title { font-size: 1.5rem; font-weight: 700; color: #0a0a0a; margin-bottom: 8px; text-align: center; }
  .rst-form-subtitle { color: #78716c; text-align: center; margin-bottom: 32px; }
  .rst-form-row { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; margin-bottom: 16px; }
  .rst-input { width: 100%; padding: 16px 20px; border: 2px solid #e7e5e4; border-radius: 12px; font-size: 1rem; outline: none; transition: all 0.2s; }
  .rst-input:focus { border-color: #eab308; }
  .rst-form-btn { width: 100%; padding: 18px; background: #eab308; color: #0a0a0a; font-weight: 700; font-size: 1rem; border: none; border-radius: 12px; cursor: pointer; transition: all 0.2s; }
  .rst-form-btn:hover { background: #ca8a04; }

  /* Location */
  .rst-location { padding: 100px 24px; background: #fafaf9; }
  .rst-location-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 60px; }
  .rst-map { width: 100%; height: 400px; border-radius: 20px; background: #e7e5e4; display: flex; align-items: center; justify-content: center; color: #78716c; font-size: 1.25rem; }
  .rst-contact-info { padding: 40px 0; }
  .rst-contact-item { display: flex; align-items: flex-start; gap: 20px; padding: 24px 0; border-bottom: 1px solid #e7e5e4; }
  .rst-contact-item:last-child { border: none; }
  .rst-contact-icon { width: 56px; height: 56px; background: #eab308; border-radius: 16px; display: flex; align-items: center; justify-content: center; font-size: 24px; flex-shrink: 0; }
  .rst-contact-label { color: #78716c; font-size: 14px; margin-bottom: 4px; }
  .rst-contact-value { color: #0a0a0a; font-weight: 600; font-size: 1.1rem; }

  /* Footer */
  .rst-footer { padding: 60px 24px; background: #0a0a0a; text-align: center; }
  .rst-footer-logo { font-size: 2rem; font-weight: 700; color: white; font-family: Georgia, serif; margin-bottom: 16px; }
  .rst-footer-social { display: flex; justify-content: center; gap: 16px; margin-bottom: 32px; }
  .rst-social-link { width: 44px; height: 44px; background: #171717; border-radius: 50%; display: flex; align-items: center; justify-content: center; color: white; text-decoration: none; font-size: 18px; transition: all 0.2s; }
  .rst-social-link:hover { background: #eab308; }
  .rst-footer-copy { color: #71717a; font-size: 14px; }

  /* Responsive */
  @media (max-width: 968px) {
    .rst-title { font-size: 2.75rem; }
    .rst-features-grid { grid-template-columns: repeat(2, 1fr); }
    .rst-about-grid, .rst-reservation-grid, .rst-location-grid { grid-template-columns: 1fr; gap: 48px; }
    .rst-menu-grid, .rst-reviews-grid { grid-template-columns: 1fr; max-width: 400px; margin: 0 auto; }
    .rst-nav-links { display: none; }
    .rst-form-row { grid-template-columns: 1fr; }
  }
</style>

<!-- NAV -->
<nav class="rst-nav">
  <div class="rst-logo">La Maison</div>
  <div class="rst-nav-links">
    <a href="#cardapio" class="rst-nav-link">Cardápio</a>
    <a href="#sobre" class="rst-nav-link">Sobre</a>
    <a href="#avaliacoes" class="rst-nav-link">Avaliações</a>
    <a href="#contato" class="rst-nav-link">Contato</a>
    <a href="#reserva" class="rst-nav-btn">Reservar Mesa</a>
  </div>
</nav>

<!-- HERO -->
<section class="rst-hero">
  <div class="rst-hero-content">
    <div class="rst-badge">✦ Desde 1985 ✦</div>
    <h1 class="rst-title">Uma experiência gastronômica inesquecível</h1>
    <p class="rst-desc">
      Ingredientes frescos, receitas tradicionais e um ambiente acolhedor. Venha descobrir os sabores que conquistam paladares há gerações.
    </p>
    <div class="rst-ctas">
      <a href="#reserva" class="rst-btn-primary">Fazer Reserva</a>
      <a href="#cardapio" class="rst-btn-secondary">Ver Cardápio</a>
    </div>
  </div>
</section>

<!-- FEATURES -->
<section class="rst-features">
  <div class="rst-container">
    <div class="rst-features-grid">
      <div>
        <div class="rst-feature-icon">🍷</div>
        <h3 class="rst-feature-title">Carta de Vinhos</h3>
        <p class="rst-feature-desc">+200 rótulos selecionados</p>
      </div>
      <div>
        <div class="rst-feature-icon">👨‍🍳</div>
        <h3 class="rst-feature-title">Chef Premiado</h3>
        <p class="rst-feature-desc">25 anos de experiência</p>
      </div>
      <div>
        <div class="rst-feature-icon">🌿</div>
        <h3 class="rst-feature-title">Farm to Table</h3>
        <p class="rst-feature-desc">Ingredientes locais</p>
      </div>
      <div>
        <div class="rst-feature-icon">⭐</div>
        <h3 class="rst-feature-title">4.9 no Google</h3>
        <p class="rst-feature-desc">+2.000 avaliações</p>
      </div>
    </div>
  </div>
</section>

<!-- ABOUT -->
<section class="rst-about" id="sobre">
  <div class="rst-container">
    <div class="rst-about-grid">
      <div>
        <img src="https://images.unsplash.com/photo-1600565193348-f74bd3c7ccdf?w=600&h=500&fit=crop" alt="Nosso restaurante" class="rst-about-image" />
      </div>
      <div>
        <div class="rst-section-label">Nossa História</div>
        <h2 class="rst-section-title">Tradição e paixão pela gastronomia desde 1985</h2>
        <p class="rst-about-text">
          Há quase 40 anos, o La Maison é referência em alta gastronomia na cidade. Fundado pelo Chef Pierre Dubois, nosso restaurante combina técnicas clássicas francesas com ingredientes brasileiros da mais alta qualidade.
        </p>
        <p class="rst-about-text">
          Cada prato é uma celebração de sabores, preparado com ingredientes frescos selecionados diariamente de produtores locais que compartilham nossa paixão por qualidade.
        </p>
      </div>
    </div>
  </div>
</section>

<!-- MENU -->
<section class="rst-menu" id="cardapio">
  <div class="rst-container">
    <div class="rst-menu-header">
      <div class="rst-section-label">Cardápio</div>
      <h2 class="rst-section-title">Nossos Pratos em Destaque</h2>
    </div>
    <div class="rst-menu-categories">
      <button class="rst-menu-cat active">Entradas</button>
      <button class="rst-menu-cat">Principais</button>
      <button class="rst-menu-cat">Sobremesas</button>
      <button class="rst-menu-cat">Vinhos</button>
    </div>
    <div class="rst-menu-grid">
      <div class="rst-menu-item">
        <img src="https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=600&h=400&fit=crop" class="rst-menu-img" alt="Prato" />
        <div class="rst-menu-content">
          <h3 class="rst-menu-name">Salmão Grelhado</h3>
          <p class="rst-menu-desc-text">Com risoto de limão siciliano e legumes da estação</p>
          <div class="rst-menu-footer">
            <div class="rst-menu-price">R$ 89,90</div>
            <button class="rst-menu-add">+</button>
          </div>
        </div>
      </div>
      <div class="rst-menu-item">
        <img src="https://images.unsplash.com/photo-1567620905732-2d1ec7ab7445?w=600&h=400&fit=crop" class="rst-menu-img" alt="Prato" />
        <div class="rst-menu-content">
          <h3 class="rst-menu-name">Filé ao Molho</h3>
          <p class="rst-menu-desc-text">Filé mignon com molho de cogumelos e batata rústica</p>
          <div class="rst-menu-footer">
            <div class="rst-menu-price">R$ 99,90</div>
            <button class="rst-menu-add">+</button>
          </div>
        </div>
      </div>
      <div class="rst-menu-item">
        <img src="https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=600&h=400&fit=crop" class="rst-menu-img" alt="Prato" />
        <div class="rst-menu-content">
          <h3 class="rst-menu-name">Risoto de Funghi</h3>
          <p class="rst-menu-desc-text">Arroz arbóreo, mix de cogumelos e parmesão</p>
          <div class="rst-menu-footer">
            <div class="rst-menu-price">R$ 79,90</div>
            <button class="rst-menu-add">+</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- REVIEWS -->
<section class="rst-reviews" id="avaliacoes">
  <div class="rst-container">
    <div class="rst-reviews-header">
      <div class="rst-section-label" style="color: #eab308;">Avaliações</div>
      <h2 class="rst-section-title">O Que Nossos Clientes Dizem</h2>
    </div>
    <div class="rst-reviews-grid">
      <div class="rst-review">
        <div class="rst-review-stars">★★★★★</div>
        <p class="rst-review-text">"Melhor restaurante da cidade! A experiência gastronômica é incrível e o atendimento impecável. Voltaremos com certeza."</p>
        <div class="rst-review-author">
          <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop" class="rst-review-avatar" alt="Avatar" />
          <div>
            <div class="rst-review-name">Carolina Silva</div>
            <div class="rst-review-date">Há 2 semanas</div>
          </div>
        </div>
      </div>
      <div class="rst-review">
        <div class="rst-review-stars">★★★★★</div>
        <p class="rst-review-text">"O salmão grelhado é simplesmente perfeito. Ambiente aconchegante e carta de vinhos excepcional. Recomendo muito!"</p>
        <div class="rst-review-author">
          <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop" class="rst-review-avatar" alt="Avatar" />
          <div>
            <div class="rst-review-name">Ricardo Santos</div>
            <div class="rst-review-date">Há 1 mês</div>
          </div>
        </div>
      </div>
      <div class="rst-review">
        <div class="rst-review-stars">★★★★★</div>
        <p class="rst-review-text">"Comemoramos nosso aniversário de casamento aqui e foi mágico. Cada detalhe pensado com carinho. Nota 10!"</p>
        <div class="rst-review-author">
          <img src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop" class="rst-review-avatar" alt="Avatar" />
          <div>
            <div class="rst-review-name">Ana Oliveira</div>
            <div class="rst-review-date">Há 1 mês</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- RESERVATION -->
<section class="rst-reservation" id="reserva">
  <div class="rst-container">
    <div class="rst-reservation-grid">
      <div class="rst-reservation-content">
        <div class="rst-section-label" style="color: #eab308;">Reservas</div>
        <h2 class="rst-section-title">Reserve sua mesa para uma noite especial</h2>
        <p>Garanta seu lugar no La Maison e viva uma experiência gastronômica única. Aceitamos reservas para grupos de até 20 pessoas.</p>
        <div class="rst-reservation-info">
          <div class="rst-info-item">
            <div class="rst-info-icon">📞</div>
            <span>(11) 3456-7890</span>
          </div>
          <div class="rst-info-item">
            <div class="rst-info-icon">⏰</div>
            <span>Ter-Dom: 19h às 23h</span>
          </div>
          <div class="rst-info-item">
            <div class="rst-info-icon">📍</div>
            <span>Rua das Flores, 123 - Jardins</span>
          </div>
        </div>
      </div>
      <div class="rst-reservation-form">
        <h3 class="rst-form-title">Faça sua Reserva</h3>
        <p class="rst-form-subtitle">Preencha os dados abaixo</p>
        <form data-success-message="Reserva solicitada! Entraremos em contato para confirmar.">
          <div class="rst-form-row">
            <input type="text" name="name" class="rst-input" placeholder="Nome completo" required />
            <input type="tel" name="phone" class="rst-input" placeholder="Telefone" required />
          </div>
          <div class="rst-form-row">
            <input type="date" name="date" class="rst-input" required />
            <input type="time" name="time" class="rst-input" required />
          </div>
          <div class="rst-form-row">
            <select name="guests" class="rst-input">
              <option value="">Número de pessoas</option>
              <option value="2">2 pessoas</option>
              <option value="4">4 pessoas</option>
              <option value="6">6 pessoas</option>
              <option value="8+">8+ pessoas</option>
            </select>
            <select name="occasion" class="rst-input">
              <option value="">Ocasião (opcional)</option>
              <option value="birthday">Aniversário</option>
              <option value="romantic">Jantar romântico</option>
              <option value="business">Negócios</option>
              <option value="other">Outra</option>
            </select>
          </div>
          <button type="submit" class="rst-form-btn">Confirmar Reserva</button>
        </form>
      </div>
    </div>
  </div>
</section>

<!-- LOCATION -->
<section class="rst-location" id="contato">
  <div class="rst-container">
    <div class="rst-location-grid">
      <div class="rst-map">[Mapa do Google Maps aqui]</div>
      <div class="rst-contact-info">
        <div class="rst-section-label">Localização</div>
        <h2 class="rst-section-title">Como Chegar</h2>
        <div class="rst-contact-item">
          <div class="rst-contact-icon">📍</div>
          <div>
            <div class="rst-contact-label">Endereço</div>
            <div class="rst-contact-value">Rua das Flores, 123 - Jardins, São Paulo</div>
          </div>
        </div>
        <div class="rst-contact-item">
          <div class="rst-contact-icon">📞</div>
          <div>
            <div class="rst-contact-label">Telefone</div>
            <div class="rst-contact-value">(11) 3456-7890</div>
          </div>
        </div>
        <div class="rst-contact-item">
          <div class="rst-contact-icon">⏰</div>
          <div>
            <div class="rst-contact-label">Horário</div>
            <div class="rst-contact-value">Ter a Dom: 19h às 23h</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- FOOTER -->
<footer class="rst-footer">
  <div class="rst-container">
    <div class="rst-footer-logo">La Maison</div>
    <div class="rst-footer-social">
      <a href="#" class="rst-social-link">📷</a>
      <a href="#" class="rst-social-link">📘</a>
      <a href="#" class="rst-social-link">🐦</a>
    </div>
    <p class="rst-footer-copy">© 2025 La Maison Restaurante. Todos os direitos reservados.</p>
  </div>
</footer>
`,
    gjsCss: '',
    gjsComponents: '',
    gjsStyles: ''
  },

  // ============================================
  // 8. APP DOWNLOAD
  // ============================================
  {
    id: 'app-download-pro',
    name: 'Download de App',
    description: 'Landing page completa para apps com screenshots, reviews e download links',
    thumbnail: 'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=400&h=300&fit=crop',
    category: 'saas',
    gjsHtml: `
<style>
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { font-family: 'Inter', -apple-system, sans-serif; }
  .app-container { max-width: 1200px; margin: 0 auto; padding: 0 24px; }

  /* Hero */
  .app-hero { min-height: 100vh; background: linear-gradient(135deg, #1e1b4b 0%, #312e81 50%, #4338ca 100%); padding: 80px 24px; display: flex; align-items: center; position: relative; overflow: hidden; }
  .app-hero::before { content: ''; position: absolute; top: -50%; right: -20%; width: 80%; height: 200%; background: radial-gradient(circle, rgba(129, 140, 248, 0.1) 0%, transparent 60%); }
  .app-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: center; position: relative; z-index: 1; }
  .app-badge { display: inline-flex; align-items: center; gap: 8px; padding: 10px 20px; background: rgba(255,255,255,0.1); border: 1px solid rgba(255,255,255,0.2); border-radius: 100px; color: #c7d2fe; font-size: 14px; font-weight: 500; margin-bottom: 32px; }
  .app-title { font-size: 3.5rem; font-weight: 800; color: white; line-height: 1.1; margin-bottom: 24px; }
  .app-title span { background: linear-gradient(90deg, #a5b4fc, #c4b5fd); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; }
  .app-desc { font-size: 1.2rem; color: #c7d2fe; line-height: 1.7; margin-bottom: 40px; }
  .app-stores { display: flex; gap: 16px; margin-bottom: 48px; }
  .app-store-btn { display: flex; align-items: center; gap: 12px; padding: 16px 28px; background: white; border-radius: 14px; text-decoration: none; transition: all 0.2s; }
  .app-store-btn:hover { transform: translateY(-4px); box-shadow: 0 20px 40px rgba(0,0,0,0.3); }
  .app-store-icon { font-size: 32px; }
  .app-store-text { font-size: 12px; color: #64748b; }
  .app-store-name { font-size: 18px; font-weight: 700; color: #0f172a; }
  .app-stats { display: flex; gap: 40px; }
  .app-stat-value { font-size: 2rem; font-weight: 800; color: white; }
  .app-stat-label { font-size: 14px; color: #a5b4fc; }
  .app-phone { position: relative; display: flex; justify-content: center; }
  .app-phone-mockup { width: 300px; background: #0f172a; border-radius: 40px; padding: 12px; box-shadow: 0 50px 100px rgba(0,0,0,0.4); }
  .app-phone-screen { width: 100%; border-radius: 32px; }

  /* Features */
  .app-section { padding: 100px 24px; }
  .app-section-header { text-align: center; margin-bottom: 60px; }
  .app-section-label { color: #6366f1; font-weight: 600; font-size: 14px; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 12px; }
  .app-section-title { font-size: 2.5rem; font-weight: 800; color: #0f172a; margin-bottom: 16px; }
  .app-section-subtitle { color: #64748b; font-size: 1.1rem; max-width: 600px; margin: 0 auto; }
  .app-features { background: white; }
  .app-features-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 32px; }
  .app-feature { text-align: center; padding: 40px 32px; background: #f8fafc; border-radius: 24px; transition: all 0.3s; }
  .app-feature:hover { transform: translateY(-8px); box-shadow: 0 20px 40px rgba(0,0,0,0.08); }
  .app-feature-icon { width: 72px; height: 72px; background: linear-gradient(135deg, #6366f1, #8b5cf6); border-radius: 20px; display: flex; align-items: center; justify-content: center; margin: 0 auto 24px; font-size: 32px; }
  .app-feature-title { font-size: 1.25rem; font-weight: 700; color: #0f172a; margin-bottom: 12px; }
  .app-feature-desc { color: #64748b; line-height: 1.6; }

  /* Screenshots */
  .app-screenshots { background: #f8fafc; }
  .app-screenshots-scroll { display: flex; gap: 24px; overflow-x: auto; padding: 20px 0; }
  .app-screenshot { flex-shrink: 0; width: 280px; background: #0f172a; border-radius: 32px; padding: 8px; box-shadow: 0 20px 40px rgba(0,0,0,0.15); }
  .app-screenshot img { width: 100%; border-radius: 26px; }

  /* Reviews */
  .app-reviews { background: white; }
  .app-reviews-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 32px; }
  .app-review { background: #f8fafc; padding: 32px; border-radius: 20px; }
  .app-review-header { display: flex; justify-content: space-between; align-items: start; margin-bottom: 16px; }
  .app-review-stars { color: #fbbf24; font-size: 18px; }
  .app-review-store { font-size: 12px; color: #94a3b8; background: #e2e8f0; padding: 4px 10px; border-radius: 100px; }
  .app-review-text { color: #334155; line-height: 1.7; margin-bottom: 20px; }
  .app-review-author { font-weight: 600; color: #0f172a; font-size: 14px; }
  .app-review-date { color: #94a3b8; font-size: 13px; }

  /* How it works */
  .app-how { background: linear-gradient(135deg, #1e1b4b 0%, #312e81 100%); }
  .app-how .app-section-title { color: white; }
  .app-how .app-section-subtitle { color: #a5b4fc; }
  .app-how-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 40px; }
  .app-how-step { text-align: center; }
  .app-how-number { width: 64px; height: 64px; background: rgba(255,255,255,0.1); border: 2px solid rgba(255,255,255,0.2); border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 1.5rem; font-weight: 800; color: white; margin: 0 auto 20px; }
  .app-how-title { color: white; font-weight: 700; margin-bottom: 8px; }
  .app-how-desc { color: #a5b4fc; font-size: 14px; line-height: 1.6; }

  /* CTA */
  .app-cta { background: white; text-align: center; }
  .app-cta-box { background: linear-gradient(135deg, #6366f1, #8b5cf6); border-radius: 32px; padding: 80px 40px; }
  .app-cta h2 { font-size: 2.5rem; font-weight: 800; color: white; margin-bottom: 16px; }
  .app-cta p { color: rgba(255,255,255,0.9); font-size: 1.2rem; margin-bottom: 40px; }
  .app-cta-stores { display: flex; gap: 16px; justify-content: center; }

  /* Footer */
  .app-footer { padding: 60px 24px; background: #0f172a; text-align: center; }
  .app-footer-logo { font-size: 1.5rem; font-weight: 800; color: white; margin-bottom: 24px; }
  .app-footer-links { display: flex; justify-content: center; gap: 32px; margin-bottom: 32px; }
  .app-footer-links a { color: #64748b; text-decoration: none; font-size: 14px; transition: color 0.2s; }
  .app-footer-links a:hover { color: white; }
  .app-footer-copy { color: #475569; font-size: 14px; }

  /* Responsive */
  @media (max-width: 968px) {
    .app-grid { grid-template-columns: 1fr; text-align: center; }
    .app-title { font-size: 2.5rem; }
    .app-stores { justify-content: center; flex-wrap: wrap; }
    .app-stats { justify-content: center; }
    .app-features-grid, .app-reviews-grid { grid-template-columns: 1fr; }
    .app-how-grid { grid-template-columns: repeat(2, 1fr); }
    .app-phone { order: -1; margin-bottom: 40px; }
    .app-phone-mockup { width: 250px; }
    .app-cta h2 { font-size: 2rem; }
    .app-cta-stores { flex-direction: column; align-items: center; }
  }
</style>

<!-- HERO -->
<section class="app-hero">
  <div class="app-container">
    <div class="app-grid">
      <div>
        <div class="app-badge">📱 +2 milhões de downloads</div>
        <h1 class="app-title">
          Sua vida financeira <span>simplificada</span>
        </h1>
        <p class="app-desc">
          Controle gastos, crie metas de economia e invista de forma inteligente. Tudo em um único app, na palma da sua mão.
        </p>
        <div class="app-stores">
          <a href="#" class="app-store-btn">
            <span class="app-store-icon">🍎</span>
            <div>
              <div class="app-store-text">Baixar na</div>
              <div class="app-store-name">App Store</div>
            </div>
          </a>
          <a href="#" class="app-store-btn">
            <span class="app-store-icon">▶️</span>
            <div>
              <div class="app-store-text">Disponível no</div>
              <div class="app-store-name">Google Play</div>
            </div>
          </a>
        </div>
        <div class="app-stats">
          <div>
            <div class="app-stat-value">2M+</div>
            <div class="app-stat-label">Downloads</div>
          </div>
          <div>
            <div class="app-stat-value">4.9</div>
            <div class="app-stat-label">Avaliação</div>
          </div>
          <div>
            <div class="app-stat-value">98%</div>
            <div class="app-stat-label">Satisfação</div>
          </div>
        </div>
      </div>
      <div class="app-phone">
        <div class="app-phone-mockup">
          <img src="https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=400&h=800&fit=crop" alt="App Screenshot" class="app-phone-screen" />
        </div>
      </div>
    </div>
  </div>
</section>

<!-- FEATURES -->
<section class="app-section app-features">
  <div class="app-container">
    <div class="app-section-header">
      <div class="app-section-label">Recursos</div>
      <h2 class="app-section-title">Tudo que você precisa em um único app</h2>
      <p class="app-section-subtitle">Funcionalidades pensadas para simplificar sua vida financeira</p>
    </div>
    <div class="app-features-grid">
      <div class="app-feature">
        <div class="app-feature-icon">📊</div>
        <h3 class="app-feature-title">Dashboard Intuitivo</h3>
        <p class="app-feature-desc">Visualize todos seus gastos e receitas em gráficos fáceis de entender</p>
      </div>
      <div class="app-feature">
        <div class="app-feature-icon">🎯</div>
        <h3 class="app-feature-title">Metas Inteligentes</h3>
        <p class="app-feature-desc">Defina objetivos financeiros e acompanhe seu progresso em tempo real</p>
      </div>
      <div class="app-feature">
        <div class="app-feature-icon">🔔</div>
        <h3 class="app-feature-title">Alertas Personalizados</h3>
        <p class="app-feature-desc">Receba notificações sobre gastos, vencimentos e metas atingidas</p>
      </div>
      <div class="app-feature">
        <div class="app-feature-icon">🏦</div>
        <h3 class="app-feature-title">Multi-bancos</h3>
        <p class="app-feature-desc">Conecte todas suas contas em um só lugar automaticamente</p>
      </div>
      <div class="app-feature">
        <div class="app-feature-icon">📱</div>
        <h3 class="app-feature-title">Offline Mode</h3>
        <p class="app-feature-desc">Acesse seus dados mesmo sem conexão com a internet</p>
      </div>
      <div class="app-feature">
        <div class="app-feature-icon">🔒</div>
        <h3 class="app-feature-title">100% Seguro</h3>
        <p class="app-feature-desc">Criptografia de ponta e autenticação biométrica</p>
      </div>
    </div>
  </div>
</section>

<!-- HOW IT WORKS -->
<section class="app-section app-how">
  <div class="app-container">
    <div class="app-section-header">
      <div class="app-section-label" style="color: #a5b4fc;">Como Funciona</div>
      <h2 class="app-section-title">Comece em 3 passos simples</h2>
      <p class="app-section-subtitle">Configure tudo em menos de 2 minutos</p>
    </div>
    <div class="app-how-grid">
      <div class="app-how-step">
        <div class="app-how-number">1</div>
        <h3 class="app-how-title">Baixe o App</h3>
        <p class="app-how-desc">Disponível gratuitamente na App Store e Google Play</p>
      </div>
      <div class="app-how-step">
        <div class="app-how-number">2</div>
        <h3 class="app-how-title">Crie sua Conta</h3>
        <p class="app-how-desc">Cadastro rápido com e-mail ou redes sociais</p>
      </div>
      <div class="app-how-step">
        <div class="app-how-number">3</div>
        <h3 class="app-how-title">Conecte Bancos</h3>
        <p class="app-how-desc">Importe suas contas de forma segura e automática</p>
      </div>
      <div class="app-how-step">
        <div class="app-how-number">4</div>
        <h3 class="app-how-title">Acompanhe</h3>
        <p class="app-how-desc">Veja tudo organizado e tome decisões melhores</p>
      </div>
    </div>
  </div>
</section>

<!-- REVIEWS -->
<section class="app-section app-reviews">
  <div class="app-container">
    <div class="app-section-header">
      <div class="app-section-label">Avaliações</div>
      <h2 class="app-section-title">O que dizem sobre o app</h2>
      <p class="app-section-subtitle">Mais de 50.000 avaliações 5 estrelas nas lojas</p>
    </div>
    <div class="app-reviews-grid">
      <div class="app-review">
        <div class="app-review-header">
          <div class="app-review-stars">★★★★★</div>
          <span class="app-review-store">App Store</span>
        </div>
        <p class="app-review-text">"Finalmente consegui organizar minhas finanças! O app é super intuitivo e as metas me ajudam a economizar todos os meses."</p>
        <div class="app-review-author">Carla M.</div>
        <div class="app-review-date">Há 1 semana</div>
      </div>
      <div class="app-review">
        <div class="app-review-header">
          <div class="app-review-stars">★★★★★</div>
          <span class="app-review-store">Google Play</span>
        </div>
        <p class="app-review-text">"Melhor app de finanças que já usei. A conexão com os bancos é perfeita e os relatórios são muito completos."</p>
        <div class="app-review-author">Pedro S.</div>
        <div class="app-review-date">Há 2 semanas</div>
      </div>
      <div class="app-review">
        <div class="app-review-header">
          <div class="app-review-stars">★★★★★</div>
          <span class="app-review-store">App Store</span>
        </div>
        <p class="app-review-text">"Economizei R$3.000 em 3 meses usando as metas do app. Recomendo para todo mundo que quer ter controle do dinheiro."</p>
        <div class="app-review-author">Ana L.</div>
        <div class="app-review-date">Há 3 semanas</div>
      </div>
    </div>
  </div>
</section>

<!-- CTA -->
<section class="app-section app-cta">
  <div class="app-container">
    <div class="app-cta-box">
      <h2>Baixe grátis e comece hoje</h2>
      <p>Junte-se a mais de 2 milhões de pessoas que já transformaram sua vida financeira</p>
      <div class="app-cta-stores">
        <a href="#" class="app-store-btn">
          <span class="app-store-icon">🍎</span>
          <div>
            <div class="app-store-text">Baixar na</div>
            <div class="app-store-name">App Store</div>
          </div>
        </a>
        <a href="#" class="app-store-btn">
          <span class="app-store-icon">▶️</span>
          <div>
            <div class="app-store-text">Disponível no</div>
            <div class="app-store-name">Google Play</div>
          </div>
        </a>
      </div>
    </div>
  </div>
</section>

<!-- FOOTER -->
<footer class="app-footer">
  <div class="app-container">
    <div class="app-footer-logo">FinanceApp</div>
    <div class="app-footer-links">
      <a href="#">Sobre</a>
      <a href="#">Recursos</a>
      <a href="#">Suporte</a>
      <a href="#">Privacidade</a>
      <a href="#">Termos</a>
    </div>
    <p class="app-footer-copy">© 2025 FinanceApp. Todos os direitos reservados.</p>
  </div>
</footer>
`,
    gjsCss: '',
    gjsComponents: '',
    gjsStyles: ''
  },

  // ============================================
  // 9. CURSO ONLINE PRO
  // ============================================
  {
    id: 'course-sales-pro',
    name: 'Curso Online Pro',
    description: 'Página de vendas profissional para cursos e infoprodutos',
    thumbnail: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=400&h=300&fit=crop',
    category: 'product-launch',
    gjsHtml: `
<style>
  * { box-sizing: border-box; margin: 0; padding: 0; }

  /* HERO */
  .course-hero { padding: 100px 24px 80px; background: linear-gradient(135deg, #0c0a09 0%, #1c1917 100%); }
  .course-container { max-width: 1100px; margin: 0 auto; }
  .course-hero-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 60px; align-items: center; }
  .course-badge { display: inline-flex; align-items: center; gap: 8px; padding: 12px 24px; background: rgba(234, 179, 8, 0.15); border: 1px solid rgba(234, 179, 8, 0.3); border-radius: 100px; color: #fcd34d; font-size: 14px; font-weight: 600; margin-bottom: 24px; }
  .course-title { font-size: 3.25rem; font-weight: 800; color: white; line-height: 1.1; margin-bottom: 24px; }
  .course-title span { color: #fbbf24; }
  .course-desc { font-size: 1.2rem; color: #a8a29e; line-height: 1.7; margin-bottom: 32px; }
  .course-hero-benefits { list-style: none; margin-bottom: 32px; }
  .course-hero-benefits li { display: flex; align-items: center; gap: 12px; padding: 12px 0; color: #d6d3d1; font-size: 1rem; }
  .course-check { width: 24px; height: 24px; background: linear-gradient(135deg, #22c55e, #16a34a); border-radius: 50%; display: flex; align-items: center; justify-content: center; color: white; font-size: 12px; flex-shrink: 0; }
  .course-hero-btn { display: inline-block; padding: 20px 48px; background: linear-gradient(135deg, #fbbf24, #f59e0b); color: #0c0a09; font-weight: 800; font-size: 18px; border: none; border-radius: 14px; cursor: pointer; text-decoration: none; transition: transform 0.2s, box-shadow 0.2s; }
  .course-hero-btn:hover { transform: translateY(-2px); box-shadow: 0 10px 30px rgba(251, 191, 36, 0.3); }
  .course-video { background: #292524; border-radius: 24px; overflow: hidden; box-shadow: 0 30px 80px rgba(0,0,0,0.5); position: relative; }
  .course-video-thumb { width: 100%; aspect-ratio: 16/9; object-fit: cover; }
  .course-video-play { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 80px; height: 80px; background: rgba(255,255,255,0.95); border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 28px; cursor: pointer; box-shadow: 0 8px 30px rgba(0,0,0,0.3); }

  /* PROBLEM/PAIN */
  .course-problem { padding: 100px 24px; background: #fafaf9; }
  .course-problem-header { text-align: center; margin-bottom: 60px; }
  .course-problem-label { color: #dc2626; font-weight: 600; font-size: 14px; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 12px; }
  .course-problem-title { font-size: 2.5rem; font-weight: 800; color: #0c0a09; margin-bottom: 16px; }
  .course-problem-subtitle { font-size: 1.2rem; color: #78716c; max-width: 700px; margin: 0 auto; }
  .course-problem-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; }
  .course-problem-card { background: white; padding: 32px; border-radius: 20px; border: 2px solid #fef2f2; text-align: center; }
  .course-problem-icon { width: 64px; height: 64px; background: #fef2f2; border-radius: 16px; display: flex; align-items: center; justify-content: center; margin: 0 auto 20px; font-size: 28px; }
  .course-problem-card-title { font-size: 1.1rem; font-weight: 700; color: #0c0a09; margin-bottom: 8px; }
  .course-problem-card-desc { color: #78716c; font-size: 14px; line-height: 1.6; }

  /* SOLUTION/TRANSFORMATION */
  .course-solution { padding: 100px 24px; background: linear-gradient(135deg, #0c0a09 0%, #1c1917 100%); }
  .course-solution-header { text-align: center; margin-bottom: 60px; }
  .course-solution-label { color: #22c55e; font-weight: 600; font-size: 14px; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 12px; }
  .course-solution-title { font-size: 2.5rem; font-weight: 800; color: white; margin-bottom: 16px; }
  .course-solution-subtitle { font-size: 1.2rem; color: #a8a29e; max-width: 700px; margin: 0 auto; }
  .course-solution-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 24px; }
  .course-solution-card { background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1); padding: 32px 24px; border-radius: 20px; text-align: center; }
  .course-solution-icon { width: 64px; height: 64px; background: linear-gradient(135deg, #22c55e, #16a34a); border-radius: 16px; display: flex; align-items: center; justify-content: center; margin: 0 auto 20px; font-size: 28px; }
  .course-solution-card-title { font-size: 1rem; font-weight: 700; color: white; margin-bottom: 8px; }
  .course-solution-card-desc { color: #a8a29e; font-size: 14px; line-height: 1.5; }

  /* INSTRUCTOR */
  .course-instructor { padding: 100px 24px; background: #fafaf9; }
  .course-instructor-grid { display: grid; grid-template-columns: 400px 1fr; gap: 60px; align-items: center; }
  .course-instructor-img { width: 100%; aspect-ratio: 1; object-fit: cover; border-radius: 24px; box-shadow: 0 20px 50px rgba(0,0,0,0.1); }
  .course-instructor-label { color: #eab308; font-weight: 600; font-size: 14px; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 12px; }
  .course-instructor-name { font-size: 2.5rem; font-weight: 800; color: #0c0a09; margin-bottom: 16px; }
  .course-instructor-role { font-size: 1.2rem; color: #f59e0b; font-weight: 600; margin-bottom: 24px; }
  .course-instructor-bio { font-size: 1.1rem; color: #57534e; line-height: 1.8; margin-bottom: 32px; }
  .course-instructor-stats { display: flex; gap: 40px; }
  .course-instructor-stat-value { font-size: 2rem; font-weight: 800; color: #0c0a09; }
  .course-instructor-stat-label { color: #78716c; font-size: 14px; }

  /* MODULES */
  .course-modules { padding: 100px 24px; background: white; }
  .course-modules-header { text-align: center; margin-bottom: 60px; }
  .course-modules-label { color: #eab308; font-weight: 600; font-size: 14px; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 12px; }
  .course-modules-title { font-size: 2.5rem; font-weight: 800; color: #0c0a09; margin-bottom: 16px; }
  .course-modules-subtitle { font-size: 1.1rem; color: #78716c; }
  .course-modules-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 24px; }
  .course-module { background: #fafaf9; padding: 32px; border-radius: 20px; display: flex; gap: 20px; transition: transform 0.2s, box-shadow 0.2s; }
  .course-module:hover { transform: translateY(-4px); box-shadow: 0 12px 32px rgba(0,0,0,0.08); }
  .course-module-num { width: 56px; height: 56px; background: linear-gradient(135deg, #fbbf24, #f59e0b); border-radius: 16px; display: flex; align-items: center; justify-content: center; color: #0c0a09; font-size: 1.5rem; font-weight: 800; flex-shrink: 0; }
  .course-module-title { font-size: 1.1rem; font-weight: 700; color: #0c0a09; margin-bottom: 8px; }
  .course-module-desc { color: #78716c; font-size: 14px; line-height: 1.6; margin-bottom: 12px; }
  .course-module-lessons { color: #a8a29e; font-size: 13px; display: flex; align-items: center; gap: 6px; }

  /* TESTIMONIALS */
  .course-testimonials { padding: 100px 24px; background: linear-gradient(135deg, #0c0a09 0%, #1c1917 100%); }
  .course-testimonials-header { text-align: center; margin-bottom: 60px; }
  .course-testimonials-label { color: #fbbf24; font-weight: 600; font-size: 14px; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 12px; }
  .course-testimonials-title { font-size: 2.5rem; font-weight: 800; color: white; }
  .course-testimonials-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; }
  .course-testimonial { background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1); padding: 32px; border-radius: 20px; }
  .course-testimonial-stars { color: #fbbf24; font-size: 18px; margin-bottom: 16px; letter-spacing: 2px; }
  .course-testimonial-quote { font-size: 1rem; color: #d6d3d1; line-height: 1.7; font-style: italic; margin-bottom: 24px; }
  .course-testimonial-author { display: flex; align-items: center; gap: 12px; }
  .course-testimonial-avatar { width: 48px; height: 48px; border-radius: 50%; object-fit: cover; }
  .course-testimonial-name { font-weight: 600; color: white; }
  .course-testimonial-role { font-size: 13px; color: #78716c; }
  .course-testimonial-result { display: inline-block; margin-top: 12px; padding: 6px 12px; background: rgba(34, 197, 94, 0.15); border-radius: 100px; color: #4ade80; font-size: 12px; font-weight: 600; }

  /* BONUS */
  .course-bonus { padding: 100px 24px; background: #fffbeb; }
  .course-bonus-header { text-align: center; margin-bottom: 60px; }
  .course-bonus-label { color: #d97706; font-weight: 600; font-size: 14px; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 12px; }
  .course-bonus-title { font-size: 2.5rem; font-weight: 800; color: #0c0a09; margin-bottom: 16px; }
  .course-bonus-subtitle { font-size: 1.1rem; color: #78716c; }
  .course-bonus-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; }
  .course-bonus-card { background: white; padding: 32px; border-radius: 20px; border: 2px solid #fef3c7; text-align: center; }
  .course-bonus-icon { width: 72px; height: 72px; background: linear-gradient(135deg, #fbbf24, #f59e0b); border-radius: 20px; display: flex; align-items: center; justify-content: center; margin: 0 auto 20px; font-size: 32px; }
  .course-bonus-name { font-size: 1.15rem; font-weight: 700; color: #0c0a09; margin-bottom: 8px; }
  .course-bonus-desc { color: #78716c; font-size: 14px; line-height: 1.6; margin-bottom: 16px; }
  .course-bonus-value { font-size: 1.25rem; font-weight: 800; color: #d97706; }

  /* FAQ */
  .course-faq { padding: 100px 24px; background: #fafaf9; }
  .course-faq-header { text-align: center; margin-bottom: 60px; }
  .course-faq-label { color: #eab308; font-weight: 600; font-size: 14px; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 12px; }
  .course-faq-title { font-size: 2.5rem; font-weight: 800; color: #0c0a09; }
  .course-faq-list { max-width: 800px; margin: 0 auto; }
  .course-faq-item { background: white; border-radius: 16px; margin-bottom: 16px; overflow: hidden; }
  .course-faq-question { padding: 24px 32px; font-size: 1.1rem; font-weight: 600; color: #0c0a09; cursor: pointer; display: flex; justify-content: space-between; align-items: center; }
  .course-faq-question::after { content: '+'; font-size: 24px; color: #d4d4d4; }
  .course-faq-answer { padding: 0 32px 24px; color: #57534e; line-height: 1.7; }

  /* PRICING */
  .course-pricing { padding: 100px 24px; background: linear-gradient(135deg, #0c0a09 0%, #1c1917 100%); }
  .course-pricing-header { text-align: center; margin-bottom: 60px; }
  .course-pricing-label { color: #22c55e; font-weight: 600; font-size: 14px; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 12px; }
  .course-pricing-title { font-size: 2.5rem; font-weight: 800; color: white; margin-bottom: 16px; }
  .course-pricing-subtitle { font-size: 1.1rem; color: #a8a29e; }
  .course-pricing-card { max-width: 600px; margin: 0 auto; background: linear-gradient(135deg, #292524, #1c1917); border: 2px solid #fbbf24; border-radius: 32px; padding: 48px; text-align: center; position: relative; overflow: hidden; }
  .course-pricing-badge { position: absolute; top: 24px; right: -40px; background: #fbbf24; color: #0c0a09; font-weight: 700; font-size: 12px; padding: 8px 48px; transform: rotate(45deg); }
  .course-pricing-name { font-size: 1.5rem; font-weight: 700; color: white; margin-bottom: 24px; }
  .course-pricing-includes { text-align: left; margin-bottom: 32px; }
  .course-pricing-includes li { display: flex; align-items: center; gap: 12px; padding: 12px 0; color: #d6d3d1; font-size: 15px; border-bottom: 1px solid rgba(255,255,255,0.1); }
  .course-pricing-includes li:last-child { border: none; }
  .course-pricing-old { color: #78716c; font-size: 1.5rem; text-decoration: line-through; margin-bottom: 8px; }
  .course-pricing-price { font-size: 4.5rem; font-weight: 900; color: #22c55e; margin-bottom: 8px; }
  .course-pricing-price span { font-size: 1.5rem; vertical-align: top; }
  .course-pricing-installments { color: #a8a29e; margin-bottom: 32px; }
  .course-pricing-btn { width: 100%; padding: 22px; background: linear-gradient(135deg, #22c55e, #16a34a); color: white; font-weight: 800; font-size: 1.25rem; border: none; border-radius: 14px; cursor: pointer; margin-bottom: 20px; transition: transform 0.2s, box-shadow 0.2s; }
  .course-pricing-btn:hover { transform: translateY(-2px); box-shadow: 0 10px 30px rgba(34, 197, 94, 0.3); }
  .course-pricing-guarantee { display: flex; align-items: center; justify-content: center; gap: 12px; color: #78716c; font-size: 14px; }
  .course-pricing-guarantee-icon { width: 48px; height: 48px; background: rgba(255,255,255,0.05); border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 24px; }

  /* FINAL CTA */
  .course-final { padding: 80px 24px; background: #fbbf24; text-align: center; }
  .course-final-title { font-size: 2rem; font-weight: 800; color: #0c0a09; margin-bottom: 16px; }
  .course-final-desc { font-size: 1.1rem; color: #44403c; margin-bottom: 32px; max-width: 600px; margin-left: auto; margin-right: auto; }
  .course-final-btn { display: inline-block; padding: 20px 48px; background: #0c0a09; color: white; font-weight: 700; font-size: 18px; border-radius: 14px; text-decoration: none; transition: transform 0.2s; }
  .course-final-btn:hover { transform: translateY(-2px); }

  /* FOOTER */
  .course-footer { padding: 40px 24px; background: #0c0a09; text-align: center; }
  .course-footer-text { color: #57534e; font-size: 14px; }
  .course-footer-links { margin-top: 16px; }
  .course-footer-links a { color: #78716c; text-decoration: none; margin: 0 12px; font-size: 13px; }

  @media (max-width: 968px) {
    .course-hero-grid { grid-template-columns: 1fr; }
    .course-title { font-size: 2.25rem; }
    .course-problem-grid { grid-template-columns: 1fr; }
    .course-solution-grid { grid-template-columns: repeat(2, 1fr); }
    .course-instructor-grid { grid-template-columns: 1fr; }
    .course-instructor-img { max-width: 300px; margin: 0 auto; }
    .course-modules-grid { grid-template-columns: 1fr; }
    .course-testimonials-grid { grid-template-columns: 1fr; }
    .course-bonus-grid { grid-template-columns: 1fr; }
    .course-pricing-price { font-size: 3.5rem; }
  }
</style>

<!-- HERO -->
<section class="course-hero">
  <div class="course-container">
    <div class="course-hero-grid">
      <div>
        <div class="course-badge">🎓 +5.000 alunos • Certificado incluso</div>
        <h1 class="course-title">
          Domine <span>Marketing Digital</span> e Multiplique Seus Resultados
        </h1>
        <p class="course-desc">
          O método passo a passo usado por profissionais de alto nível que já gerou milhões em resultados para empresas de todos os tamanhos.
        </p>
        <ul class="course-hero-benefits">
          <li><span class="course-check">✓</span> +80 horas de conteúdo prático em vídeo HD</li>
          <li><span class="course-check">✓</span> Acesso vitalício + Todas as atualizações futuras</li>
          <li><span class="course-check">✓</span> Comunidade exclusiva no Discord com 5.000+ alunos</li>
          <li><span class="course-check">✓</span> 7 dias de garantia incondicional</li>
        </ul>
        <a href="#preco" class="course-hero-btn">QUERO ME INSCREVER AGORA →</a>
      </div>
      <div class="course-video">
        <img src="https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=800&h=450&fit=crop" class="course-video-thumb" alt="Assista a aula gratuita" />
        <div class="course-video-play">▶</div>
      </div>
    </div>
  </div>
</section>

<!-- PROBLEM -->
<section class="course-problem">
  <div class="course-container">
    <div class="course-problem-header">
      <div class="course-problem-label">Você se identifica?</div>
      <h2 class="course-problem-title">Os 3 maiores erros de quem quer crescer online</h2>
      <p class="course-problem-subtitle">Se você está cometendo algum desses erros, está deixando dinheiro na mesa todos os dias.</p>
    </div>
    <div class="course-problem-grid">
      <div class="course-problem-card">
        <div class="course-problem-icon">😰</div>
        <h3 class="course-problem-card-title">Gastar sem retorno</h3>
        <p class="course-problem-card-desc">Investir em anúncios sem estratégia e ver o dinheiro desaparecer sem gerar vendas ou leads qualificados.</p>
      </div>
      <div class="course-problem-card">
        <div class="course-problem-icon">😵</div>
        <h3 class="course-problem-card-title">Informação demais</h3>
        <p class="course-problem-card-desc">Consumir conteúdo gratuito desorganizado que só gera mais confusão e paralisia por análise.</p>
      </div>
      <div class="course-problem-card">
        <div class="course-problem-icon">😤</div>
        <h3 class="course-problem-card-title">Resultados lentos</h3>
        <p class="course-problem-card-desc">Trabalhar meses sem ver crescimento porque não sabe exatamente o que fazer e em qual ordem.</p>
      </div>
    </div>
  </div>
</section>

<!-- SOLUTION -->
<section class="course-solution">
  <div class="course-container">
    <div class="course-solution-header">
      <div class="course-solution-label">A transformação</div>
      <h2 class="course-solution-title">O que você vai conquistar</h2>
      <p class="course-solution-subtitle">Não é só sobre aprender marketing. É sobre transformar seu negócio e sua vida.</p>
    </div>
    <div class="course-solution-grid">
      <div class="course-solution-card">
        <div class="course-solution-icon">🎯</div>
        <h3 class="course-solution-card-title">Estratégia Clara</h3>
        <p class="course-solution-card-desc">Plano de ação definido para cada etapa do crescimento</p>
      </div>
      <div class="course-solution-card">
        <div class="course-solution-icon">💰</div>
        <h3 class="course-solution-card-title">ROI Positivo</h3>
        <p class="course-solution-card-desc">Campanhas que geram mais do que custam desde o início</p>
      </div>
      <div class="course-solution-card">
        <div class="course-solution-icon">📈</div>
        <h3 class="course-solution-card-title">Escala Previsível</h3>
        <p class="course-solution-card-desc">Sistema replicável para crescer de forma consistente</p>
      </div>
      <div class="course-solution-card">
        <div class="course-solution-icon">🏆</div>
        <h3 class="course-solution-card-title">Autoridade</h3>
        <p class="course-solution-card-desc">Posicionamento como referência no seu mercado</p>
      </div>
    </div>
  </div>
</section>

<!-- INSTRUCTOR -->
<section class="course-instructor">
  <div class="course-container">
    <div class="course-instructor-grid">
      <img src="https://images.unsplash.com/photo-1560250097-0b93528c311a?w=500&h=500&fit=crop" class="course-instructor-img" alt="Professor" />
      <div>
        <div class="course-instructor-label">Seu mentor</div>
        <h2 class="course-instructor-name">Ricardo Oliveira</h2>
        <p class="course-instructor-role">Especialista em Marketing Digital & Growth</p>
        <p class="course-instructor-bio">
          Com mais de 12 anos de experiência em marketing digital, Ricardo já ajudou mais de 500 empresas a escalarem seus negócios online. Foi head de marketing em startups que juntas captaram mais de R$50 milhões em investimentos. Hoje dedica seu tempo a formar a nova geração de profissionais de marketing através deste curso.
        </p>
        <div class="course-instructor-stats">
          <div>
            <div class="course-instructor-stat-value">500+</div>
            <div class="course-instructor-stat-label">Empresas atendidas</div>
          </div>
          <div>
            <div class="course-instructor-stat-value">R$50M+</div>
            <div class="course-instructor-stat-label">Gerados em vendas</div>
          </div>
          <div>
            <div class="course-instructor-stat-value">12 anos</div>
            <div class="course-instructor-stat-label">De experiência</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- MODULES -->
<section class="course-modules">
  <div class="course-container">
    <div class="course-modules-header">
      <div class="course-modules-label">Conteúdo Completo</div>
      <h2 class="course-modules-title">O que você vai aprender</h2>
      <p class="course-modules-subtitle">8 módulos • 80+ aulas • 40+ horas de conteúdo prático</p>
    </div>
    <div class="course-modules-grid">
      <div class="course-module">
        <div class="course-module-num">1</div>
        <div>
          <h3 class="course-module-title">Fundamentos do Marketing Digital</h3>
          <p class="course-module-desc">Entenda os pilares, monte sua estratégia do zero e defina seu público ideal.</p>
          <span class="course-module-lessons">📹 12 aulas • 4h de conteúdo</span>
        </div>
      </div>
      <div class="course-module">
        <div class="course-module-num">2</div>
        <div>
          <h3 class="course-module-title">Tráfego Pago: Meta Ads</h3>
          <p class="course-module-desc">Domine Facebook e Instagram Ads: criação, segmentação, otimização e escala.</p>
          <span class="course-module-lessons">📹 15 aulas • 6h de conteúdo</span>
        </div>
      </div>
      <div class="course-module">
        <div class="course-module-num">3</div>
        <div>
          <h3 class="course-module-title">Tráfego Pago: Google Ads</h3>
          <p class="course-module-desc">Search, Display, YouTube e Performance Max. Do básico ao avançado.</p>
          <span class="course-module-lessons">📹 14 aulas • 5h de conteúdo</span>
        </div>
      </div>
      <div class="course-module">
        <div class="course-module-num">4</div>
        <div>
          <h3 class="course-module-title">SEO e Tráfego Orgânico</h3>
          <p class="course-module-desc">Posicione seu site no topo do Google e atraia visitantes gratuitos 24/7.</p>
          <span class="course-module-lessons">📹 10 aulas • 4h de conteúdo</span>
        </div>
      </div>
      <div class="course-module">
        <div class="course-module-num">5</div>
        <div>
          <h3 class="course-module-title">Copywriting & Persuasão</h3>
          <p class="course-module-desc">Escreva textos que vendem, convertam e criem conexão com seu público.</p>
          <span class="course-module-lessons">📹 10 aulas • 4h de conteúdo</span>
        </div>
      </div>
      <div class="course-module">
        <div class="course-module-num">6</div>
        <div>
          <h3 class="course-module-title">Landing Pages que Convertem</h3>
          <p class="course-module-desc">Estrutura, design e psicologia por trás de páginas que vendem.</p>
          <span class="course-module-lessons">📹 8 aulas • 3h de conteúdo</span>
        </div>
      </div>
      <div class="course-module">
        <div class="course-module-num">7</div>
        <div>
          <h3 class="course-module-title">E-mail Marketing & Automação</h3>
          <p class="course-module-desc">Crie funis automatizados que nutrem leads e geram vendas no piloto automático.</p>
          <span class="course-module-lessons">📹 8 aulas • 3h de conteúdo</span>
        </div>
      </div>
      <div class="course-module">
        <div class="course-module-num">8</div>
        <div>
          <h3 class="course-module-title">Analytics & Otimização</h3>
          <p class="course-module-desc">Meça, analise e otimize suas campanhas com dados reais para maximizar ROI.</p>
          <span class="course-module-lessons">📹 8 aulas • 4h de conteúdo</span>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- TESTIMONIALS -->
<section class="course-testimonials">
  <div class="course-container">
    <div class="course-testimonials-header">
      <div class="course-testimonials-label">Histórias reais</div>
      <h2 class="course-testimonials-title">O que nossos alunos dizem</h2>
    </div>
    <div class="course-testimonials-grid">
      <div class="course-testimonial">
        <div class="course-testimonial-stars">★★★★★</div>
        <p class="course-testimonial-quote">"Em 3 meses aplicando o método, saí de R$15k para R$85k de faturamento mensal. O curso se pagou 100x."</p>
        <div class="course-testimonial-author">
          <img src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop" class="course-testimonial-avatar" alt="Aluno" />
          <div>
            <div class="course-testimonial-name">Bruno Santos</div>
            <div class="course-testimonial-role">E-commerce de Moda</div>
          </div>
        </div>
        <span class="course-testimonial-result">+467% de faturamento</span>
      </div>
      <div class="course-testimonial">
        <div class="course-testimonial-stars">★★★★★</div>
        <p class="course-testimonial-quote">"Reduzi meu custo por lead de R$45 para R$8. Hoje gero 10x mais leads com o mesmo orçamento."</p>
        <div class="course-testimonial-author">
          <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop" class="course-testimonial-avatar" alt="Aluna" />
          <div>
            <div class="course-testimonial-name">Carla Mendes</div>
            <div class="course-testimonial-role">Consultoria B2B</div>
          </div>
        </div>
        <span class="course-testimonial-result">-82% no custo por lead</span>
      </div>
      <div class="course-testimonial">
        <div class="course-testimonial-stars">★★★★★</div>
        <p class="course-testimonial-quote">"Larguei meu emprego CLT e hoje faturo 4x mais trabalhando como gestor de tráfego freelancer."</p>
        <div class="course-testimonial-author">
          <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop" class="course-testimonial-avatar" alt="Aluno" />
          <div>
            <div class="course-testimonial-name">Lucas Ferreira</div>
            <div class="course-testimonial-role">Gestor de Tráfego</div>
          </div>
        </div>
        <span class="course-testimonial-result">4x mais renda</span>
      </div>
    </div>
  </div>
</section>

<!-- BONUS -->
<section class="course-bonus">
  <div class="course-container">
    <div class="course-bonus-header">
      <div class="course-bonus-label">Exclusivo</div>
      <h2 class="course-bonus-title">Bônus especiais inclusos</h2>
      <p class="course-bonus-subtitle">Mais de R$2.000 em bônus totalmente grátis para acelerar seus resultados</p>
    </div>
    <div class="course-bonus-grid">
      <div class="course-bonus-card">
        <div class="course-bonus-icon">📋</div>
        <h3 class="course-bonus-name">Pack de Templates</h3>
        <p class="course-bonus-desc">+50 templates de anúncios, landing pages e e-mails prontos para usar.</p>
        <span class="course-bonus-value">Valor: R$497</span>
      </div>
      <div class="course-bonus-card">
        <div class="course-bonus-icon">📊</div>
        <h3 class="course-bonus-name">Planilhas Profissionais</h3>
        <p class="course-bonus-desc">Dashboard de métricas, calculadora de ROI e planejador de campanhas.</p>
        <span class="course-bonus-value">Valor: R$297</span>
      </div>
      <div class="course-bonus-card">
        <div class="course-bonus-icon">🎓</div>
        <h3 class="course-bonus-name">Mentoria em Grupo</h3>
        <p class="course-bonus-desc">4 sessões ao vivo mensais para tirar dúvidas e fazer networking.</p>
        <span class="course-bonus-value">Valor: R$997</span>
      </div>
    </div>
  </div>
</section>

<!-- FAQ -->
<section class="course-faq">
  <div class="course-container">
    <div class="course-faq-header">
      <div class="course-faq-label">Dúvidas frequentes</div>
      <h2 class="course-faq-title">Perguntas comuns</h2>
    </div>
    <div class="course-faq-list">
      <div class="course-faq-item">
        <div class="course-faq-question">O curso é para iniciantes ou avançados?</div>
        <div class="course-faq-answer">O curso foi desenvolvido para atender desde iniciantes até profissionais que querem se atualizar. Começamos do básico e avançamos progressivamente até estratégias avançadas de escala.</div>
      </div>
      <div class="course-faq-item">
        <div class="course-faq-question">Por quanto tempo terei acesso ao curso?</div>
        <div class="course-faq-answer">Acesso vitalício! Uma vez inscrito, você terá acesso para sempre, incluindo todas as atualizações futuras sem custo adicional.</div>
      </div>
      <div class="course-faq-item">
        <div class="course-faq-question">E se eu não gostar do curso?</div>
        <div class="course-faq-answer">Você tem 7 dias de garantia incondicional. Se por qualquer motivo não ficar satisfeito, basta solicitar o reembolso e devolvemos 100% do valor, sem perguntas.</div>
      </div>
      <div class="course-faq-item">
        <div class="course-faq-question">Preciso de algum conhecimento prévio?</div>
        <div class="course-faq-answer">Não! O curso começa do zero absoluto. Você só precisa de um computador, internet e vontade de aprender.</div>
      </div>
      <div class="course-faq-item">
        <div class="course-faq-question">Recebo certificado ao concluir?</div>
        <div class="course-faq-answer">Sim! Ao completar todas as aulas, você recebe um certificado de conclusão reconhecido pelo mercado para adicionar ao seu LinkedIn e currículo.</div>
      </div>
    </div>
  </div>
</section>

<!-- PRICING -->
<section class="course-pricing" id="preco">
  <div class="course-container">
    <div class="course-pricing-header">
      <div class="course-pricing-label">Investimento</div>
      <h2 class="course-pricing-title">Comece sua transformação hoje</h2>
      <p class="course-pricing-subtitle">Tudo que você precisa para dominar marketing digital em um só lugar</p>
    </div>
    <div class="course-pricing-card">
      <div class="course-pricing-badge">-75% OFF</div>
      <h3 class="course-pricing-name">Acesso Completo + Bônus</h3>
      <ul class="course-pricing-includes">
        <li><span class="course-check">✓</span> 8 módulos completos (+80 aulas)</li>
        <li><span class="course-check">✓</span> Acesso vitalício + atualizações</li>
        <li><span class="course-check">✓</span> Comunidade exclusiva no Discord</li>
        <li><span class="course-check">✓</span> Certificado de conclusão</li>
        <li><span class="course-check">✓</span> +R$1.791 em bônus inclusos</li>
        <li><span class="course-check">✓</span> Suporte direto por 12 meses</li>
      </ul>
      <div class="course-pricing-old">De R$ 1.997</div>
      <div class="course-pricing-price"><span>R$</span>497</div>
      <p class="course-pricing-installments">ou 12x de R$ 49,70 sem juros</p>
      <button class="course-pricing-btn">GARANTIR MINHA VAGA AGORA →</button>
      <div class="course-pricing-guarantee">
        <div class="course-pricing-guarantee-icon">🔒</div>
        <span>7 dias de garantia incondicional • Pagamento 100% seguro</span>
      </div>
    </div>
  </div>
</section>

<!-- FINAL CTA -->
<section class="course-final">
  <div class="course-container">
    <h2 class="course-final-title">⏰ Oferta por tempo limitado</h2>
    <p class="course-final-desc">O desconto de 75% é válido apenas para as próximas 48 horas. Depois disso, o preço volta ao normal de R$1.997.</p>
    <a href="#preco" class="course-final-btn">QUERO COMEÇAR AGORA</a>
  </div>
</section>

<!-- FOOTER -->
<footer class="course-footer">
  <div class="course-container">
    <p class="course-footer-text">© 2024 Marketing Digital Pro. Todos os direitos reservados.</p>
    <div class="course-footer-links">
      <a href="#">Termos de Uso</a>
      <a href="#">Política de Privacidade</a>
      <a href="#">Contato</a>
    </div>
  </div>
</footer>
`,
    gjsCss: '',
    gjsComponents: '',
    gjsStyles: ''
  },

  // ============================================
  // 10. PORTFOLIO CRIATIVO
  // ============================================
  {
    id: 'portfolio-creative',
    name: 'Portfolio Criativo',
    description: 'Portfolio moderno para designers, fotógrafos e criativos',
    thumbnail: 'https://images.unsplash.com/photo-1561070791-2526d30994b5?w=400&h=300&fit=crop',
    category: 'agency',
    gjsHtml: `
<style>
  * { box-sizing: border-box; margin: 0; padding: 0; }

  /* BASE */
  .pf-page { background: #0a0a0a; min-height: 100vh; font-family: 'Inter', system-ui, sans-serif; }
  .pf-container { max-width: 1200px; margin: 0 auto; padding: 0 24px; }

  /* NAV */
  .pf-nav { padding: 24px 40px; display: flex; justify-content: space-between; align-items: center; position: fixed; top: 0; left: 0; right: 0; z-index: 100; background: rgba(10,10,10,0.8); backdrop-filter: blur(20px); }
  .pf-logo { font-size: 1.25rem; font-weight: 700; color: white; letter-spacing: -0.5px; }
  .pf-nav-links { display: flex; gap: 32px; }
  .pf-nav-link { color: #71717a; text-decoration: none; font-size: 14px; font-weight: 500; transition: color 0.2s; }
  .pf-nav-link:hover { color: white; }
  .pf-nav-btn { padding: 10px 24px; background: white; color: #0a0a0a; font-weight: 600; font-size: 14px; border-radius: 8px; text-decoration: none; }

  /* HERO */
  .pf-hero { padding: 160px 40px 100px; }
  .pf-hero-grid { display: grid; grid-template-columns: 1fr 400px; gap: 80px; align-items: center; }
  .pf-greeting { color: #71717a; font-size: 16px; margin-bottom: 16px; display: flex; align-items: center; gap: 8px; }
  .pf-status { display: inline-flex; align-items: center; gap: 6px; padding: 6px 12px; background: rgba(34, 197, 94, 0.1); border-radius: 100px; }
  .pf-status-dot { width: 8px; height: 8px; background: #22c55e; border-radius: 50%; animation: pulse 2s infinite; }
  @keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.5; } }
  .pf-status-text { color: #22c55e; font-size: 13px; font-weight: 500; }
  .pf-title { font-size: 4rem; font-weight: 800; color: white; line-height: 1.05; margin-bottom: 24px; letter-spacing: -0.03em; }
  .pf-title span { background: linear-gradient(135deg, #f472b6, #a78bfa); -webkit-background-clip: text; -webkit-text-fill-color: transparent; }
  .pf-desc { font-size: 1.2rem; color: #a1a1aa; line-height: 1.7; margin-bottom: 32px; }
  .pf-hero-ctas { display: flex; gap: 16px; }
  .pf-btn-primary { display: inline-flex; align-items: center; gap: 8px; padding: 16px 32px; background: white; color: #0a0a0a; font-weight: 700; font-size: 15px; border-radius: 12px; text-decoration: none; transition: transform 0.2s; }
  .pf-btn-primary:hover { transform: translateY(-2px); }
  .pf-btn-secondary { display: inline-flex; align-items: center; gap: 8px; padding: 16px 32px; background: transparent; color: white; font-weight: 600; font-size: 15px; border: 1px solid #333; border-radius: 12px; text-decoration: none; }
  .pf-hero-image { position: relative; }
  .pf-hero-image img { width: 100%; aspect-ratio: 1; object-fit: cover; border-radius: 24px; }
  .pf-hero-stats { display: flex; gap: 40px; margin-top: 48px; }
  .pf-stat-value { font-size: 2.5rem; font-weight: 800; color: white; }
  .pf-stat-label { color: #71717a; font-size: 14px; margin-top: 4px; }

  /* CLIENTS */
  .pf-clients { padding: 60px 40px; border-top: 1px solid #1a1a1a; border-bottom: 1px solid #1a1a1a; }
  .pf-clients-label { color: #52525b; font-size: 12px; text-transform: uppercase; letter-spacing: 2px; text-align: center; margin-bottom: 32px; }
  .pf-clients-logos { display: flex; justify-content: center; gap: 60px; flex-wrap: wrap; opacity: 0.4; }
  .pf-client-logo { font-size: 20px; font-weight: 700; color: white; }

  /* SERVICES */
  .pf-services { padding: 100px 40px; }
  .pf-section-header { text-align: center; margin-bottom: 60px; }
  .pf-section-label { color: #a78bfa; font-weight: 600; font-size: 13px; text-transform: uppercase; letter-spacing: 2px; margin-bottom: 16px; }
  .pf-section-title { font-size: 2.5rem; font-weight: 800; color: white; margin-bottom: 16px; }
  .pf-section-subtitle { color: #71717a; font-size: 1.1rem; max-width: 600px; margin: 0 auto; }
  .pf-services-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; }
  .pf-service { background: #111; border: 1px solid #1a1a1a; border-radius: 20px; padding: 40px 32px; transition: transform 0.2s, border-color 0.2s; }
  .pf-service:hover { transform: translateY(-4px); border-color: #333; }
  .pf-service-icon { width: 56px; height: 56px; background: linear-gradient(135deg, #a78bfa, #f472b6); border-radius: 14px; display: flex; align-items: center; justify-content: center; font-size: 24px; margin-bottom: 24px; }
  .pf-service-title { font-size: 1.25rem; font-weight: 700; color: white; margin-bottom: 12px; }
  .pf-service-desc { color: #71717a; font-size: 15px; line-height: 1.6; }

  /* WORK */
  .pf-work { padding: 100px 40px; background: #0f0f0f; }
  .pf-work-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 32px; }
  .pf-work-item { position: relative; border-radius: 24px; overflow: hidden; aspect-ratio: 4/3; cursor: pointer; }
  .pf-work-item img { width: 100%; height: 100%; object-fit: cover; transition: transform 0.5s; }
  .pf-work-item:hover img { transform: scale(1.08); }
  .pf-work-overlay { position: absolute; inset: 0; background: linear-gradient(transparent 40%, rgba(0,0,0,0.9)); display: flex; flex-direction: column; justify-content: flex-end; padding: 32px; }
  .pf-work-title { color: white; font-size: 1.5rem; font-weight: 700; margin-bottom: 8px; }
  .pf-work-cat { color: #a78bfa; font-size: 14px; font-weight: 500; }
  .pf-work-cta { text-align: center; margin-top: 48px; }
  .pf-work-btn { display: inline-flex; align-items: center; gap: 8px; padding: 16px 32px; background: transparent; color: white; font-weight: 600; border: 1px solid #333; border-radius: 12px; text-decoration: none; }

  /* ABOUT */
  .pf-about { padding: 100px 40px; }
  .pf-about-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: center; }
  .pf-about-image img { width: 100%; border-radius: 24px; }
  .pf-about-label { color: #a78bfa; font-weight: 600; font-size: 13px; text-transform: uppercase; letter-spacing: 2px; margin-bottom: 16px; }
  .pf-about-title { font-size: 2.5rem; font-weight: 800; color: white; margin-bottom: 24px; line-height: 1.2; }
  .pf-about-text { color: #a1a1aa; font-size: 1.1rem; line-height: 1.8; margin-bottom: 32px; }
  .pf-skills { display: flex; flex-wrap: wrap; gap: 12px; }
  .pf-skill { padding: 10px 20px; background: #1a1a1a; border-radius: 100px; color: #d4d4d4; font-size: 14px; font-weight: 500; }

  /* TESTIMONIALS */
  .pf-testimonials { padding: 100px 40px; background: #0f0f0f; }
  .pf-testimonials-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 24px; }
  .pf-testimonial { background: #111; border: 1px solid #1a1a1a; border-radius: 20px; padding: 40px; }
  .pf-testimonial-stars { color: #fbbf24; font-size: 16px; margin-bottom: 20px; letter-spacing: 2px; }
  .pf-testimonial-quote { color: #d4d4d4; font-size: 1.1rem; line-height: 1.7; font-style: italic; margin-bottom: 24px; }
  .pf-testimonial-author { display: flex; align-items: center; gap: 16px; }
  .pf-testimonial-avatar { width: 48px; height: 48px; border-radius: 50%; object-fit: cover; }
  .pf-testimonial-name { color: white; font-weight: 600; }
  .pf-testimonial-role { color: #71717a; font-size: 14px; }

  /* CONTACT */
  .pf-contact { padding: 100px 40px; }
  .pf-contact-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 80px; }
  .pf-contact-title { font-size: 3rem; font-weight: 800; color: white; margin-bottom: 24px; line-height: 1.1; }
  .pf-contact-desc { color: #71717a; font-size: 1.1rem; line-height: 1.7; margin-bottom: 40px; }
  .pf-contact-info { display: flex; flex-direction: column; gap: 24px; }
  .pf-contact-item { display: flex; align-items: center; gap: 16px; }
  .pf-contact-icon { width: 48px; height: 48px; background: #1a1a1a; border-radius: 12px; display: flex; align-items: center; justify-content: center; font-size: 20px; }
  .pf-contact-label { color: #71717a; font-size: 13px; }
  .pf-contact-value { color: white; font-size: 1rem; font-weight: 500; }
  .pf-form { background: #111; border: 1px solid #1a1a1a; border-radius: 24px; padding: 40px; }
  .pf-form-group { margin-bottom: 24px; }
  .pf-form-label { display: block; color: #a1a1aa; font-size: 14px; font-weight: 500; margin-bottom: 8px; }
  .pf-form-input { width: 100%; padding: 16px; background: #1a1a1a; border: 1px solid #333; border-radius: 12px; color: white; font-size: 15px; outline: none; }
  .pf-form-input:focus { border-color: #a78bfa; }
  .pf-form-textarea { min-height: 120px; resize: vertical; }
  .pf-form-btn { width: 100%; padding: 18px; background: linear-gradient(135deg, #a78bfa, #f472b6); color: white; font-weight: 700; font-size: 16px; border: none; border-radius: 12px; cursor: pointer; transition: transform 0.2s; }
  .pf-form-btn:hover { transform: translateY(-2px); }

  /* FOOTER */
  .pf-footer { padding: 40px; border-top: 1px solid #1a1a1a; display: flex; justify-content: space-between; align-items: center; }
  .pf-footer-text { color: #52525b; font-size: 14px; }
  .pf-social { display: flex; gap: 16px; }
  .pf-social-link { width: 40px; height: 40px; background: #1a1a1a; border-radius: 10px; display: flex; align-items: center; justify-content: center; color: #71717a; text-decoration: none; font-size: 16px; transition: background 0.2s, color 0.2s; }
  .pf-social-link:hover { background: #333; color: white; }

  @media (max-width: 968px) {
    .pf-hero-grid { grid-template-columns: 1fr; }
    .pf-hero-image { order: -1; max-width: 300px; margin: 0 auto; }
    .pf-title { font-size: 2.75rem; }
    .pf-services-grid { grid-template-columns: 1fr; }
    .pf-work-grid { grid-template-columns: 1fr; }
    .pf-about-grid { grid-template-columns: 1fr; }
    .pf-testimonials-grid { grid-template-columns: 1fr; }
    .pf-contact-grid { grid-template-columns: 1fr; }
    .pf-nav-links { display: none; }
    .pf-footer { flex-direction: column; gap: 24px; text-align: center; }
  }
</style>

<div class="pf-page">
  <!-- NAV -->
  <nav class="pf-nav">
    <div class="pf-logo">João.design</div>
    <div class="pf-nav-links">
      <a href="#trabalhos" class="pf-nav-link">Trabalhos</a>
      <a href="#servicos" class="pf-nav-link">Serviços</a>
      <a href="#sobre" class="pf-nav-link">Sobre</a>
      <a href="#contato" class="pf-nav-link">Contato</a>
    </div>
    <a href="#contato" class="pf-nav-btn">Orçamento</a>
  </nav>

  <!-- HERO -->
  <section class="pf-hero">
    <div class="pf-container">
      <div class="pf-hero-grid">
        <div>
          <p class="pf-greeting">
            <span>Olá, eu sou João 👋</span>
            <span class="pf-status">
              <span class="pf-status-dot"></span>
              <span class="pf-status-text">Disponível para projetos</span>
            </span>
          </p>
          <h1 class="pf-title">
            Crio experiências digitais <span>memoráveis</span>
          </h1>
          <p class="pf-desc">
            Designer de produto com 8+ anos de experiência criando interfaces intuitivas e marcas impactantes para startups e empresas globais.
          </p>
          <div class="pf-hero-ctas">
            <a href="#contato" class="pf-btn-primary">Iniciar Projeto →</a>
            <a href="#trabalhos" class="pf-btn-secondary">Ver Portfolio</a>
          </div>
          <div class="pf-hero-stats">
            <div>
              <div class="pf-stat-value">150+</div>
              <div class="pf-stat-label">Projetos entregues</div>
            </div>
            <div>
              <div class="pf-stat-value">50+</div>
              <div class="pf-stat-label">Clientes satisfeitos</div>
            </div>
            <div>
              <div class="pf-stat-value">8 anos</div>
              <div class="pf-stat-label">De experiência</div>
            </div>
          </div>
        </div>
        <div class="pf-hero-image">
          <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=500&h=500&fit=crop" alt="João Designer" />
        </div>
      </div>
    </div>
  </section>

  <!-- CLIENTS -->
  <section class="pf-clients">
    <div class="pf-container">
      <p class="pf-clients-label">Trabalhei com empresas como</p>
      <div class="pf-clients-logos">
        <span class="pf-client-logo">Google</span>
        <span class="pf-client-logo">Nubank</span>
        <span class="pf-client-logo">iFood</span>
        <span class="pf-client-logo">Spotify</span>
        <span class="pf-client-logo">Uber</span>
      </div>
    </div>
  </section>

  <!-- SERVICES -->
  <section class="pf-services" id="servicos">
    <div class="pf-container">
      <div class="pf-section-header">
        <div class="pf-section-label">Serviços</div>
        <h2 class="pf-section-title">O que posso fazer por você</h2>
        <p class="pf-section-subtitle">Ofereço soluções completas de design para transformar sua visão em realidade</p>
      </div>
      <div class="pf-services-grid">
        <div class="pf-service">
          <div class="pf-service-icon">🎨</div>
          <h3 class="pf-service-title">UI/UX Design</h3>
          <p class="pf-service-desc">Interfaces intuitivas e experiências que encantam usuários e geram resultados para o seu negócio.</p>
        </div>
        <div class="pf-service">
          <div class="pf-service-icon">✨</div>
          <h3 class="pf-service-title">Branding</h3>
          <p class="pf-service-desc">Identidade visual completa: logo, cores, tipografia e todos os elementos que definem sua marca.</p>
        </div>
        <div class="pf-service">
          <div class="pf-service-icon">📱</div>
          <h3 class="pf-service-title">Design de Produto</h3>
          <p class="pf-service-desc">Do conceito ao lançamento, crio produtos digitais que resolvem problemas reais.</p>
        </div>
      </div>
    </div>
  </section>

  <!-- WORK -->
  <section class="pf-work" id="trabalhos">
    <div class="pf-container">
      <div class="pf-section-header">
        <div class="pf-section-label">Portfolio</div>
        <h2 class="pf-section-title">Trabalhos Selecionados</h2>
        <p class="pf-section-subtitle">Uma seleção dos meus melhores projetos recentes</p>
      </div>
      <div class="pf-work-grid">
        <div class="pf-work-item">
          <img src="https://images.unsplash.com/photo-1561070791-2526d30994b5?w=800&h=600&fit=crop" alt="Fintech App" />
          <div class="pf-work-overlay">
            <h3 class="pf-work-title">Fintech App Redesign</h3>
            <p class="pf-work-cat">UI/UX Design • Mobile</p>
          </div>
        </div>
        <div class="pf-work-item">
          <img src="https://images.unsplash.com/photo-1558655146-9f40138edfeb?w=800&h=600&fit=crop" alt="E-commerce" />
          <div class="pf-work-overlay">
            <h3 class="pf-work-title">E-commerce Premium</h3>
            <p class="pf-work-cat">Product Design • Web</p>
          </div>
        </div>
        <div class="pf-work-item">
          <img src="https://images.unsplash.com/photo-1586717791821-3f44a563fa4c?w=800&h=600&fit=crop" alt="Brand Identity" />
          <div class="pf-work-overlay">
            <h3 class="pf-work-title">Brand Identity System</h3>
            <p class="pf-work-cat">Branding • Visual Identity</p>
          </div>
        </div>
        <div class="pf-work-item">
          <img src="https://images.unsplash.com/photo-1545235617-9465d2a55698?w=800&h=600&fit=crop" alt="Banking App" />
          <div class="pf-work-overlay">
            <h3 class="pf-work-title">Digital Banking</h3>
            <p class="pf-work-cat">UI/UX Design • Fintech</p>
          </div>
        </div>
      </div>
      <div class="pf-work-cta">
        <a href="#" class="pf-work-btn">Ver todos os projetos →</a>
      </div>
    </div>
  </section>

  <!-- ABOUT -->
  <section class="pf-about" id="sobre">
    <div class="pf-container">
      <div class="pf-about-grid">
        <div class="pf-about-image">
          <img src="https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?w=600&h=700&fit=crop" alt="Sobre mim" />
        </div>
        <div>
          <div class="pf-about-label">Sobre mim</div>
          <h2 class="pf-about-title">Apaixonado por resolver problemas através do design</h2>
          <p class="pf-about-text">
            Sou designer de produto baseado em São Paulo, com mais de 8 anos de experiência criando soluções digitais que equilibram estética e funcionalidade.
            <br/><br/>
            Minha abordagem combina pesquisa de usuário, design thinking e atenção obsessiva aos detalhes. Acredito que bom design é invisível — ele simplesmente funciona.
            <br/><br/>
            Quando não estou desenhando interfaces, você me encontra fotografando a cidade, lendo sobre psicologia cognitiva ou experimentando novos restaurantes.
          </p>
          <div class="pf-skills">
            <span class="pf-skill">Figma</span>
            <span class="pf-skill">Design Systems</span>
            <span class="pf-skill">Prototyping</span>
            <span class="pf-skill">User Research</span>
            <span class="pf-skill">Branding</span>
            <span class="pf-skill">Motion Design</span>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- TESTIMONIALS -->
  <section class="pf-testimonials">
    <div class="pf-container">
      <div class="pf-section-header">
        <div class="pf-section-label">Depoimentos</div>
        <h2 class="pf-section-title">O que meus clientes dizem</h2>
      </div>
      <div class="pf-testimonials-grid">
        <div class="pf-testimonial">
          <div class="pf-testimonial-stars">★★★★★</div>
          <p class="pf-testimonial-quote">"João entendeu perfeitamente nossa visão e entregou um produto que superou todas as expectativas. Nosso app teve um aumento de 200% em retenção."</p>
          <div class="pf-testimonial-author">
            <img src="https://i.pravatar.cc/100?img=1" class="pf-testimonial-avatar" alt="Cliente" />
            <div>
              <div class="pf-testimonial-name">Marina Costa</div>
              <div class="pf-testimonial-role">CEO, TechStartup</div>
            </div>
          </div>
        </div>
        <div class="pf-testimonial">
          <div class="pf-testimonial-stars">★★★★★</div>
          <p class="pf-testimonial-quote">"Trabalhar com o João foi uma experiência incrível. Ele não apenas entrega design, mas estratégia. Nossa marca nunca esteve tão forte."</p>
          <div class="pf-testimonial-author">
            <img src="https://i.pravatar.cc/100?img=3" class="pf-testimonial-avatar" alt="Cliente" />
            <div>
              <div class="pf-testimonial-name">Rafael Mendes</div>
              <div class="pf-testimonial-role">Founder, E-commerce XYZ</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- CONTACT -->
  <section class="pf-contact" id="contato">
    <div class="pf-container">
      <div class="pf-contact-grid">
        <div>
          <h2 class="pf-contact-title">Vamos criar algo incrível juntos?</h2>
          <p class="pf-contact-desc">Estou sempre aberto a novos projetos e parcerias interessantes. Entre em contato e vamos conversar sobre como posso ajudar.</p>
          <div class="pf-contact-info">
            <div class="pf-contact-item">
              <div class="pf-contact-icon">📧</div>
              <div>
                <div class="pf-contact-label">Email</div>
                <div class="pf-contact-value">ola@joaodesign.com</div>
              </div>
            </div>
            <div class="pf-contact-item">
              <div class="pf-contact-icon">📱</div>
              <div>
                <div class="pf-contact-label">WhatsApp</div>
                <div class="pf-contact-value">+55 11 99999-9999</div>
              </div>
            </div>
            <div class="pf-contact-item">
              <div class="pf-contact-icon">📍</div>
              <div>
                <div class="pf-contact-label">Localização</div>
                <div class="pf-contact-value">São Paulo, Brasil</div>
              </div>
            </div>
          </div>
        </div>
        <div class="pf-form">
          <div class="pf-form-group">
            <label class="pf-form-label">Nome</label>
            <input type="text" class="pf-form-input" placeholder="Seu nome completo" />
          </div>
          <div class="pf-form-group">
            <label class="pf-form-label">Email</label>
            <input type="email" class="pf-form-input" placeholder="seu@email.com" />
          </div>
          <div class="pf-form-group">
            <label class="pf-form-label">Tipo de projeto</label>
            <input type="text" class="pf-form-input" placeholder="Ex: Redesign de app, branding..." />
          </div>
          <div class="pf-form-group">
            <label class="pf-form-label">Mensagem</label>
            <textarea class="pf-form-input pf-form-textarea" placeholder="Conte-me sobre seu projeto..."></textarea>
          </div>
          <button class="pf-form-btn">Enviar Mensagem →</button>
        </div>
      </div>
    </div>
  </section>

  <!-- FOOTER -->
  <footer class="pf-footer">
    <div class="pf-container" style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
      <p class="pf-footer-text">© 2024 João.design. Todos os direitos reservados.</p>
      <div class="pf-social">
        <a href="#" class="pf-social-link">📸</a>
        <a href="#" class="pf-social-link">💼</a>
        <a href="#" class="pf-social-link">🐦</a>
        <a href="#" class="pf-social-link">🎨</a>
      </div>
    </div>
  </footer>
</div>
`,
    gjsCss: '',
    gjsComponents: '',
    gjsStyles: ''
  },

  // ============================================
  // 11. AGÊNCIA DIGITAL
  // ============================================
  {
    id: 'agency-modern',
    name: 'Agência Digital',
    description: 'Landing page profissional para agências e consultorias',
    thumbnail: 'https://images.unsplash.com/photo-1497215728101-856f4ea42174?w=400&h=300&fit=crop',
    category: 'agency',
    gjsHtml: `
<style>
  * { box-sizing: border-box; margin: 0; padding: 0; }

  /* NAV */
  .ag-nav { padding: 20px 40px; display: flex; justify-content: space-between; align-items: center; background: rgba(255,255,255,0.95); backdrop-filter: blur(20px); position: fixed; top: 0; left: 0; right: 0; z-index: 100; border-bottom: 1px solid #f1f5f9; }
  .ag-logo { font-size: 1.5rem; font-weight: 800; color: #0f172a; }
  .ag-nav-links { display: flex; gap: 32px; }
  .ag-nav-link { color: #64748b; text-decoration: none; font-size: 14px; font-weight: 500; transition: color 0.2s; }
  .ag-nav-link:hover { color: #0f172a; }
  .ag-nav-btn { padding: 12px 24px; background: #0f172a; color: white; border-radius: 10px; text-decoration: none; font-weight: 600; font-size: 14px; transition: transform 0.2s; }
  .ag-nav-btn:hover { transform: translateY(-1px); }
  .ag-container { max-width: 1200px; margin: 0 auto; padding: 0 24px; }

  /* HERO */
  .ag-hero { padding: 160px 40px 100px; background: linear-gradient(180deg, #f8fafc 0%, #ffffff 100%); }
  .ag-hero-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 60px; align-items: center; }
  .ag-badge { display: inline-flex; align-items: center; gap: 8px; padding: 10px 20px; background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 100px; color: #16a34a; font-size: 13px; font-weight: 600; margin-bottom: 24px; }
  .ag-title { font-size: 3.5rem; font-weight: 800; color: #0f172a; line-height: 1.08; margin-bottom: 24px; letter-spacing: -0.03em; }
  .ag-title span { background: linear-gradient(135deg, #6366f1, #8b5cf6); -webkit-background-clip: text; -webkit-text-fill-color: transparent; }
  .ag-desc { font-size: 1.2rem; color: #64748b; line-height: 1.7; margin-bottom: 40px; }
  .ag-ctas { display: flex; gap: 16px; margin-bottom: 48px; }
  .ag-btn-primary { display: inline-flex; align-items: center; gap: 8px; padding: 18px 36px; background: #0f172a; color: white; font-weight: 700; font-size: 16px; border-radius: 12px; text-decoration: none; transition: all 0.2s; }
  .ag-btn-primary:hover { background: #1e293b; transform: translateY(-2px); }
  .ag-btn-secondary { display: inline-flex; align-items: center; gap: 8px; padding: 18px 36px; background: transparent; color: #0f172a; font-weight: 600; font-size: 16px; border: 2px solid #e2e8f0; border-radius: 12px; text-decoration: none; transition: all 0.2s; }
  .ag-btn-secondary:hover { border-color: #cbd5e1; }
  .ag-hero-stats { display: flex; gap: 48px; }
  .ag-stat-value { font-size: 2.5rem; font-weight: 800; color: #0f172a; }
  .ag-stat-label { color: #64748b; font-size: 14px; }
  .ag-hero-image { position: relative; }
  .ag-hero-image img { width: 100%; border-radius: 24px; box-shadow: 0 25px 80px rgba(0,0,0,0.12); }
  .ag-hero-float { position: absolute; background: white; border-radius: 16px; padding: 16px 20px; box-shadow: 0 10px 40px rgba(0,0,0,0.1); display: flex; align-items: center; gap: 12px; }
  .ag-hero-float-1 { top: 20%; left: -40px; }
  .ag-hero-float-2 { bottom: 20%; right: -40px; }
  .ag-float-icon { width: 40px; height: 40px; background: linear-gradient(135deg, #6366f1, #8b5cf6); border-radius: 10px; display: flex; align-items: center; justify-content: center; font-size: 18px; }
  .ag-float-text { font-size: 13px; color: #64748b; }
  .ag-float-value { font-size: 18px; font-weight: 700; color: #0f172a; }

  /* CLIENTS */
  .ag-clients { padding: 60px 40px; background: white; border-top: 1px solid #f1f5f9; border-bottom: 1px solid #f1f5f9; }
  .ag-clients-label { text-align: center; color: #94a3b8; font-size: 13px; text-transform: uppercase; letter-spacing: 2px; margin-bottom: 32px; }
  .ag-clients-logos { display: flex; justify-content: center; gap: 60px; flex-wrap: wrap; opacity: 0.4; }
  .ag-client-logo { font-size: 22px; font-weight: 700; color: #334155; }

  /* SERVICES */
  .ag-services { padding: 100px 40px; background: #f8fafc; }
  .ag-section-header { text-align: center; margin-bottom: 60px; }
  .ag-section-label { color: #6366f1; font-weight: 600; font-size: 13px; text-transform: uppercase; letter-spacing: 2px; margin-bottom: 16px; }
  .ag-section-title { font-size: 2.5rem; font-weight: 800; color: #0f172a; margin-bottom: 16px; }
  .ag-section-subtitle { color: #64748b; font-size: 1.1rem; max-width: 600px; margin: 0 auto; }
  .ag-services-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; }
  .ag-service { background: white; padding: 40px 32px; border-radius: 20px; border: 1px solid #e2e8f0; transition: all 0.3s; }
  .ag-service:hover { transform: translateY(-8px); box-shadow: 0 20px 40px rgba(0,0,0,0.08); border-color: transparent; }
  .ag-service-icon { width: 64px; height: 64px; background: linear-gradient(135deg, #6366f1, #8b5cf6); border-radius: 16px; display: flex; align-items: center; justify-content: center; font-size: 28px; margin-bottom: 24px; }
  .ag-service-title { font-size: 1.25rem; font-weight: 700; color: #0f172a; margin-bottom: 12px; }
  .ag-service-desc { color: #64748b; line-height: 1.7; font-size: 15px; }

  /* PORTFOLIO */
  .ag-portfolio { padding: 100px 40px; background: white; }
  .ag-portfolio-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; }
  .ag-portfolio-item { position: relative; border-radius: 20px; overflow: hidden; aspect-ratio: 4/3; cursor: pointer; }
  .ag-portfolio-item img { width: 100%; height: 100%; object-fit: cover; transition: transform 0.5s; }
  .ag-portfolio-item:hover img { transform: scale(1.08); }
  .ag-portfolio-overlay { position: absolute; inset: 0; background: linear-gradient(transparent 40%, rgba(15,23,42,0.9)); display: flex; flex-direction: column; justify-content: flex-end; padding: 32px; opacity: 0; transition: opacity 0.3s; }
  .ag-portfolio-item:hover .ag-portfolio-overlay { opacity: 1; }
  .ag-portfolio-cat { color: #a5b4fc; font-size: 13px; font-weight: 500; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 8px; }
  .ag-portfolio-title { color: white; font-size: 1.25rem; font-weight: 700; }

  /* PROCESS */
  .ag-process { padding: 100px 40px; background: #0f172a; }
  .ag-process .ag-section-label { color: #a5b4fc; }
  .ag-process .ag-section-title { color: white; }
  .ag-process .ag-section-subtitle { color: #94a3b8; }
  .ag-process-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 32px; }
  .ag-process-step { text-align: center; }
  .ag-process-num { width: 64px; height: 64px; background: linear-gradient(135deg, #6366f1, #8b5cf6); border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 1.5rem; font-weight: 800; color: white; margin: 0 auto 24px; }
  .ag-process-title { color: white; font-size: 1.1rem; font-weight: 700; margin-bottom: 12px; }
  .ag-process-desc { color: #94a3b8; font-size: 14px; line-height: 1.6; }

  /* TESTIMONIALS */
  .ag-testimonials { padding: 100px 40px; background: #f8fafc; }
  .ag-testimonials-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; }
  .ag-testimonial { background: white; padding: 32px; border-radius: 20px; border: 1px solid #e2e8f0; }
  .ag-testimonial-stars { color: #fbbf24; font-size: 16px; margin-bottom: 16px; letter-spacing: 2px; }
  .ag-testimonial-quote { color: #334155; font-size: 1rem; line-height: 1.7; margin-bottom: 24px; }
  .ag-testimonial-author { display: flex; align-items: center; gap: 12px; }
  .ag-testimonial-avatar { width: 48px; height: 48px; border-radius: 50%; object-fit: cover; }
  .ag-testimonial-name { font-weight: 600; color: #0f172a; font-size: 15px; }
  .ag-testimonial-role { color: #64748b; font-size: 13px; }

  /* TEAM */
  .ag-team { padding: 100px 40px; background: white; }
  .ag-team-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 32px; }
  .ag-team-member { text-align: center; }
  .ag-team-photo { width: 100%; aspect-ratio: 1; border-radius: 20px; object-fit: cover; margin-bottom: 20px; filter: grayscale(100%); transition: filter 0.3s; }
  .ag-team-member:hover .ag-team-photo { filter: grayscale(0%); }
  .ag-team-name { font-size: 1.1rem; font-weight: 700; color: #0f172a; margin-bottom: 4px; }
  .ag-team-role { color: #6366f1; font-size: 14px; font-weight: 500; }

  /* CONTACT */
  .ag-contact { padding: 100px 40px; background: #f8fafc; }
  .ag-contact-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 80px; }
  .ag-contact-title { font-size: 2.5rem; font-weight: 800; color: #0f172a; margin-bottom: 24px; line-height: 1.2; }
  .ag-contact-desc { color: #64748b; font-size: 1.1rem; line-height: 1.7; margin-bottom: 40px; }
  .ag-contact-info { display: flex; flex-direction: column; gap: 24px; }
  .ag-contact-item { display: flex; align-items: center; gap: 16px; }
  .ag-contact-icon { width: 52px; height: 52px; background: white; border: 1px solid #e2e8f0; border-radius: 14px; display: flex; align-items: center; justify-content: center; font-size: 22px; }
  .ag-contact-label { color: #64748b; font-size: 13px; }
  .ag-contact-value { color: #0f172a; font-size: 1rem; font-weight: 600; }
  .ag-form { background: white; border-radius: 24px; padding: 40px; border: 1px solid #e2e8f0; }
  .ag-form-row { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; margin-bottom: 16px; }
  .ag-form-group { margin-bottom: 16px; }
  .ag-form-label { display: block; color: #334155; font-size: 14px; font-weight: 500; margin-bottom: 8px; }
  .ag-form-input { width: 100%; padding: 14px 16px; background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 10px; color: #0f172a; font-size: 15px; outline: none; transition: border-color 0.2s; }
  .ag-form-input:focus { border-color: #6366f1; }
  .ag-form-textarea { min-height: 120px; resize: vertical; }
  .ag-form-btn { width: 100%; padding: 18px; background: #0f172a; color: white; font-weight: 700; font-size: 16px; border: none; border-radius: 12px; cursor: pointer; transition: all 0.2s; }
  .ag-form-btn:hover { background: #1e293b; transform: translateY(-2px); }

  /* CTA */
  .ag-cta { padding: 100px 40px; background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%); text-align: center; }
  .ag-cta-title { font-size: 2.5rem; font-weight: 800; color: white; margin-bottom: 16px; }
  .ag-cta-desc { color: #e0e7ff; font-size: 1.2rem; margin-bottom: 40px; max-width: 600px; margin-left: auto; margin-right: auto; }
  .ag-cta-btn { display: inline-block; padding: 20px 48px; background: white; color: #6366f1; font-weight: 700; font-size: 18px; border-radius: 14px; text-decoration: none; transition: all 0.2s; }
  .ag-cta-btn:hover { transform: translateY(-3px); box-shadow: 0 15px 40px rgba(0,0,0,0.2); }

  /* FOOTER */
  .ag-footer { padding: 60px 40px 40px; background: #0f172a; }
  .ag-footer-grid { display: grid; grid-template-columns: 2fr 1fr 1fr 1fr; gap: 60px; margin-bottom: 60px; }
  .ag-footer-brand { font-size: 1.5rem; font-weight: 800; color: white; margin-bottom: 16px; }
  .ag-footer-desc { color: #64748b; font-size: 14px; line-height: 1.7; }
  .ag-footer-title { color: white; font-weight: 600; font-size: 15px; margin-bottom: 20px; }
  .ag-footer-links { list-style: none; }
  .ag-footer-links li { margin-bottom: 12px; }
  .ag-footer-links a { color: #64748b; text-decoration: none; font-size: 14px; transition: color 0.2s; }
  .ag-footer-links a:hover { color: white; }
  .ag-footer-bottom { padding-top: 40px; border-top: 1px solid #1e293b; display: flex; justify-content: space-between; align-items: center; }
  .ag-footer-copy { color: #64748b; font-size: 14px; }
  .ag-footer-social { display: flex; gap: 16px; }
  .ag-footer-social a { width: 40px; height: 40px; background: #1e293b; border-radius: 10px; display: flex; align-items: center; justify-content: center; color: #64748b; text-decoration: none; font-size: 16px; transition: all 0.2s; }
  .ag-footer-social a:hover { background: #6366f1; color: white; }

  @media (max-width: 968px) {
    .ag-hero-grid { grid-template-columns: 1fr; }
    .ag-title { font-size: 2.75rem; }
    .ag-services-grid { grid-template-columns: 1fr; }
    .ag-portfolio-grid { grid-template-columns: 1fr; }
    .ag-process-grid { grid-template-columns: repeat(2, 1fr); }
    .ag-testimonials-grid { grid-template-columns: 1fr; }
    .ag-team-grid { grid-template-columns: repeat(2, 1fr); }
    .ag-contact-grid { grid-template-columns: 1fr; }
    .ag-footer-grid { grid-template-columns: 1fr 1fr; }
    .ag-hero { padding: 120px 24px 60px; }
    .ag-nav-links { display: none; }
    .ag-hero-float { display: none; }
  }
</style>

<!-- NAV -->
<nav class="ag-nav">
  <div class="ag-logo">Studio.</div>
  <div class="ag-nav-links">
    <a href="#servicos" class="ag-nav-link">Serviços</a>
    <a href="#portfolio" class="ag-nav-link">Portfolio</a>
    <a href="#sobre" class="ag-nav-link">Sobre</a>
    <a href="#contato" class="ag-nav-link">Contato</a>
  </div>
  <a href="#contato" class="ag-nav-btn">Iniciar Projeto</a>
</nav>

<!-- HERO -->
<section class="ag-hero">
  <div class="ag-container">
    <div class="ag-hero-grid">
      <div>
        <div class="ag-badge">✨ Agência premiada 2024</div>
        <h1 class="ag-title">Transformamos marcas em experiências <span>memoráveis</span></h1>
        <p class="ag-desc">
          Somos uma agência de design e tecnologia que ajuda empresas a criar produtos digitais que as pessoas amam. Do conceito ao lançamento.
        </p>
        <div class="ag-ctas">
          <a href="#portfolio" class="ag-btn-primary">Ver Projetos →</a>
          <a href="#servicos" class="ag-btn-secondary">Nossos Serviços</a>
        </div>
        <div class="ag-hero-stats">
          <div>
            <div class="ag-stat-value">150+</div>
            <div class="ag-stat-label">Projetos entregues</div>
          </div>
          <div>
            <div class="ag-stat-value">50+</div>
            <div class="ag-stat-label">Clientes satisfeitos</div>
          </div>
          <div>
            <div class="ag-stat-value">8 anos</div>
            <div class="ag-stat-label">De mercado</div>
          </div>
        </div>
      </div>
      <div class="ag-hero-image">
        <img src="https://images.unsplash.com/photo-1497215728101-856f4ea42174?w=600&h=500&fit=crop" alt="Nossa equipe" />
        <div class="ag-hero-float ag-hero-float-1">
          <div class="ag-float-icon">🚀</div>
          <div>
            <div class="ag-float-text">Projetos ativos</div>
            <div class="ag-float-value">12</div>
          </div>
        </div>
        <div class="ag-hero-float ag-hero-float-2">
          <div class="ag-float-icon">⭐</div>
          <div>
            <div class="ag-float-text">Avaliação</div>
            <div class="ag-float-value">4.9/5</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- CLIENTS -->
<section class="ag-clients">
  <div class="ag-container">
    <p class="ag-clients-label">Empresas que confiam em nosso trabalho</p>
    <div class="ag-clients-logos">
      <span class="ag-client-logo">Google</span>
      <span class="ag-client-logo">Nubank</span>
      <span class="ag-client-logo">iFood</span>
      <span class="ag-client-logo">Magazine</span>
      <span class="ag-client-logo">Mercado Livre</span>
    </div>
  </div>
</section>

<!-- SERVICES -->
<section class="ag-services" id="servicos">
  <div class="ag-container">
    <div class="ag-section-header">
      <div class="ag-section-label">Nossos Serviços</div>
      <h2 class="ag-section-title">O que fazemos de melhor</h2>
      <p class="ag-section-subtitle">Oferecemos soluções completas para transformar sua presença digital</p>
    </div>
    <div class="ag-services-grid">
      <div class="ag-service">
        <div class="ag-service-icon">🎨</div>
        <h3 class="ag-service-title">Design de Produto</h3>
        <p class="ag-service-desc">Criamos interfaces intuitivas que encantam usuários e geram resultados mensuráveis para o seu negócio.</p>
      </div>
      <div class="ag-service">
        <div class="ag-service-icon">💻</div>
        <h3 class="ag-service-title">Desenvolvimento Web</h3>
        <p class="ag-service-desc">Sites e aplicações de alta performance com as melhores tecnologias do mercado.</p>
      </div>
      <div class="ag-service">
        <div class="ag-service-icon">📱</div>
        <h3 class="ag-service-title">Apps Mobile</h3>
        <p class="ag-service-desc">Aplicativos nativos e híbridos para iOS e Android com experiência impecável.</p>
      </div>
      <div class="ag-service">
        <div class="ag-service-icon">✨</div>
        <h3 class="ag-service-title">Branding</h3>
        <p class="ag-service-desc">Identidade visual completa que comunica os valores e diferencia sua marca.</p>
      </div>
      <div class="ag-service">
        <div class="ag-service-icon">📈</div>
        <h3 class="ag-service-title">Marketing Digital</h3>
        <p class="ag-service-desc">Estratégias de growth que trazem resultados reais e escaláveis.</p>
      </div>
      <div class="ag-service">
        <div class="ag-service-icon">🔧</div>
        <h3 class="ag-service-title">Consultoria</h3>
        <p class="ag-service-desc">Análise e planejamento estratégico para otimizar seus processos digitais.</p>
      </div>
    </div>
  </div>
</section>

<!-- PORTFOLIO -->
<section class="ag-portfolio" id="portfolio">
  <div class="ag-container">
    <div class="ag-section-header">
      <div class="ag-section-label">Portfolio</div>
      <h2 class="ag-section-title">Projetos em destaque</h2>
      <p class="ag-section-subtitle">Uma seleção dos nossos melhores trabalhos recentes</p>
    </div>
    <div class="ag-portfolio-grid">
      <div class="ag-portfolio-item">
        <img src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&h=450&fit=crop" alt="Projeto 1" />
        <div class="ag-portfolio-overlay">
          <div class="ag-portfolio-cat">Fintech</div>
          <h3 class="ag-portfolio-title">App Bancário Digital</h3>
        </div>
      </div>
      <div class="ag-portfolio-item">
        <img src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600&h=450&fit=crop" alt="Projeto 2" />
        <div class="ag-portfolio-overlay">
          <div class="ag-portfolio-cat">E-commerce</div>
          <h3 class="ag-portfolio-title">Plataforma de Moda</h3>
        </div>
      </div>
      <div class="ag-portfolio-item">
        <img src="https://images.unsplash.com/photo-1559136555-9303baea8ebd?w=600&h=450&fit=crop" alt="Projeto 3" />
        <div class="ag-portfolio-overlay">
          <div class="ag-portfolio-cat">SaaS</div>
          <h3 class="ag-portfolio-title">Dashboard Analytics</h3>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- PROCESS -->
<section class="ag-process">
  <div class="ag-container">
    <div class="ag-section-header">
      <div class="ag-section-label">Nosso Processo</div>
      <h2 class="ag-section-title">Como trabalhamos</h2>
      <p class="ag-section-subtitle">Um processo estruturado para entregar resultados excepcionais</p>
    </div>
    <div class="ag-process-grid">
      <div class="ag-process-step">
        <div class="ag-process-num">01</div>
        <h3 class="ag-process-title">Discovery</h3>
        <p class="ag-process-desc">Entendemos seu negócio, objetivos e desafios para criar a estratégia ideal.</p>
      </div>
      <div class="ag-process-step">
        <div class="ag-process-num">02</div>
        <h3 class="ag-process-title">Design</h3>
        <p class="ag-process-desc">Criamos protótipos e designs que equilibram estética e funcionalidade.</p>
      </div>
      <div class="ag-process-step">
        <div class="ag-process-num">03</div>
        <h3 class="ag-process-title">Desenvolvimento</h3>
        <p class="ag-process-desc">Construímos a solução com as melhores práticas e tecnologias.</p>
      </div>
      <div class="ag-process-step">
        <div class="ag-process-num">04</div>
        <h3 class="ag-process-title">Lançamento</h3>
        <p class="ag-process-desc">Deploy, monitoramento e suporte contínuo para garantir o sucesso.</p>
      </div>
    </div>
  </div>
</section>

<!-- TESTIMONIALS -->
<section class="ag-testimonials">
  <div class="ag-container">
    <div class="ag-section-header">
      <div class="ag-section-label">Depoimentos</div>
      <h2 class="ag-section-title">O que nossos clientes dizem</h2>
    </div>
    <div class="ag-testimonials-grid">
      <div class="ag-testimonial">
        <div class="ag-testimonial-stars">★★★★★</div>
        <p class="ag-testimonial-quote">"A Studio entendeu perfeitamente nossa visão e entregou um produto que superou todas as expectativas. Nosso app teve um aumento de 200% em downloads."</p>
        <div class="ag-testimonial-author">
          <img src="https://i.pravatar.cc/100?img=1" class="ag-testimonial-avatar" alt="Cliente" />
          <div>
            <div class="ag-testimonial-name">Marina Costa</div>
            <div class="ag-testimonial-role">CEO, TechStartup</div>
          </div>
        </div>
      </div>
      <div class="ag-testimonial">
        <div class="ag-testimonial-stars">★★★★★</div>
        <p class="ag-testimonial-quote">"Profissionais excepcionais! O novo site aumentou nossa taxa de conversão em 150%. Parceria que vale cada centavo investido."</p>
        <div class="ag-testimonial-author">
          <img src="https://i.pravatar.cc/100?img=3" class="ag-testimonial-avatar" alt="Cliente" />
          <div>
            <div class="ag-testimonial-name">Rafael Mendes</div>
            <div class="ag-testimonial-role">CMO, E-commerce XYZ</div>
          </div>
        </div>
      </div>
      <div class="ag-testimonial">
        <div class="ag-testimonial-stars">★★★★★</div>
        <p class="ag-testimonial-quote">"Da identidade visual ao lançamento do app, a Studio cuidou de tudo. Resultado impecável e dentro do prazo."</p>
        <div class="ag-testimonial-author">
          <img src="https://i.pravatar.cc/100?img=5" class="ag-testimonial-avatar" alt="Cliente" />
          <div>
            <div class="ag-testimonial-name">Julia Santos</div>
            <div class="ag-testimonial-role">Founder, HealthApp</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- TEAM -->
<section class="ag-team" id="sobre">
  <div class="ag-container">
    <div class="ag-section-header">
      <div class="ag-section-label">Nossa Equipe</div>
      <h2 class="ag-section-title">As mentes por trás da magia</h2>
      <p class="ag-section-subtitle">Uma equipe multidisciplinar apaixonada por criar experiências incríveis</p>
    </div>
    <div class="ag-team-grid">
      <div class="ag-team-member">
        <img src="https://images.unsplash.com/photo-1560250097-0b93528c311a?w=300&h=300&fit=crop" class="ag-team-photo" alt="Membro" />
        <h3 class="ag-team-name">Lucas Oliveira</h3>
        <p class="ag-team-role">CEO & Founder</p>
      </div>
      <div class="ag-team-member">
        <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=300&h=300&fit=crop" class="ag-team-photo" alt="Membro" />
        <h3 class="ag-team-name">Ana Beatriz</h3>
        <p class="ag-team-role">Design Lead</p>
      </div>
      <div class="ag-team-member">
        <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=300&h=300&fit=crop" class="ag-team-photo" alt="Membro" />
        <h3 class="ag-team-name">Pedro Santos</h3>
        <p class="ag-team-role">Tech Lead</p>
      </div>
      <div class="ag-team-member">
        <img src="https://images.unsplash.com/photo-1580489944761-15a19d654956?w=300&h=300&fit=crop" class="ag-team-photo" alt="Membro" />
        <h3 class="ag-team-name">Carla Mendes</h3>
        <p class="ag-team-role">Project Manager</p>
      </div>
    </div>
  </div>
</section>

<!-- CONTACT -->
<section class="ag-contact" id="contato">
  <div class="ag-container">
    <div class="ag-contact-grid">
      <div>
        <h2 class="ag-contact-title">Vamos criar algo incrível juntos?</h2>
        <p class="ag-contact-desc">Conte-nos sobre seu projeto e descubra como podemos ajudar a transformar sua visão em realidade.</p>
        <div class="ag-contact-info">
          <div class="ag-contact-item">
            <div class="ag-contact-icon">📧</div>
            <div>
              <div class="ag-contact-label">Email</div>
              <div class="ag-contact-value">contato@studio.com.br</div>
            </div>
          </div>
          <div class="ag-contact-item">
            <div class="ag-contact-icon">📱</div>
            <div>
              <div class="ag-contact-label">Telefone</div>
              <div class="ag-contact-value">+55 11 99999-9999</div>
            </div>
          </div>
          <div class="ag-contact-item">
            <div class="ag-contact-icon">📍</div>
            <div>
              <div class="ag-contact-label">Endereço</div>
              <div class="ag-contact-value">São Paulo, SP - Brasil</div>
            </div>
          </div>
        </div>
      </div>
      <div class="ag-form">
        <div class="ag-form-row">
          <div class="ag-form-group">
            <label class="ag-form-label">Nome</label>
            <input type="text" class="ag-form-input" placeholder="Seu nome" />
          </div>
          <div class="ag-form-group">
            <label class="ag-form-label">Email</label>
            <input type="email" class="ag-form-input" placeholder="seu@email.com" />
          </div>
        </div>
        <div class="ag-form-group">
          <label class="ag-form-label">Tipo de projeto</label>
          <input type="text" class="ag-form-input" placeholder="Ex: App, Site, Branding..." />
        </div>
        <div class="ag-form-group">
          <label class="ag-form-label">Mensagem</label>
          <textarea class="ag-form-input ag-form-textarea" placeholder="Conte-nos sobre seu projeto..."></textarea>
        </div>
        <button class="ag-form-btn">Enviar Mensagem →</button>
      </div>
    </div>
  </div>
</section>

<!-- CTA -->
<section class="ag-cta">
  <div class="ag-container">
    <h2 class="ag-cta-title">Pronto para começar seu projeto?</h2>
    <p class="ag-cta-desc">Agende uma conversa gratuita de 30 minutos para discutir suas ideias e como podemos ajudar.</p>
    <a href="#contato" class="ag-cta-btn">Agendar Conversa Grátis</a>
  </div>
</section>

<!-- FOOTER -->
<footer class="ag-footer">
  <div class="ag-container">
    <div class="ag-footer-grid">
      <div>
        <div class="ag-footer-brand">Studio.</div>
        <p class="ag-footer-desc">Transformamos ideias em produtos digitais que as pessoas amam. Design, tecnologia e estratégia sob medida.</p>
      </div>
      <div>
        <h4 class="ag-footer-title">Serviços</h4>
        <ul class="ag-footer-links">
          <li><a href="#">Design de Produto</a></li>
          <li><a href="#">Desenvolvimento Web</a></li>
          <li><a href="#">Apps Mobile</a></li>
          <li><a href="#">Branding</a></li>
        </ul>
      </div>
      <div>
        <h4 class="ag-footer-title">Empresa</h4>
        <ul class="ag-footer-links">
          <li><a href="#">Sobre nós</a></li>
          <li><a href="#">Portfolio</a></li>
          <li><a href="#">Blog</a></li>
          <li><a href="#">Carreiras</a></li>
        </ul>
      </div>
      <div>
        <h4 class="ag-footer-title">Contato</h4>
        <ul class="ag-footer-links">
          <li><a href="#">contato@studio.com.br</a></li>
          <li><a href="#">+55 11 99999-9999</a></li>
          <li><a href="#">São Paulo, SP</a></li>
        </ul>
      </div>
    </div>
    <div class="ag-footer-bottom">
      <p class="ag-footer-copy">© 2024 Studio. Todos os direitos reservados.</p>
      <div class="ag-footer-social">
        <a href="#">📸</a>
        <a href="#">💼</a>
        <a href="#">🐦</a>
        <a href="#">🎨</a>
      </div>
    </div>
  </div>
</footer>
`,
    gjsCss: '',
    gjsComponents: '',
    gjsStyles: ''
  },

  // ============================================
  // 12. E-COMMERCE PRODUTO
  // ============================================
  {
    id: 'ecommerce-product',
    name: 'E-commerce Produto',
    description: 'Página de produto para lojas virtuais',
    thumbnail: 'https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=400&h=300&fit=crop',
    category: 'ecommerce',
    gjsHtml: `
<style>
  * { box-sizing: border-box; margin: 0; padding: 0; }
  .ec-hero { padding: 60px 24px; background: #fafafa; min-height: 100vh; }
  .ec-container { max-width: 1200px; margin: 0 auto; }
  .ec-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: start; }
  .ec-gallery { position: sticky; top: 40px; }
  .ec-main-img { width: 100%; border-radius: 24px; background: white; overflow: hidden; margin-bottom: 16px; }
  .ec-main-img img { width: 100%; aspect-ratio: 1; object-fit: cover; }
  .ec-thumbs { display: flex; gap: 12px; }
  .ec-thumb { width: 80px; height: 80px; border-radius: 12px; overflow: hidden; cursor: pointer; border: 2px solid transparent; }
  .ec-thumb.active { border-color: #0f172a; }
  .ec-thumb img { width: 100%; height: 100%; object-fit: cover; }
  .ec-info { padding-top: 20px; }
  .ec-badge { display: inline-block; padding: 6px 12px; background: #dcfce7; color: #16a34a; font-size: 12px; font-weight: 600; border-radius: 6px; margin-bottom: 16px; }
  .ec-title { font-size: 2.5rem; font-weight: 800; color: #0f172a; margin-bottom: 16px; line-height: 1.2; }
  .ec-rating { display: flex; align-items: center; gap: 12px; margin-bottom: 24px; }
  .ec-stars { color: #fbbf24; font-size: 18px; }
  .ec-reviews { color: #64748b; font-size: 14px; }
  .ec-price { margin-bottom: 32px; }
  .ec-price-current { font-size: 2.5rem; font-weight: 800; color: #0f172a; }
  .ec-price-old { font-size: 1.25rem; color: #94a3b8; text-decoration: line-through; margin-left: 12px; }
  .ec-price-save { display: inline-block; padding: 4px 10px; background: #fef2f2; color: #dc2626; font-size: 13px; font-weight: 600; border-radius: 6px; margin-left: 12px; }
  .ec-desc { color: #64748b; line-height: 1.7; margin-bottom: 32px; font-size: 1.05rem; }
  .ec-options { margin-bottom: 32px; }
  .ec-option-label { font-weight: 600; color: #0f172a; margin-bottom: 12px; font-size: 14px; }
  .ec-colors { display: flex; gap: 12px; }
  .ec-color { width: 40px; height: 40px; border-radius: 50%; cursor: pointer; border: 3px solid transparent; }
  .ec-color.active { border-color: #0f172a; }
  .ec-btn-buy { width: 100%; padding: 20px; background: #0f172a; color: white; font-weight: 700; font-size: 18px; border: none; border-radius: 14px; cursor: pointer; margin-bottom: 16px; }
  .ec-btn-cart { width: 100%; padding: 20px; background: white; color: #0f172a; font-weight: 600; font-size: 18px; border: 2px solid #e2e8f0; border-radius: 14px; cursor: pointer; }
  .ec-trust { display: flex; gap: 24px; margin-top: 32px; padding-top: 32px; border-top: 1px solid #e2e8f0; }
  .ec-trust-item { display: flex; align-items: center; gap: 8px; color: #64748b; font-size: 14px; }
  @media (max-width: 968px) {
    .ec-grid { grid-template-columns: 1fr; gap: 40px; }
    .ec-gallery { position: static; }
    .ec-title { font-size: 2rem; }
  }
</style>

<section class="ec-hero">
  <div class="ec-container">
    <div class="ec-grid">
      <div class="ec-gallery">
        <div class="ec-main-img">
          <img src="https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=800&h=800&fit=crop" alt="Product" />
        </div>
        <div class="ec-thumbs">
          <div class="ec-thumb active"><img src="https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=200&h=200&fit=crop" alt="Thumb" /></div>
          <div class="ec-thumb"><img src="https://images.unsplash.com/photo-1546868871-7041f2a55e12?w=200&h=200&fit=crop" alt="Thumb" /></div>
          <div class="ec-thumb"><img src="https://images.unsplash.com/photo-1585386959984-a4155224a1ad?w=200&h=200&fit=crop" alt="Thumb" /></div>
        </div>
      </div>
      <div class="ec-info">
        <div class="ec-badge">Em estoque</div>
        <h1 class="ec-title">Smart Watch Pro Series 5</h1>
        <div class="ec-rating">
          <span class="ec-stars">★★★★★</span>
          <span class="ec-reviews">4.9 (2.847 avaliações)</span>
        </div>
        <div class="ec-price">
          <span class="ec-price-current">R$ 899</span>
          <span class="ec-price-old">R$ 1.299</span>
          <span class="ec-price-save">-31%</span>
        </div>
        <p class="ec-desc">
          O smartwatch mais avançado do mercado. Monitor cardíaco, GPS integrado, resistente à água até 50m, bateria de 7 dias e mais de 100 modos de exercício.
        </p>
        <div class="ec-options">
          <div class="ec-option-label">Cor: Preto</div>
          <div class="ec-colors">
            <div class="ec-color active" style="background: #0f172a;"></div>
            <div class="ec-color" style="background: #f8fafc; border: 1px solid #e2e8f0;"></div>
            <div class="ec-color" style="background: #164e63;"></div>
          </div>
        </div>
        <button class="ec-btn-buy">Comprar Agora</button>
        <button class="ec-btn-cart">Adicionar ao Carrinho</button>
        <div class="ec-trust">
          <div class="ec-trust-item">🚚 Frete grátis</div>
          <div class="ec-trust-item">🔄 30 dias para troca</div>
          <div class="ec-trust-item">🔒 Compra segura</div>
        </div>
      </div>
    </div>
  </div>
</section>
`,
    gjsCss: '',
    gjsComponents: '',
    gjsStyles: ''
  },

  // ============================================
  // 13. CLÍNICA / SAÚDE
  // ============================================
  {
    id: 'clinic-health',
    name: 'Clínica & Saúde',
    description: 'Landing page profissional para clínicas e profissionais de saúde',
    thumbnail: 'https://images.unsplash.com/photo-1631217868264-e5b90bb7e133?w=400&h=300&fit=crop',
    category: 'agency',
    gjsHtml: `
<style>
  * { box-sizing: border-box; margin: 0; padding: 0; }

  /* Navigation */
  .cli-nav { position: fixed; top: 0; left: 0; right: 0; z-index: 100; padding: 16px 24px; background: rgba(255,255,255,0.95); backdrop-filter: blur(10px); border-bottom: 1px solid rgba(0,0,0,0.05); }
  .cli-nav-container { max-width: 1200px; margin: 0 auto; display: flex; align-items: center; justify-content: space-between; }
  .cli-nav-logo { font-size: 1.5rem; font-weight: 800; color: #0d9488; text-decoration: none; display: flex; align-items: center; gap: 8px; }
  .cli-nav-links { display: flex; gap: 32px; }
  .cli-nav-link { color: #475569; font-weight: 500; text-decoration: none; font-size: 15px; transition: color 0.2s; }
  .cli-nav-link:hover { color: #0d9488; }
  .cli-nav-cta { padding: 12px 24px; background: #0d9488; color: white; font-weight: 600; border-radius: 10px; text-decoration: none; font-size: 14px; }

  /* Hero */
  .cli-hero { padding: 140px 24px 100px; background: linear-gradient(135deg, #ecfeff 0%, #f0fdfa 100%); }
  .cli-container { max-width: 1200px; margin: 0 auto; }
  .cli-hero-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: center; }
  .cli-badge { display: inline-flex; align-items: center; gap: 8px; padding: 10px 20px; background: white; border-radius: 100px; color: #0d9488; font-size: 14px; font-weight: 600; margin-bottom: 24px; box-shadow: 0 2px 8px rgba(0,0,0,0.06); }
  .cli-title { font-size: 3.5rem; font-weight: 800; color: #0f172a; line-height: 1.1; margin-bottom: 24px; }
  .cli-title span { color: #0d9488; }
  .cli-desc { font-size: 1.2rem; color: #64748b; line-height: 1.7; margin-bottom: 32px; }
  .cli-ctas { display: flex; gap: 16px; flex-wrap: wrap; }
  .cli-btn-primary { padding: 18px 36px; background: #0d9488; color: white; font-weight: 700; font-size: 16px; border-radius: 12px; text-decoration: none; display: inline-flex; align-items: center; gap: 8px; transition: transform 0.2s, box-shadow 0.2s; }
  .cli-btn-primary:hover { transform: translateY(-2px); box-shadow: 0 10px 30px rgba(13,148,136,0.3); }
  .cli-btn-secondary { padding: 18px 36px; background: white; color: #0f172a; font-weight: 600; font-size: 16px; border: 2px solid #e2e8f0; border-radius: 12px; text-decoration: none; }
  .cli-hero-image { position: relative; }
  .cli-hero-image img { width: 100%; border-radius: 24px; box-shadow: 0 25px 50px rgba(0,0,0,0.1); }
  .cli-hero-badge { position: absolute; bottom: -20px; left: -20px; background: white; padding: 16px 24px; border-radius: 16px; box-shadow: 0 10px 30px rgba(0,0,0,0.1); display: flex; align-items: center; gap: 12px; }
  .cli-hero-badge-icon { width: 48px; height: 48px; background: #dcfce7; border-radius: 12px; display: flex; align-items: center; justify-content: center; font-size: 24px; }
  .cli-hero-badge-text { font-weight: 700; color: #0f172a; }
  .cli-hero-badge-sub { font-size: 13px; color: #64748b; }

  /* Features */
  .cli-features { padding: 100px 24px; background: white; }
  .cli-features-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 32px; text-align: center; }
  .cli-feature-icon { width: 72px; height: 72px; background: linear-gradient(135deg, #ccfbf1, #99f6e4); border-radius: 20px; display: flex; align-items: center; justify-content: center; margin: 0 auto 20px; font-size: 32px; }
  .cli-feature-title { font-size: 1.1rem; font-weight: 700; color: #0f172a; margin-bottom: 8px; }
  .cli-feature-desc { color: #64748b; font-size: 14px; line-height: 1.6; }

  /* About */
  .cli-about { padding: 100px 24px; background: #f8fafc; }
  .cli-about-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: center; }
  .cli-about-images { position: relative; }
  .cli-about-img1 { width: 80%; border-radius: 20px; box-shadow: 0 20px 40px rgba(0,0,0,0.1); }
  .cli-about-img2 { position: absolute; bottom: -40px; right: 0; width: 60%; border-radius: 16px; box-shadow: 0 15px 30px rgba(0,0,0,0.15); border: 4px solid white; }
  .cli-about-label { color: #0d9488; font-weight: 600; font-size: 14px; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 12px; }
  .cli-about-title { font-size: 2.5rem; font-weight: 800; color: #0f172a; margin-bottom: 24px; line-height: 1.2; }
  .cli-about-text { color: #64748b; line-height: 1.8; margin-bottom: 24px; font-size: 1.05rem; }
  .cli-about-list { list-style: none; margin-bottom: 32px; }
  .cli-about-list li { display: flex; align-items: center; gap: 12px; padding: 12px 0; color: #334155; font-weight: 500; }
  .cli-about-list li span { width: 24px; height: 24px; background: #0d9488; border-radius: 50%; display: flex; align-items: center; justify-content: center; color: white; font-size: 14px; }

  /* Services */
  .cli-services { padding: 100px 24px; background: white; }
  .cli-services-header { text-align: center; margin-bottom: 60px; }
  .cli-services-label { color: #0d9488; font-weight: 600; font-size: 14px; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 12px; }
  .cli-services-title { font-size: 2.5rem; font-weight: 800; color: #0f172a; margin-bottom: 16px; }
  .cli-services-desc { color: #64748b; font-size: 1.1rem; max-width: 600px; margin: 0 auto; }
  .cli-services-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; }
  .cli-service { background: #f8fafc; padding: 32px; border-radius: 20px; text-align: center; transition: transform 0.3s, box-shadow 0.3s; border: 1px solid transparent; }
  .cli-service:hover { transform: translateY(-8px); box-shadow: 0 20px 40px rgba(0,0,0,0.1); border-color: #0d9488; background: white; }
  .cli-service-icon { width: 80px; height: 80px; background: linear-gradient(135deg, #0d9488, #14b8a6); border-radius: 20px; display: flex; align-items: center; justify-content: center; margin: 0 auto 24px; font-size: 36px; }
  .cli-service-title { font-size: 1.25rem; font-weight: 700; color: #0f172a; margin-bottom: 12px; }
  .cli-service-desc { color: #64748b; font-size: 14px; line-height: 1.6; margin-bottom: 20px; }
  .cli-service-link { color: #0d9488; font-weight: 600; text-decoration: none; display: inline-flex; align-items: center; gap: 6px; font-size: 14px; }

  /* Team */
  .cli-team { padding: 100px 24px; background: #f8fafc; }
  .cli-team-header { text-align: center; margin-bottom: 60px; }
  .cli-team-label { color: #0d9488; font-weight: 600; font-size: 14px; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 12px; }
  .cli-team-title { font-size: 2.5rem; font-weight: 800; color: #0f172a; margin-bottom: 16px; }
  .cli-team-desc { color: #64748b; font-size: 1.1rem; max-width: 600px; margin: 0 auto; }
  .cli-team-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 32px; }
  .cli-doctor { background: white; border-radius: 20px; overflow: hidden; box-shadow: 0 4px 20px rgba(0,0,0,0.06); text-align: center; transition: transform 0.3s; }
  .cli-doctor:hover { transform: translateY(-8px); }
  .cli-doctor-img { width: 100%; height: 280px; object-fit: cover; }
  .cli-doctor-info { padding: 24px; }
  .cli-doctor-name { font-size: 1.1rem; font-weight: 700; color: #0f172a; margin-bottom: 4px; }
  .cli-doctor-specialty { color: #0d9488; font-size: 14px; font-weight: 600; margin-bottom: 8px; }
  .cli-doctor-crm { color: #94a3b8; font-size: 13px; }

  /* Testimonials */
  .cli-testimonials { padding: 100px 24px; background: white; }
  .cli-testimonials-header { text-align: center; margin-bottom: 60px; }
  .cli-testimonials-label { color: #0d9488; font-weight: 600; font-size: 14px; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 12px; }
  .cli-testimonials-title { font-size: 2.5rem; font-weight: 800; color: #0f172a; }
  .cli-testimonials-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 32px; }
  .cli-testimonial { background: #f8fafc; padding: 32px; border-radius: 20px; }
  .cli-testimonial-stars { color: #fbbf24; font-size: 20px; margin-bottom: 16px; }
  .cli-testimonial-text { color: #475569; line-height: 1.7; margin-bottom: 24px; font-size: 15px; font-style: italic; }
  .cli-testimonial-author { display: flex; align-items: center; gap: 16px; }
  .cli-testimonial-avatar { width: 56px; height: 56px; border-radius: 50%; object-fit: cover; }
  .cli-testimonial-name { font-weight: 700; color: #0f172a; }
  .cli-testimonial-role { color: #64748b; font-size: 14px; }

  /* FAQ */
  .cli-faq { padding: 100px 24px; background: #f8fafc; }
  .cli-faq-header { text-align: center; margin-bottom: 60px; }
  .cli-faq-label { color: #0d9488; font-weight: 600; font-size: 14px; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 12px; }
  .cli-faq-title { font-size: 2.5rem; font-weight: 800; color: #0f172a; }
  .cli-faq-grid { max-width: 800px; margin: 0 auto; }
  .cli-faq-item { background: white; border-radius: 16px; padding: 24px 32px; margin-bottom: 16px; box-shadow: 0 2px 10px rgba(0,0,0,0.04); }
  .cli-faq-question { font-weight: 700; color: #0f172a; font-size: 1.1rem; margin-bottom: 12px; display: flex; align-items: center; gap: 12px; }
  .cli-faq-question span { color: #0d9488; }
  .cli-faq-answer { color: #64748b; line-height: 1.7; padding-left: 32px; }

  /* Contact */
  .cli-contact { padding: 100px 24px; background: white; }
  .cli-contact-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: start; }
  .cli-contact-label { color: #0d9488; font-weight: 600; font-size: 14px; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 12px; }
  .cli-contact-title { font-size: 2.5rem; font-weight: 800; color: #0f172a; margin-bottom: 24px; line-height: 1.2; }
  .cli-contact-text { color: #64748b; line-height: 1.7; margin-bottom: 40px; }
  .cli-contact-info { display: flex; flex-direction: column; gap: 24px; }
  .cli-contact-item { display: flex; align-items: flex-start; gap: 16px; }
  .cli-contact-icon { width: 56px; height: 56px; background: linear-gradient(135deg, #ccfbf1, #99f6e4); border-radius: 16px; display: flex; align-items: center; justify-content: center; font-size: 24px; flex-shrink: 0; }
  .cli-contact-item-title { font-weight: 700; color: #0f172a; margin-bottom: 4px; }
  .cli-contact-item-text { color: #64748b; font-size: 15px; }
  .cli-contact-form { background: #f8fafc; padding: 40px; border-radius: 24px; }
  .cli-form-title { font-size: 1.5rem; font-weight: 700; color: #0f172a; margin-bottom: 24px; }
  .cli-form-row { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; margin-bottom: 16px; }
  .cli-form-group { margin-bottom: 16px; }
  .cli-form-label { display: block; font-weight: 600; color: #334155; margin-bottom: 8px; font-size: 14px; }
  .cli-form-input { width: 100%; padding: 16px 20px; border: 2px solid #e2e8f0; border-radius: 12px; font-size: 16px; transition: border-color 0.2s; outline: none; }
  .cli-form-input:focus { border-color: #0d9488; }
  .cli-form-textarea { width: 100%; padding: 16px 20px; border: 2px solid #e2e8f0; border-radius: 12px; font-size: 16px; min-height: 120px; resize: vertical; outline: none; }
  .cli-form-textarea:focus { border-color: #0d9488; }
  .cli-form-select { width: 100%; padding: 16px 20px; border: 2px solid #e2e8f0; border-radius: 12px; font-size: 16px; background: white; outline: none; cursor: pointer; }
  .cli-form-btn { width: 100%; padding: 18px; background: #0d9488; color: white; font-weight: 700; font-size: 16px; border: none; border-radius: 12px; cursor: pointer; transition: background 0.2s; }
  .cli-form-btn:hover { background: #0f766e; }

  /* CTA */
  .cli-cta { padding: 100px 24px; background: linear-gradient(135deg, #0d9488, #14b8a6); text-align: center; position: relative; overflow: hidden; }
  .cli-cta::before { content: ''; position: absolute; top: -50%; right: -50%; width: 100%; height: 200%; background: radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 50%); }
  .cli-cta-title { font-size: 2.5rem; font-weight: 800; color: white; margin-bottom: 16px; position: relative; }
  .cli-cta-desc { color: rgba(255,255,255,0.9); font-size: 1.2rem; margin-bottom: 40px; max-width: 600px; margin-left: auto; margin-right: auto; position: relative; }
  .cli-cta-btn { padding: 20px 48px; background: white; color: #0d9488; font-weight: 700; font-size: 18px; border-radius: 12px; text-decoration: none; display: inline-block; position: relative; transition: transform 0.2s; }
  .cli-cta-btn:hover { transform: scale(1.05); }

  /* Footer */
  .cli-footer { padding: 80px 24px 40px; background: #0f172a; }
  .cli-footer-grid { display: grid; grid-template-columns: 2fr 1fr 1fr 1fr; gap: 60px; margin-bottom: 60px; }
  .cli-footer-logo { font-size: 1.5rem; font-weight: 800; color: white; margin-bottom: 16px; display: flex; align-items: center; gap: 8px; }
  .cli-footer-desc { color: #94a3b8; line-height: 1.7; margin-bottom: 24px; }
  .cli-footer-social { display: flex; gap: 12px; }
  .cli-footer-social a { width: 44px; height: 44px; background: rgba(255,255,255,0.1); border-radius: 12px; display: flex; align-items: center; justify-content: center; color: white; text-decoration: none; transition: background 0.2s; }
  .cli-footer-social a:hover { background: #0d9488; }
  .cli-footer-title { font-weight: 700; color: white; margin-bottom: 24px; font-size: 1.1rem; }
  .cli-footer-links { list-style: none; }
  .cli-footer-links li { margin-bottom: 12px; }
  .cli-footer-links a { color: #94a3b8; text-decoration: none; font-size: 15px; transition: color 0.2s; }
  .cli-footer-links a:hover { color: #0d9488; }
  .cli-footer-bottom { border-top: 1px solid rgba(255,255,255,0.1); padding-top: 40px; display: flex; justify-content: space-between; align-items: center; }
  .cli-footer-copy { color: #64748b; font-size: 14px; }
  .cli-footer-badges { display: flex; gap: 16px; }
  .cli-footer-badge { padding: 8px 16px; background: rgba(255,255,255,0.05); border-radius: 8px; color: #94a3b8; font-size: 13px; }

  @media (max-width: 968px) {
    .cli-nav-links { display: none; }
    .cli-hero { padding: 100px 24px 60px; }
    .cli-hero-grid { grid-template-columns: 1fr; gap: 40px; }
    .cli-title { font-size: 2.5rem; }
    .cli-features-grid { grid-template-columns: repeat(2, 1fr); }
    .cli-about-grid { grid-template-columns: 1fr; gap: 60px; }
    .cli-about-images { order: -1; }
    .cli-services-grid { grid-template-columns: 1fr; }
    .cli-team-grid { grid-template-columns: repeat(2, 1fr); }
    .cli-testimonials-grid { grid-template-columns: 1fr; }
    .cli-contact-grid { grid-template-columns: 1fr; }
    .cli-form-row { grid-template-columns: 1fr; }
    .cli-footer-grid { grid-template-columns: 1fr 1fr; gap: 40px; }
    .cli-footer-bottom { flex-direction: column; gap: 20px; text-align: center; }
  }
</style>

<!-- NAVIGATION -->
<nav class="cli-nav">
  <div class="cli-nav-container">
    <a href="#" class="cli-nav-logo">🏥 VidaClinic</a>
    <div class="cli-nav-links">
      <a href="#" class="cli-nav-link">Inicio</a>
      <a href="#" class="cli-nav-link">Sobre</a>
      <a href="#" class="cli-nav-link">Especialidades</a>
      <a href="#" class="cli-nav-link">Equipe</a>
      <a href="#" class="cli-nav-link">Contato</a>
    </div>
    <a href="#" class="cli-nav-cta">Agendar Consulta</a>
  </div>
</nav>

<!-- HERO -->
<section class="cli-hero">
  <div class="cli-container">
    <div class="cli-hero-grid">
      <div>
        <div class="cli-badge">🏥 Referencia em Saude desde 2008</div>
        <h1 class="cli-title">
          Cuidando da sua <span>saude</span> com excelencia e humanidade
        </h1>
        <p class="cli-desc">
          Equipe medica altamente especializada, tecnologia de ponta e atendimento humanizado.
          Sua saude merece o melhor cuidado - e nos estamos aqui para oferecer isso.
        </p>
        <div class="cli-ctas">
          <a href="#" class="cli-btn-primary">Agendar Consulta →</a>
          <a href="#" class="cli-btn-secondary">Conheca a Clinica</a>
        </div>
      </div>
      <div class="cli-hero-image">
        <img src="https://images.unsplash.com/photo-1631217868264-e5b90bb7e133?w=600&h=500&fit=crop" alt="Clinica moderna" />
        <div class="cli-hero-badge">
          <div class="cli-hero-badge-icon">✓</div>
          <div>
            <div class="cli-hero-badge-text">+50.000 pacientes</div>
            <div class="cli-hero-badge-sub">atendidos com sucesso</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- FEATURES -->
<section class="cli-features">
  <div class="cli-container">
    <div class="cli-features-grid">
      <div>
        <div class="cli-feature-icon">👨‍⚕️</div>
        <h3 class="cli-feature-title">+30 Especialistas</h3>
        <p class="cli-feature-desc">Medicos renomados em todas as especialidades</p>
      </div>
      <div>
        <div class="cli-feature-icon">🏆</div>
        <h3 class="cli-feature-title">15 Anos</h3>
        <p class="cli-feature-desc">De excelencia em cuidados com a saude</p>
      </div>
      <div>
        <div class="cli-feature-icon">⚡</div>
        <h3 class="cli-feature-title">Resultados 24h</h3>
        <p class="cli-feature-desc">Exames com resultados rapidos e precisos</p>
      </div>
      <div>
        <div class="cli-feature-icon">❤️</div>
        <h3 class="cli-feature-title">Atendimento Humanizado</h3>
        <p class="cli-feature-desc">Voce e tratado como parte da familia</p>
      </div>
    </div>
  </div>
</section>

<!-- ABOUT -->
<section class="cli-about">
  <div class="cli-container">
    <div class="cli-about-grid">
      <div class="cli-about-images">
        <img src="https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=500&h=600&fit=crop" class="cli-about-img1" alt="Clinica" />
        <img src="https://images.unsplash.com/photo-1582750433449-648ed127bb54?w=400&h=300&fit=crop" class="cli-about-img2" alt="Equipe medica" />
      </div>
      <div>
        <div class="cli-about-label">Sobre Nos</div>
        <h2 class="cli-about-title">Uma clinica pensada para o seu bem-estar</h2>
        <p class="cli-about-text">
          Fundada em 2008, a VidaClinic nasceu com o proposito de oferecer atendimento medico
          de alta qualidade com um diferencial: o cuidado humanizado. Acreditamos que a medicina
          vai alem dos diagnosticos - ela envolve acolhimento, respeito e empatia.
        </p>
        <p class="cli-about-text">
          Nossa estrutura moderna conta com equipamentos de ultima geracao e uma equipe
          multidisciplinar preparada para cuidar de voce e sua familia em todas as fases da vida.
        </p>
        <ul class="cli-about-list">
          <li><span>✓</span> Estrutura moderna e acessivel</li>
          <li><span>✓</span> Equipamentos de ultima geracao</li>
          <li><span>✓</span> Convenios com principais operadoras</li>
          <li><span>✓</span> Estacionamento gratuito</li>
        </ul>
        <a href="#" class="cli-btn-primary">Conheca Nossa Historia →</a>
      </div>
    </div>
  </div>
</section>

<!-- SERVICES -->
<section class="cli-services">
  <div class="cli-container">
    <div class="cli-services-header">
      <div class="cli-services-label">Especialidades</div>
      <h2 class="cli-services-title">Nossas Areas de Atuacao</h2>
      <p class="cli-services-desc">Oferecemos atendimento completo em diversas especialidades medicas com profissionais altamente qualificados.</p>
    </div>
    <div class="cli-services-grid">
      <div class="cli-service">
        <div class="cli-service-icon">❤️</div>
        <h3 class="cli-service-title">Cardiologia</h3>
        <p class="cli-service-desc">Diagnostico e tratamento de doencas cardiovasculares com tecnologia avancada e acompanhamento especializado.</p>
        <a href="#" class="cli-service-link">Saiba mais →</a>
      </div>
      <div class="cli-service">
        <div class="cli-service-icon">🧴</div>
        <h3 class="cli-service-title">Dermatologia</h3>
        <p class="cli-service-desc">Cuidados com a saude da pele, cabelos e unhas. Tratamentos esteticos e clinicos com resultados comprovados.</p>
        <a href="#" class="cli-service-link">Saiba mais →</a>
      </div>
      <div class="cli-service">
        <div class="cli-service-icon">🦴</div>
        <h3 class="cli-service-title">Ortopedia</h3>
        <p class="cli-service-desc">Tratamento de ossos, articulacoes e musculos. Reabilitacao completa e acompanhamento personalizado.</p>
        <a href="#" class="cli-service-link">Saiba mais →</a>
      </div>
      <div class="cli-service">
        <div class="cli-service-icon">👶</div>
        <h3 class="cli-service-title">Pediatria</h3>
        <p class="cli-service-desc">Cuidados completos para bebes, criancas e adolescentes. Ambiente acolhedor e equipe especializada.</p>
        <a href="#" class="cli-service-link">Saiba mais →</a>
      </div>
      <div class="cli-service">
        <div class="cli-service-icon">🧠</div>
        <h3 class="cli-service-title">Neurologia</h3>
        <p class="cli-service-desc">Diagnostico e tratamento de doencas do sistema nervoso com abordagem multidisciplinar.</p>
        <a href="#" class="cli-service-link">Saiba mais →</a>
      </div>
      <div class="cli-service">
        <div class="cli-service-icon">👁️</div>
        <h3 class="cli-service-title">Oftalmologia</h3>
        <p class="cli-service-desc">Exames completos e tratamentos para a saude dos seus olhos. Cirurgias refrativas e muito mais.</p>
        <a href="#" class="cli-service-link">Saiba mais →</a>
      </div>
    </div>
  </div>
</section>

<!-- TEAM -->
<section class="cli-team">
  <div class="cli-container">
    <div class="cli-team-header">
      <div class="cli-team-label">Nossa Equipe</div>
      <h2 class="cli-team-title">Conheca Nossos Especialistas</h2>
      <p class="cli-team-desc">Profissionais altamente qualificados e comprometidos com sua saude e bem-estar.</p>
    </div>
    <div class="cli-team-grid">
      <div class="cli-doctor">
        <img src="https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=400&h=400&fit=crop" class="cli-doctor-img" alt="Dr. Carlos" />
        <div class="cli-doctor-info">
          <h3 class="cli-doctor-name">Dr. Carlos Mendes</h3>
          <p class="cli-doctor-specialty">Cardiologista</p>
          <p class="cli-doctor-crm">CRM 12345-SP</p>
        </div>
      </div>
      <div class="cli-doctor">
        <img src="https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=400&h=400&fit=crop" class="cli-doctor-img" alt="Dra. Ana" />
        <div class="cli-doctor-info">
          <h3 class="cli-doctor-name">Dra. Ana Costa</h3>
          <p class="cli-doctor-specialty">Dermatologista</p>
          <p class="cli-doctor-crm">CRM 23456-SP</p>
        </div>
      </div>
      <div class="cli-doctor">
        <img src="https://images.unsplash.com/photo-1537368910025-700350fe46c7?w=400&h=400&fit=crop" class="cli-doctor-img" alt="Dr. Roberto" />
        <div class="cli-doctor-info">
          <h3 class="cli-doctor-name">Dr. Roberto Silva</h3>
          <p class="cli-doctor-specialty">Ortopedista</p>
          <p class="cli-doctor-crm">CRM 34567-SP</p>
        </div>
      </div>
      <div class="cli-doctor">
        <img src="https://images.unsplash.com/photo-1594824476967-48c8b964273f?w=400&h=400&fit=crop" class="cli-doctor-img" alt="Dra. Marina" />
        <div class="cli-doctor-info">
          <h3 class="cli-doctor-name">Dra. Marina Lima</h3>
          <p class="cli-doctor-specialty">Pediatra</p>
          <p class="cli-doctor-crm">CRM 45678-SP</p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- TESTIMONIALS -->
<section class="cli-testimonials">
  <div class="cli-container">
    <div class="cli-testimonials-header">
      <div class="cli-testimonials-label">Depoimentos</div>
      <h2 class="cli-testimonials-title">O que nossos pacientes dizem</h2>
    </div>
    <div class="cli-testimonials-grid">
      <div class="cli-testimonial">
        <div class="cli-testimonial-stars">★★★★★</div>
        <p class="cli-testimonial-text">"Fui muito bem atendida desde a recepcao ate a consulta. O Dr. Carlos e extremamente atencioso e me explicou tudo com calma. Recomendo demais!"</p>
        <div class="cli-testimonial-author">
          <img src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop" class="cli-testimonial-avatar" alt="Paciente" />
          <div>
            <div class="cli-testimonial-name">Maria Fernanda</div>
            <div class="cli-testimonial-role">Paciente de Cardiologia</div>
          </div>
        </div>
      </div>
      <div class="cli-testimonial">
        <div class="cli-testimonial-stars">★★★★★</div>
        <p class="cli-testimonial-text">"Ambiente impecavel e equipe super preparada. Meus filhos adoram ir ao pediatra aqui porque sao sempre muito carinhosos com eles."</p>
        <div class="cli-testimonial-author">
          <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop" class="cli-testimonial-avatar" alt="Paciente" />
          <div>
            <div class="cli-testimonial-name">Paulo Ricardo</div>
            <div class="cli-testimonial-role">Pai de paciente</div>
          </div>
        </div>
      </div>
      <div class="cli-testimonial">
        <div class="cli-testimonial-stars">★★★★★</div>
        <p class="cli-testimonial-text">"Depois de anos sofrendo com dores nas costas, finalmente encontrei uma solucao. A equipe de ortopedia mudou minha qualidade de vida."</p>
        <div class="cli-testimonial-author">
          <img src="https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=100&h=100&fit=crop" class="cli-testimonial-avatar" alt="Paciente" />
          <div>
            <div class="cli-testimonial-name">Lucia Andrade</div>
            <div class="cli-testimonial-role">Paciente de Ortopedia</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- FAQ -->
<section class="cli-faq">
  <div class="cli-container">
    <div class="cli-faq-header">
      <div class="cli-faq-label">Duvidas Frequentes</div>
      <h2 class="cli-faq-title">Perguntas e Respostas</h2>
    </div>
    <div class="cli-faq-grid">
      <div class="cli-faq-item">
        <h3 class="cli-faq-question"><span>?</span> Quais convenios sao aceitos?</h3>
        <p class="cli-faq-answer">Trabalhamos com os principais convenios do mercado: Unimed, Bradesco Saude, SulAmerica, Amil, Porto Seguro, entre outros. Consulte nossa equipe para verificar seu plano.</p>
      </div>
      <div class="cli-faq-item">
        <h3 class="cli-faq-question"><span>?</span> Como agendar uma consulta?</h3>
        <p class="cli-faq-answer">Voce pode agendar pelo telefone (11) 3456-7890, pelo WhatsApp ou preenchendo o formulario online. Tambem aceitamos agendamentos presenciais.</p>
      </div>
      <div class="cli-faq-item">
        <h3 class="cli-faq-question"><span>?</span> A clinica tem estacionamento?</h3>
        <p class="cli-faq-answer">Sim, oferecemos estacionamento gratuito para todos os pacientes durante o horario da consulta. Basta validar o ticket na recepcao.</p>
      </div>
      <div class="cli-faq-item">
        <h3 class="cli-faq-question"><span>?</span> Qual o horario de funcionamento?</h3>
        <p class="cli-faq-answer">Funcionamos de segunda a sexta das 7h as 20h e aos sabados das 8h as 14h. Alguns exames de urgencia podem ser realizados fora desse horario.</p>
      </div>
    </div>
  </div>
</section>

<!-- CONTACT -->
<section class="cli-contact">
  <div class="cli-container">
    <div class="cli-contact-grid">
      <div>
        <div class="cli-contact-label">Fale Conosco</div>
        <h2 class="cli-contact-title">Entre em contato ou agende sua consulta</h2>
        <p class="cli-contact-text">
          Nossa equipe esta pronta para atende-lo. Entre em contato pelos canais abaixo
          ou preencha o formulario para agendar sua consulta.
        </p>
        <div class="cli-contact-info">
          <div class="cli-contact-item">
            <div class="cli-contact-icon">📍</div>
            <div>
              <div class="cli-contact-item-title">Endereco</div>
              <div class="cli-contact-item-text">Av. Paulista, 1000 - Bela Vista<br/>Sao Paulo - SP, 01310-100</div>
            </div>
          </div>
          <div class="cli-contact-item">
            <div class="cli-contact-icon">📞</div>
            <div>
              <div class="cli-contact-item-title">Telefone</div>
              <div class="cli-contact-item-text">(11) 3456-7890<br/>WhatsApp: (11) 98765-4321</div>
            </div>
          </div>
          <div class="cli-contact-item">
            <div class="cli-contact-icon">🕐</div>
            <div>
              <div class="cli-contact-item-title">Horario</div>
              <div class="cli-contact-item-text">Seg a Sex: 7h - 20h<br/>Sabado: 8h - 14h</div>
            </div>
          </div>
        </div>
      </div>
      <div class="cli-contact-form">
        <h3 class="cli-form-title">Agende sua Consulta</h3>
        <div class="cli-form-row">
          <div class="cli-form-group">
            <label class="cli-form-label">Nome Completo</label>
            <input type="text" class="cli-form-input" placeholder="Seu nome" />
          </div>
          <div class="cli-form-group">
            <label class="cli-form-label">Telefone</label>
            <input type="tel" class="cli-form-input" placeholder="(11) 99999-9999" />
          </div>
        </div>
        <div class="cli-form-group">
          <label class="cli-form-label">E-mail</label>
          <input type="email" class="cli-form-input" placeholder="seu@email.com" />
        </div>
        <div class="cli-form-group">
          <label class="cli-form-label">Especialidade</label>
          <select class="cli-form-select">
            <option>Selecione uma especialidade</option>
            <option>Cardiologia</option>
            <option>Dermatologia</option>
            <option>Ortopedia</option>
            <option>Pediatria</option>
            <option>Neurologia</option>
            <option>Oftalmologia</option>
          </select>
        </div>
        <div class="cli-form-group">
          <label class="cli-form-label">Mensagem (opcional)</label>
          <textarea class="cli-form-textarea" placeholder="Descreva seus sintomas ou duvidas..."></textarea>
        </div>
        <button class="cli-form-btn">Solicitar Agendamento</button>
      </div>
    </div>
  </div>
</section>

<!-- CTA -->
<section class="cli-cta">
  <div class="cli-container">
    <h2 class="cli-cta-title">Sua saude nao pode esperar</h2>
    <p class="cli-cta-desc">Agende agora sua consulta e cuide do que mais importa: voce e sua familia.</p>
    <a href="#" class="cli-cta-btn">Agendar Consulta Agora</a>
  </div>
</section>

<!-- FOOTER -->
<footer class="cli-footer">
  <div class="cli-container">
    <div class="cli-footer-grid">
      <div>
        <div class="cli-footer-logo">🏥 VidaClinic</div>
        <p class="cli-footer-desc">
          Ha mais de 15 anos cuidando da saude de milhares de familias com
          excelencia, tecnologia e muito carinho.
        </p>
        <div class="cli-footer-social">
          <a href="#">f</a>
          <a href="#">in</a>
          <a href="#">ig</a>
          <a href="#">yt</a>
        </div>
      </div>
      <div>
        <h4 class="cli-footer-title">Especialidades</h4>
        <ul class="cli-footer-links">
          <li><a href="#">Cardiologia</a></li>
          <li><a href="#">Dermatologia</a></li>
          <li><a href="#">Ortopedia</a></li>
          <li><a href="#">Pediatria</a></li>
          <li><a href="#">Neurologia</a></li>
        </ul>
      </div>
      <div>
        <h4 class="cli-footer-title">A Clinica</h4>
        <ul class="cli-footer-links">
          <li><a href="#">Sobre Nos</a></li>
          <li><a href="#">Nossa Equipe</a></li>
          <li><a href="#">Estrutura</a></li>
          <li><a href="#">Convenios</a></li>
          <li><a href="#">Trabalhe Conosco</a></li>
        </ul>
      </div>
      <div>
        <h4 class="cli-footer-title">Atendimento</h4>
        <ul class="cli-footer-links">
          <li><a href="#">Agendar Consulta</a></li>
          <li><a href="#">Resultados de Exames</a></li>
          <li><a href="#">Duvidas Frequentes</a></li>
          <li><a href="#">Fale Conosco</a></li>
          <li><a href="#">Ouvidoria</a></li>
        </ul>
      </div>
    </div>
    <div class="cli-footer-bottom">
      <p class="cli-footer-copy">© 2024 VidaClinic. Todos os direitos reservados.</p>
      <div class="cli-footer-badges">
        <span class="cli-footer-badge">🏆 ANVISA Aprovado</span>
        <span class="cli-footer-badge">✓ Certificado ISO 9001</span>
      </div>
    </div>
  </div>
</footer>
`,
    gjsCss: '',
    gjsComponents: '',
    gjsStyles: ''
  },

  // ============================================
  // 14. IMOBILIÁRIA
  // ============================================
  {
    id: 'real-estate',
    name: 'Imobiliária',
    description: 'Landing page elegante para imóveis e corretores',
    thumbnail: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=400&h=300&fit=crop',
    category: 'ecommerce',
    gjsHtml: `
<style>
  * { box-sizing: border-box; margin: 0; padding: 0; }

  /* Navigation */
  .re-nav { position: fixed; top: 0; left: 0; right: 0; z-index: 100; padding: 16px 24px; background: rgba(255,255,255,0.95); backdrop-filter: blur(10px); box-shadow: 0 2px 20px rgba(0,0,0,0.08); }
  .re-nav-container { max-width: 1200px; margin: 0 auto; display: flex; align-items: center; justify-content: space-between; }
  .re-nav-logo { font-size: 1.5rem; font-weight: 800; color: #1e3a5f; text-decoration: none; display: flex; align-items: center; gap: 8px; }
  .re-nav-links { display: flex; gap: 32px; }
  .re-nav-link { color: #475569; font-weight: 500; text-decoration: none; font-size: 15px; transition: color 0.2s; }
  .re-nav-link:hover { color: #1e3a5f; }
  .re-nav-cta { padding: 12px 24px; background: #1e3a5f; color: white; font-weight: 600; border-radius: 10px; text-decoration: none; font-size: 14px; }

  /* Hero */
  .re-hero { min-height: 100vh; background: linear-gradient(135deg, rgba(30,58,95,0.85), rgba(15,23,42,0.9)), url('https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=1920&h=1080&fit=crop') center/cover; display: flex; align-items: center; padding: 120px 24px 80px; }
  .re-container { max-width: 1200px; margin: 0 auto; width: 100%; }
  .re-hero-content { max-width: 700px; }
  .re-badge { display: inline-flex; align-items: center; gap: 8px; padding: 12px 24px; background: rgba(255,255,255,0.15); backdrop-filter: blur(10px); border-radius: 100px; color: white; font-size: 14px; font-weight: 600; margin-bottom: 24px; border: 1px solid rgba(255,255,255,0.2); }
  .re-title { font-size: 4rem; font-weight: 800; color: white; line-height: 1.1; margin-bottom: 24px; }
  .re-title span { color: #fbbf24; }
  .re-desc { font-size: 1.25rem; color: rgba(255,255,255,0.85); line-height: 1.7; margin-bottom: 40px; }
  .re-ctas { display: flex; gap: 16px; flex-wrap: wrap; margin-bottom: 60px; }
  .re-btn-primary { padding: 18px 36px; background: #fbbf24; color: #1e3a5f; font-weight: 700; font-size: 16px; border-radius: 12px; text-decoration: none; display: inline-flex; align-items: center; gap: 8px; transition: transform 0.2s; }
  .re-btn-primary:hover { transform: translateY(-2px); }
  .re-btn-secondary { padding: 18px 36px; background: transparent; color: white; font-weight: 600; font-size: 16px; border: 2px solid rgba(255,255,255,0.3); border-radius: 12px; text-decoration: none; }
  .re-stats { display: flex; gap: 60px; }
  .re-stat-value { font-size: 3rem; font-weight: 800; color: #fbbf24; }
  .re-stat-label { color: rgba(255,255,255,0.7); font-size: 14px; margin-top: 4px; }

  /* Services */
  .re-services { padding: 100px 24px; background: white; }
  .re-section-header { text-align: center; margin-bottom: 60px; }
  .re-section-label { color: #1e3a5f; font-weight: 600; font-size: 14px; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 12px; }
  .re-section-title { font-size: 2.5rem; font-weight: 800; color: #0f172a; margin-bottom: 16px; }
  .re-section-desc { color: #64748b; font-size: 1.1rem; max-width: 600px; margin: 0 auto; }
  .re-services-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 32px; }
  .re-service { text-align: center; padding: 32px; background: #f8fafc; border-radius: 20px; transition: transform 0.3s, box-shadow 0.3s; }
  .re-service:hover { transform: translateY(-8px); box-shadow: 0 20px 40px rgba(0,0,0,0.1); background: white; }
  .re-service-icon { width: 72px; height: 72px; background: linear-gradient(135deg, #1e3a5f, #334155); border-radius: 20px; display: flex; align-items: center; justify-content: center; margin: 0 auto 20px; font-size: 32px; }
  .re-service-title { font-size: 1.1rem; font-weight: 700; color: #0f172a; margin-bottom: 8px; }
  .re-service-desc { color: #64748b; font-size: 14px; line-height: 1.6; }

  /* Properties */
  .re-properties { padding: 100px 24px; background: #f8fafc; }
  .re-properties-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 48px; }
  .re-properties-title { font-size: 2rem; font-weight: 800; color: #0f172a; }
  .re-properties-tabs { display: flex; gap: 8px; }
  .re-tab { padding: 10px 20px; background: white; border: 1px solid #e2e8f0; border-radius: 10px; font-weight: 600; color: #64748b; cursor: pointer; transition: all 0.2s; }
  .re-tab.active { background: #1e3a5f; color: white; border-color: #1e3a5f; }
  .re-properties-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 32px; }
  .re-property { background: white; border-radius: 24px; overflow: hidden; box-shadow: 0 4px 20px rgba(0,0,0,0.08); transition: transform 0.3s, box-shadow 0.3s; }
  .re-property:hover { transform: translateY(-8px); box-shadow: 0 20px 40px rgba(0,0,0,0.12); }
  .re-property-image { position: relative; }
  .re-property-img { width: 100%; height: 240px; object-fit: cover; }
  .re-property-badge { position: absolute; top: 16px; left: 16px; padding: 8px 16px; background: #1e3a5f; color: white; font-size: 13px; font-weight: 600; border-radius: 8px; }
  .re-property-favorite { position: absolute; top: 16px; right: 16px; width: 40px; height: 40px; background: white; border-radius: 50%; display: flex; align-items: center; justify-content: center; cursor: pointer; box-shadow: 0 2px 10px rgba(0,0,0,0.1); }
  .re-property-content { padding: 24px; }
  .re-property-price { font-size: 1.75rem; font-weight: 800; color: #1e3a5f; margin-bottom: 8px; }
  .re-property-price span { font-size: 0.9rem; color: #64748b; font-weight: 500; }
  .re-property-title { font-size: 1.1rem; font-weight: 600; color: #334155; margin-bottom: 12px; }
  .re-property-location { display: flex; align-items: center; gap: 6px; color: #64748b; font-size: 14px; margin-bottom: 16px; }
  .re-property-details { display: flex; gap: 16px; padding-top: 16px; border-top: 1px solid #e2e8f0; }
  .re-property-detail { display: flex; align-items: center; gap: 6px; color: #64748b; font-size: 14px; }

  /* About */
  .re-about { padding: 100px 24px; background: white; }
  .re-about-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: center; }
  .re-about-images { position: relative; }
  .re-about-img1 { width: 80%; border-radius: 24px; box-shadow: 0 25px 50px rgba(0,0,0,0.15); }
  .re-about-img2 { position: absolute; bottom: -40px; right: 0; width: 55%; border-radius: 20px; box-shadow: 0 20px 40px rgba(0,0,0,0.2); border: 6px solid white; }
  .re-about-badge { position: absolute; top: 20px; right: 20px; background: #fbbf24; color: #1e3a5f; padding: 20px; border-radius: 16px; text-align: center; box-shadow: 0 10px 30px rgba(251,191,36,0.3); }
  .re-about-badge-value { font-size: 2.5rem; font-weight: 800; line-height: 1; }
  .re-about-badge-label { font-size: 13px; font-weight: 600; margin-top: 4px; }
  .re-about-label { color: #1e3a5f; font-weight: 600; font-size: 14px; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 12px; }
  .re-about-title { font-size: 2.5rem; font-weight: 800; color: #0f172a; margin-bottom: 24px; line-height: 1.2; }
  .re-about-text { color: #64748b; line-height: 1.8; margin-bottom: 24px; font-size: 1.05rem; }
  .re-about-features { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; margin-bottom: 32px; }
  .re-about-feature { display: flex; align-items: center; gap: 12px; color: #334155; font-weight: 500; }
  .re-about-feature span { width: 28px; height: 28px; background: #dcfce7; border-radius: 50%; display: flex; align-items: center; justify-content: center; color: #16a34a; font-size: 14px; }

  /* Agents */
  .re-agents { padding: 100px 24px; background: #f8fafc; }
  .re-agents-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 32px; }
  .re-agent { background: white; border-radius: 24px; overflow: hidden; box-shadow: 0 4px 20px rgba(0,0,0,0.06); text-align: center; transition: transform 0.3s; }
  .re-agent:hover { transform: translateY(-8px); }
  .re-agent-img { width: 100%; height: 280px; object-fit: cover; }
  .re-agent-info { padding: 24px; }
  .re-agent-name { font-size: 1.2rem; font-weight: 700; color: #0f172a; margin-bottom: 4px; }
  .re-agent-role { color: #1e3a5f; font-size: 14px; font-weight: 600; margin-bottom: 8px; }
  .re-agent-creci { color: #94a3b8; font-size: 13px; margin-bottom: 16px; }
  .re-agent-contact { display: flex; justify-content: center; gap: 12px; }
  .re-agent-btn { width: 40px; height: 40px; background: #f1f5f9; border-radius: 10px; display: flex; align-items: center; justify-content: center; color: #64748b; text-decoration: none; transition: all 0.2s; }
  .re-agent-btn:hover { background: #1e3a5f; color: white; }

  /* Testimonials */
  .re-testimonials { padding: 100px 24px; background: white; }
  .re-testimonials-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 32px; }
  .re-testimonial { background: #f8fafc; padding: 32px; border-radius: 24px; }
  .re-testimonial-stars { color: #fbbf24; font-size: 20px; margin-bottom: 16px; }
  .re-testimonial-text { color: #475569; line-height: 1.7; margin-bottom: 24px; font-size: 15px; font-style: italic; }
  .re-testimonial-author { display: flex; align-items: center; gap: 16px; }
  .re-testimonial-avatar { width: 56px; height: 56px; border-radius: 50%; object-fit: cover; }
  .re-testimonial-name { font-weight: 700; color: #0f172a; }
  .re-testimonial-role { color: #64748b; font-size: 14px; }

  /* Contact */
  .re-contact { padding: 100px 24px; background: linear-gradient(135deg, #1e3a5f, #0f172a); }
  .re-contact-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: start; }
  .re-contact-label { color: #fbbf24; font-weight: 600; font-size: 14px; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 12px; }
  .re-contact-title { font-size: 2.5rem; font-weight: 800; color: white; margin-bottom: 24px; line-height: 1.2; }
  .re-contact-text { color: rgba(255,255,255,0.7); line-height: 1.7; margin-bottom: 40px; }
  .re-contact-info { display: flex; flex-direction: column; gap: 24px; }
  .re-contact-item { display: flex; align-items: flex-start; gap: 16px; }
  .re-contact-icon { width: 56px; height: 56px; background: rgba(251,191,36,0.2); border-radius: 16px; display: flex; align-items: center; justify-content: center; font-size: 24px; flex-shrink: 0; }
  .re-contact-item-title { font-weight: 700; color: white; margin-bottom: 4px; }
  .re-contact-item-text { color: rgba(255,255,255,0.7); font-size: 15px; }
  .re-contact-form { background: white; padding: 40px; border-radius: 24px; }
  .re-form-title { font-size: 1.5rem; font-weight: 700; color: #0f172a; margin-bottom: 24px; }
  .re-form-row { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; margin-bottom: 16px; }
  .re-form-group { margin-bottom: 16px; }
  .re-form-label { display: block; font-weight: 600; color: #334155; margin-bottom: 8px; font-size: 14px; }
  .re-form-input { width: 100%; padding: 16px 20px; border: 2px solid #e2e8f0; border-radius: 12px; font-size: 16px; transition: border-color 0.2s; outline: none; }
  .re-form-input:focus { border-color: #1e3a5f; }
  .re-form-textarea { width: 100%; padding: 16px 20px; border: 2px solid #e2e8f0; border-radius: 12px; font-size: 16px; min-height: 120px; resize: vertical; outline: none; }
  .re-form-select { width: 100%; padding: 16px 20px; border: 2px solid #e2e8f0; border-radius: 12px; font-size: 16px; background: white; outline: none; cursor: pointer; }
  .re-form-btn { width: 100%; padding: 18px; background: #1e3a5f; color: white; font-weight: 700; font-size: 16px; border: none; border-radius: 12px; cursor: pointer; transition: background 0.2s; }
  .re-form-btn:hover { background: #0f172a; }

  /* Footer */
  .re-footer { padding: 80px 24px 40px; background: #0f172a; }
  .re-footer-grid { display: grid; grid-template-columns: 2fr 1fr 1fr 1fr; gap: 60px; margin-bottom: 60px; }
  .re-footer-logo { font-size: 1.5rem; font-weight: 800; color: white; margin-bottom: 16px; display: flex; align-items: center; gap: 8px; }
  .re-footer-desc { color: #94a3b8; line-height: 1.7; margin-bottom: 24px; }
  .re-footer-social { display: flex; gap: 12px; }
  .re-footer-social a { width: 44px; height: 44px; background: rgba(255,255,255,0.1); border-radius: 12px; display: flex; align-items: center; justify-content: center; color: white; text-decoration: none; transition: background 0.2s; }
  .re-footer-social a:hover { background: #1e3a5f; }
  .re-footer-title { font-weight: 700; color: white; margin-bottom: 24px; font-size: 1.1rem; }
  .re-footer-links { list-style: none; }
  .re-footer-links li { margin-bottom: 12px; }
  .re-footer-links a { color: #94a3b8; text-decoration: none; font-size: 15px; transition: color 0.2s; }
  .re-footer-links a:hover { color: #fbbf24; }
  .re-footer-bottom { border-top: 1px solid rgba(255,255,255,0.1); padding-top: 40px; display: flex; justify-content: space-between; align-items: center; }
  .re-footer-copy { color: #64748b; font-size: 14px; }

  @media (max-width: 968px) {
    .re-nav-links { display: none; }
    .re-hero { padding: 100px 24px 60px; }
    .re-title { font-size: 2.75rem; }
    .re-stats { gap: 32px; flex-wrap: wrap; }
    .re-services-grid { grid-template-columns: repeat(2, 1fr); }
    .re-properties-header { flex-direction: column; gap: 20px; align-items: flex-start; }
    .re-properties-grid { grid-template-columns: 1fr; }
    .re-about-grid { grid-template-columns: 1fr; gap: 60px; }
    .re-about-images { order: -1; }
    .re-agents-grid { grid-template-columns: repeat(2, 1fr); }
    .re-testimonials-grid { grid-template-columns: 1fr; }
    .re-contact-grid { grid-template-columns: 1fr; }
    .re-form-row { grid-template-columns: 1fr; }
    .re-footer-grid { grid-template-columns: 1fr 1fr; gap: 40px; }
    .re-footer-bottom { flex-direction: column; gap: 20px; text-align: center; }
  }
</style>

<!-- NAVIGATION -->
<nav class="re-nav">
  <div class="re-nav-container">
    <a href="#" class="re-nav-logo">🏠 PrimeImoveis</a>
    <div class="re-nav-links">
      <a href="#" class="re-nav-link">Inicio</a>
      <a href="#" class="re-nav-link">Imoveis</a>
      <a href="#" class="re-nav-link">Sobre</a>
      <a href="#" class="re-nav-link">Corretores</a>
      <a href="#" class="re-nav-link">Contato</a>
    </div>
    <a href="#" class="re-nav-cta">Anunciar Imovel</a>
  </div>
</nav>

<!-- HERO -->
<section class="re-hero">
  <div class="re-container">
    <div class="re-hero-content">
      <div class="re-badge">🏆 A imobiliaria mais premiada da regiao</div>
      <h1 class="re-title">Encontre o <span>imovel perfeito</span> para voce e sua familia</h1>
      <p class="re-desc">
        Mais de 5.000 imoveis disponiveis nas melhores localizacoes. Casas, apartamentos,
        terrenos e empreendimentos com as melhores condicoes do mercado.
      </p>
      <div class="re-ctas">
        <a href="#" class="re-btn-primary">Ver Imoveis Disponiveis →</a>
        <a href="#" class="re-btn-secondary">Fale com um Corretor</a>
      </div>
      <div class="re-stats">
        <div>
          <div class="re-stat-value">5.000+</div>
          <div class="re-stat-label">Imoveis disponiveis</div>
        </div>
        <div>
          <div class="re-stat-value">2.500+</div>
          <div class="re-stat-label">Clientes satisfeitos</div>
        </div>
        <div>
          <div class="re-stat-value">15 anos</div>
          <div class="re-stat-label">De experiencia</div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- SERVICES -->
<section class="re-services">
  <div class="re-container">
    <div class="re-section-header">
      <div class="re-section-label">Nossos Servicos</div>
      <h2 class="re-section-title">Como podemos ajudar voce?</h2>
      <p class="re-section-desc">Oferecemos servicos completos para quem quer comprar, vender ou alugar imoveis.</p>
    </div>
    <div class="re-services-grid">
      <div class="re-service">
        <div class="re-service-icon">🏠</div>
        <h3 class="re-service-title">Compra</h3>
        <p class="re-service-desc">Encontre o imovel ideal com assessoria especializada em todo o processo.</p>
      </div>
      <div class="re-service">
        <div class="re-service-icon">💰</div>
        <h3 class="re-service-title">Venda</h3>
        <p class="re-service-desc">Venda seu imovel pelo melhor preco com estrategias de marketing eficientes.</p>
      </div>
      <div class="re-service">
        <div class="re-service-icon">🔑</div>
        <h3 class="re-service-title">Aluguel</h3>
        <p class="re-service-desc">Alugue com seguranca e praticidade, tanto para locadores quanto locatarios.</p>
      </div>
      <div class="re-service">
        <div class="re-service-icon">📋</div>
        <h3 class="re-service-title">Avaliacao</h3>
        <p class="re-service-desc">Avaliacao profissional do seu imovel para definir o valor de mercado.</p>
      </div>
    </div>
  </div>
</section>

<!-- PROPERTIES -->
<section class="re-properties">
  <div class="re-container">
    <div class="re-properties-header">
      <h2 class="re-properties-title">Imoveis em Destaque</h2>
      <div class="re-properties-tabs">
        <button class="re-tab active">Todos</button>
        <button class="re-tab">Casas</button>
        <button class="re-tab">Apartamentos</button>
        <button class="re-tab">Terrenos</button>
      </div>
    </div>
    <div class="re-properties-grid">
      <div class="re-property">
        <div class="re-property-image">
          <img src="https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=600&h=400&fit=crop" class="re-property-img" alt="Casa moderna" />
          <div class="re-property-badge">Destaque</div>
          <div class="re-property-favorite">♡</div>
        </div>
        <div class="re-property-content">
          <div class="re-property-price">R$ 890.000 <span>/ Venda</span></div>
          <h3 class="re-property-title">Casa moderna em condominio fechado</h3>
          <div class="re-property-location">📍 Alphaville, Sao Paulo</div>
          <div class="re-property-details">
            <span class="re-property-detail">🛏️ 4 quartos</span>
            <span class="re-property-detail">🚗 2 vagas</span>
            <span class="re-property-detail">📐 250m²</span>
          </div>
        </div>
      </div>
      <div class="re-property">
        <div class="re-property-image">
          <img src="https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=600&h=400&fit=crop" class="re-property-img" alt="Apartamento" />
          <div class="re-property-badge">Novo</div>
          <div class="re-property-favorite">♡</div>
        </div>
        <div class="re-property-content">
          <div class="re-property-price">R$ 650.000 <span>/ Venda</span></div>
          <h3 class="re-property-title">Apartamento com vista para o mar</h3>
          <div class="re-property-location">📍 Barra da Tijuca, RJ</div>
          <div class="re-property-details">
            <span class="re-property-detail">🛏️ 3 quartos</span>
            <span class="re-property-detail">🚗 1 vaga</span>
            <span class="re-property-detail">📐 120m²</span>
          </div>
        </div>
      </div>
      <div class="re-property">
        <div class="re-property-image">
          <img src="https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=600&h=400&fit=crop" class="re-property-img" alt="Cobertura" />
          <div class="re-property-badge">Premium</div>
          <div class="re-property-favorite">♡</div>
        </div>
        <div class="re-property-content">
          <div class="re-property-price">R$ 1.200.000 <span>/ Venda</span></div>
          <h3 class="re-property-title">Cobertura duplex no centro</h3>
          <div class="re-property-location">📍 Centro, Curitiba</div>
          <div class="re-property-details">
            <span class="re-property-detail">🛏️ 5 quartos</span>
            <span class="re-property-detail">🚗 3 vagas</span>
            <span class="re-property-detail">📐 320m²</span>
          </div>
        </div>
      </div>
      <div class="re-property">
        <div class="re-property-image">
          <img src="https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=600&h=400&fit=crop" class="re-property-img" alt="Casa terrea" />
          <div class="re-property-badge">Oportunidade</div>
          <div class="re-property-favorite">♡</div>
        </div>
        <div class="re-property-content">
          <div class="re-property-price">R$ 450.000 <span>/ Venda</span></div>
          <h3 class="re-property-title">Casa terrea com quintal amplo</h3>
          <div class="re-property-location">📍 Morumbi, Sao Paulo</div>
          <div class="re-property-details">
            <span class="re-property-detail">🛏️ 3 quartos</span>
            <span class="re-property-detail">🚗 2 vagas</span>
            <span class="re-property-detail">📐 180m²</span>
          </div>
        </div>
      </div>
      <div class="re-property">
        <div class="re-property-image">
          <img src="https://images.unsplash.com/photo-1600573472592-401b489a3cdc?w=600&h=400&fit=crop" class="re-property-img" alt="Apartamento compacto" />
          <div class="re-property-badge">Aluguel</div>
          <div class="re-property-favorite">♡</div>
        </div>
        <div class="re-property-content">
          <div class="re-property-price">R$ 3.500 <span>/ mes</span></div>
          <h3 class="re-property-title">Apartamento moderno mobiliado</h3>
          <div class="re-property-location">📍 Itaim Bibi, Sao Paulo</div>
          <div class="re-property-details">
            <span class="re-property-detail">🛏️ 2 quartos</span>
            <span class="re-property-detail">🚗 1 vaga</span>
            <span class="re-property-detail">📐 75m²</span>
          </div>
        </div>
      </div>
      <div class="re-property">
        <div class="re-property-image">
          <img src="https://images.unsplash.com/photo-1600585154526-990dced4db0d?w=600&h=400&fit=crop" class="re-property-img" alt="Sobrado" />
          <div class="re-property-badge">Lancamento</div>
          <div class="re-property-favorite">♡</div>
        </div>
        <div class="re-property-content">
          <div class="re-property-price">R$ 750.000 <span>/ Venda</span></div>
          <h3 class="re-property-title">Sobrado novo em condominio</h3>
          <div class="re-property-location">📍 Granja Viana, SP</div>
          <div class="re-property-details">
            <span class="re-property-detail">🛏️ 4 quartos</span>
            <span class="re-property-detail">🚗 2 vagas</span>
            <span class="re-property-detail">📐 200m²</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ABOUT -->
<section class="re-about">
  <div class="re-container">
    <div class="re-about-grid">
      <div class="re-about-images">
        <img src="https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=600&h=700&fit=crop" class="re-about-img1" alt="Escritorio" />
        <img src="https://images.unsplash.com/photo-1556912172-45b7abe8b7e1?w=400&h=300&fit=crop" class="re-about-img2" alt="Equipe" />
        <div class="re-about-badge">
          <div class="re-about-badge-value">15+</div>
          <div class="re-about-badge-label">Anos de mercado</div>
        </div>
      </div>
      <div>
        <div class="re-about-label">Sobre Nos</div>
        <h2 class="re-about-title">A imobiliaria que entende suas necessidades</h2>
        <p class="re-about-text">
          Ha mais de 15 anos no mercado imobiliario, a PrimeImoveis se consolidou como
          referencia em compra, venda e locacao de imoveis. Nossa equipe de corretores
          especializados esta pronta para ajuda-lo a encontrar o imovel dos seus sonhos.
        </p>
        <p class="re-about-text">
          Trabalhamos com transparencia, etica e comprometimento, oferecendo as melhores
          oportunidades do mercado e um atendimento personalizado para cada cliente.
        </p>
        <div class="re-about-features">
          <div class="re-about-feature"><span>✓</span> Corretores certificados</div>
          <div class="re-about-feature"><span>✓</span> Assessoria juridica</div>
          <div class="re-about-feature"><span>✓</span> Financiamento facilitado</div>
          <div class="re-about-feature"><span>✓</span> Documentacao completa</div>
        </div>
        <a href="#" class="re-btn-primary">Conheca Nossa Historia →</a>
      </div>
    </div>
  </div>
</section>

<!-- AGENTS -->
<section class="re-agents">
  <div class="re-container">
    <div class="re-section-header">
      <div class="re-section-label">Nossa Equipe</div>
      <h2 class="re-section-title">Corretores Especializados</h2>
      <p class="re-section-desc">Profissionais qualificados prontos para ajudar voce a encontrar o imovel perfeito.</p>
    </div>
    <div class="re-agents-grid">
      <div class="re-agent">
        <img src="https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&h=400&fit=crop" class="re-agent-img" alt="Corretor" />
        <div class="re-agent-info">
          <h3 class="re-agent-name">Carlos Mendes</h3>
          <p class="re-agent-role">Corretor Senior</p>
          <p class="re-agent-creci">CRECI 12345-SP</p>
          <div class="re-agent-contact">
            <a href="#" class="re-agent-btn">📞</a>
            <a href="#" class="re-agent-btn">✉️</a>
            <a href="#" class="re-agent-btn">💬</a>
          </div>
        </div>
      </div>
      <div class="re-agent">
        <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop" class="re-agent-img" alt="Corretora" />
        <div class="re-agent-info">
          <h3 class="re-agent-name">Ana Paula Costa</h3>
          <p class="re-agent-role">Corretora de Alto Padrao</p>
          <p class="re-agent-creci">CRECI 23456-SP</p>
          <div class="re-agent-contact">
            <a href="#" class="re-agent-btn">📞</a>
            <a href="#" class="re-agent-btn">✉️</a>
            <a href="#" class="re-agent-btn">💬</a>
          </div>
        </div>
      </div>
      <div class="re-agent">
        <img src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop" class="re-agent-img" alt="Corretor" />
        <div class="re-agent-info">
          <h3 class="re-agent-name">Roberto Silva</h3>
          <p class="re-agent-role">Especialista em Lancamentos</p>
          <p class="re-agent-creci">CRECI 34567-SP</p>
          <div class="re-agent-contact">
            <a href="#" class="re-agent-btn">📞</a>
            <a href="#" class="re-agent-btn">✉️</a>
            <a href="#" class="re-agent-btn">💬</a>
          </div>
        </div>
      </div>
      <div class="re-agent">
        <img src="https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&h=400&fit=crop" class="re-agent-img" alt="Corretora" />
        <div class="re-agent-info">
          <h3 class="re-agent-name">Marina Lima</h3>
          <p class="re-agent-role">Corretora de Locacao</p>
          <p class="re-agent-creci">CRECI 45678-SP</p>
          <div class="re-agent-contact">
            <a href="#" class="re-agent-btn">📞</a>
            <a href="#" class="re-agent-btn">✉️</a>
            <a href="#" class="re-agent-btn">💬</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- TESTIMONIALS -->
<section class="re-testimonials">
  <div class="re-container">
    <div class="re-section-header">
      <div class="re-section-label">Depoimentos</div>
      <h2 class="re-section-title">O que nossos clientes dizem</h2>
    </div>
    <div class="re-testimonials-grid">
      <div class="re-testimonial">
        <div class="re-testimonial-stars">★★★★★</div>
        <p class="re-testimonial-text">"Encontrei o apartamento perfeito com a ajuda da PrimeImoveis. O atendimento foi excepcional do inicio ao fim. Super recomendo!"</p>
        <div class="re-testimonial-author">
          <img src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop" class="re-testimonial-avatar" alt="Cliente" />
          <div>
            <div class="re-testimonial-name">Maria Fernanda</div>
            <div class="re-testimonial-role">Compradora - Apartamento</div>
          </div>
        </div>
      </div>
      <div class="re-testimonial">
        <div class="re-testimonial-stars">★★★★★</div>
        <p class="re-testimonial-text">"Vendi minha casa em tempo recorde e por um otimo preco. A equipe foi muito profissional e transparente em todo o processo."</p>
        <div class="re-testimonial-author">
          <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop" class="re-testimonial-avatar" alt="Cliente" />
          <div>
            <div class="re-testimonial-name">Paulo Ricardo</div>
            <div class="re-testimonial-role">Vendedor - Casa</div>
          </div>
        </div>
      </div>
      <div class="re-testimonial">
        <div class="re-testimonial-stars">★★★★★</div>
        <p class="re-testimonial-text">"Aluguei um escritorio comercial com toda a documentacao em dia. Processo rapido e sem complicacoes. Excelente servico!"</p>
        <div class="re-testimonial-author">
          <img src="https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=100&h=100&fit=crop" class="re-testimonial-avatar" alt="Cliente" />
          <div>
            <div class="re-testimonial-name">Lucia Andrade</div>
            <div class="re-testimonial-role">Locataria - Comercial</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- CONTACT -->
<section class="re-contact">
  <div class="re-container">
    <div class="re-contact-grid">
      <div>
        <div class="re-contact-label">Fale Conosco</div>
        <h2 class="re-contact-title">Pronto para encontrar seu imovel ideal?</h2>
        <p class="re-contact-text">
          Entre em contato conosco e um de nossos corretores especializados ira ajuda-lo
          a encontrar a melhor opcao para voce e sua familia.
        </p>
        <div class="re-contact-info">
          <div class="re-contact-item">
            <div class="re-contact-icon">📍</div>
            <div>
              <div class="re-contact-item-title">Endereco</div>
              <div class="re-contact-item-text">Av. Paulista, 1000 - Bela Vista<br/>Sao Paulo - SP, 01310-100</div>
            </div>
          </div>
          <div class="re-contact-item">
            <div class="re-contact-icon">📞</div>
            <div>
              <div class="re-contact-item-title">Telefone</div>
              <div class="re-contact-item-text">(11) 3456-7890<br/>WhatsApp: (11) 98765-4321</div>
            </div>
          </div>
          <div class="re-contact-item">
            <div class="re-contact-icon">🕐</div>
            <div>
              <div class="re-contact-item-title">Horario</div>
              <div class="re-contact-item-text">Seg a Sex: 9h - 18h<br/>Sabado: 9h - 13h</div>
            </div>
          </div>
        </div>
      </div>
      <div class="re-contact-form">
        <h3 class="re-form-title">Solicite Atendimento</h3>
        <div class="re-form-row">
          <div class="re-form-group">
            <label class="re-form-label">Nome Completo</label>
            <input type="text" class="re-form-input" placeholder="Seu nome" />
          </div>
          <div class="re-form-group">
            <label class="re-form-label">Telefone</label>
            <input type="tel" class="re-form-input" placeholder="(11) 99999-9999" />
          </div>
        </div>
        <div class="re-form-group">
          <label class="re-form-label">E-mail</label>
          <input type="email" class="re-form-input" placeholder="seu@email.com" />
        </div>
        <div class="re-form-group">
          <label class="re-form-label">Interesse</label>
          <select class="re-form-select">
            <option>Selecione seu interesse</option>
            <option>Comprar imovel</option>
            <option>Vender imovel</option>
            <option>Alugar imovel</option>
            <option>Avaliacao de imovel</option>
          </select>
        </div>
        <div class="re-form-group">
          <label class="re-form-label">Mensagem</label>
          <textarea class="re-form-textarea" placeholder="Descreva o imovel que procura ou seu interesse..."></textarea>
        </div>
        <button class="re-form-btn">Enviar Solicitacao</button>
      </div>
    </div>
  </div>
</section>

<!-- FOOTER -->
<footer class="re-footer">
  <div class="re-container">
    <div class="re-footer-grid">
      <div>
        <div class="re-footer-logo">🏠 PrimeImoveis</div>
        <p class="re-footer-desc">
          Ha mais de 15 anos realizando o sonho de milhares de familias.
          Compra, venda e locacao de imoveis com seguranca e transparencia.
        </p>
        <div class="re-footer-social">
          <a href="#">f</a>
          <a href="#">in</a>
          <a href="#">ig</a>
          <a href="#">yt</a>
        </div>
      </div>
      <div>
        <h4 class="re-footer-title">Imoveis</h4>
        <ul class="re-footer-links">
          <li><a href="#">Casas</a></li>
          <li><a href="#">Apartamentos</a></li>
          <li><a href="#">Terrenos</a></li>
          <li><a href="#">Comerciais</a></li>
          <li><a href="#">Lancamentos</a></li>
        </ul>
      </div>
      <div>
        <h4 class="re-footer-title">Empresa</h4>
        <ul class="re-footer-links">
          <li><a href="#">Sobre Nos</a></li>
          <li><a href="#">Nossa Equipe</a></li>
          <li><a href="#">Blog</a></li>
          <li><a href="#">Carreiras</a></li>
          <li><a href="#">Contato</a></li>
        </ul>
      </div>
      <div>
        <h4 class="re-footer-title">Servicos</h4>
        <ul class="re-footer-links">
          <li><a href="#">Comprar</a></li>
          <li><a href="#">Vender</a></li>
          <li><a href="#">Alugar</a></li>
          <li><a href="#">Financiamento</a></li>
          <li><a href="#">Avaliacao</a></li>
        </ul>
      </div>
    </div>
    <div class="re-footer-bottom">
      <p class="re-footer-copy">© 2024 PrimeImoveis. Todos os direitos reservados. CRECI-J 12345</p>
    </div>
  </div>
</footer>
`,
    gjsCss: '',
    gjsComponents: '',
    gjsStyles: ''
  },

  // ============================================
  // 15. FITNESS / ACADEMIA
  // ============================================
  {
    id: 'fitness-gym',
    name: 'Fitness & Academia',
    description: 'Landing page energética para academias e personal trainers',
    thumbnail: 'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=400&h=300&fit=crop',
    category: 'agency',
    gjsHtml: `
<style>
  * { box-sizing: border-box; margin: 0; padding: 0; }

  /* Navigation */
  .fit-nav { position: fixed; top: 0; left: 0; right: 0; z-index: 100; padding: 16px 24px; background: rgba(0,0,0,0.9); backdrop-filter: blur(10px); }
  .fit-nav-container { max-width: 1200px; margin: 0 auto; display: flex; align-items: center; justify-content: space-between; }
  .fit-nav-logo { font-size: 1.5rem; font-weight: 900; color: white; text-decoration: none; display: flex; align-items: center; gap: 8px; text-transform: uppercase; }
  .fit-nav-logo span { color: #ef4444; }
  .fit-nav-links { display: flex; gap: 32px; }
  .fit-nav-link { color: rgba(255,255,255,0.7); font-weight: 600; text-decoration: none; font-size: 14px; text-transform: uppercase; letter-spacing: 0.5px; transition: color 0.2s; }
  .fit-nav-link:hover { color: #ef4444; }
  .fit-nav-cta { padding: 12px 24px; background: #ef4444; color: white; font-weight: 700; border-radius: 8px; text-decoration: none; font-size: 14px; text-transform: uppercase; }

  /* Hero */
  .fit-hero { min-height: 100vh; background: linear-gradient(135deg, rgba(0,0,0,0.85), rgba(0,0,0,0.7)), url('https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=1920&h=1080&fit=crop') center/cover; display: flex; align-items: center; padding: 120px 24px 80px; }
  .fit-container { max-width: 1200px; margin: 0 auto; width: 100%; }
  .fit-hero-content { max-width: 700px; }
  .fit-badge { display: inline-flex; align-items: center; gap: 8px; padding: 12px 24px; background: linear-gradient(135deg, #ef4444, #dc2626); border-radius: 100px; color: white; font-size: 14px; font-weight: 700; margin-bottom: 24px; text-transform: uppercase; }
  .fit-title { font-size: 5rem; font-weight: 900; color: white; line-height: 0.95; margin-bottom: 24px; text-transform: uppercase; letter-spacing: -0.03em; }
  .fit-title span { color: #ef4444; display: block; }
  .fit-desc { font-size: 1.25rem; color: rgba(255,255,255,0.8); line-height: 1.7; margin-bottom: 40px; }
  .fit-ctas { display: flex; gap: 16px; flex-wrap: wrap; }
  .fit-btn-primary { padding: 20px 40px; background: #ef4444; color: white; font-weight: 800; font-size: 16px; border: none; border-radius: 12px; cursor: pointer; text-decoration: none; text-transform: uppercase; transition: transform 0.2s, box-shadow 0.2s; }
  .fit-btn-primary:hover { transform: translateY(-2px); box-shadow: 0 10px 30px rgba(239,68,68,0.4); }
  .fit-btn-secondary { padding: 20px 40px; background: transparent; color: white; font-weight: 700; font-size: 16px; border: 2px solid rgba(255,255,255,0.3); border-radius: 12px; cursor: pointer; text-decoration: none; text-transform: uppercase; }
  .fit-stats { display: flex; gap: 60px; margin-top: 60px; }
  .fit-stat-value { font-size: 3.5rem; font-weight: 900; color: #ef4444; line-height: 1; }
  .fit-stat-label { color: rgba(255,255,255,0.6); font-size: 14px; text-transform: uppercase; letter-spacing: 1px; margin-top: 8px; }

  /* Features */
  .fit-features { padding: 100px 24px; background: #0a0a0a; }
  .fit-features-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 32px; }
  .fit-feature { text-align: center; padding: 40px 24px; background: #111; border-radius: 20px; border: 1px solid #222; transition: transform 0.3s, border-color 0.3s; }
  .fit-feature:hover { transform: translateY(-8px); border-color: #ef4444; }
  .fit-feature-icon { width: 80px; height: 80px; background: linear-gradient(135deg, #ef4444, #dc2626); border-radius: 20px; display: flex; align-items: center; justify-content: center; margin: 0 auto 20px; font-size: 36px; }
  .fit-feature-title { font-size: 1.25rem; font-weight: 800; color: white; margin-bottom: 12px; text-transform: uppercase; }
  .fit-feature-desc { color: #71717a; font-size: 14px; line-height: 1.6; }

  /* Classes */
  .fit-classes { padding: 100px 24px; background: #111; }
  .fit-section-header { text-align: center; margin-bottom: 60px; }
  .fit-section-label { color: #ef4444; font-weight: 700; font-size: 14px; text-transform: uppercase; letter-spacing: 2px; margin-bottom: 12px; }
  .fit-section-title { font-size: 3rem; font-weight: 900; color: white; text-transform: uppercase; margin-bottom: 16px; }
  .fit-section-desc { color: #71717a; font-size: 1.1rem; max-width: 600px; margin: 0 auto; }
  .fit-classes-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; }
  .fit-class { position: relative; border-radius: 24px; overflow: hidden; height: 350px; }
  .fit-class-img { width: 100%; height: 100%; object-fit: cover; transition: transform 0.5s; }
  .fit-class:hover .fit-class-img { transform: scale(1.1); }
  .fit-class-overlay { position: absolute; inset: 0; background: linear-gradient(to top, rgba(0,0,0,0.9), transparent); display: flex; flex-direction: column; justify-content: flex-end; padding: 32px; }
  .fit-class-title { font-size: 1.5rem; font-weight: 800; color: white; text-transform: uppercase; margin-bottom: 8px; }
  .fit-class-info { color: rgba(255,255,255,0.7); font-size: 14px; display: flex; gap: 16px; }

  /* Trainers */
  .fit-trainers { padding: 100px 24px; background: #0a0a0a; }
  .fit-trainers-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 32px; }
  .fit-trainer { text-align: center; }
  .fit-trainer-img-wrap { position: relative; margin-bottom: 20px; }
  .fit-trainer-img { width: 100%; aspect-ratio: 3/4; object-fit: cover; border-radius: 20px; filter: grayscale(100%); transition: filter 0.3s; }
  .fit-trainer:hover .fit-trainer-img { filter: grayscale(0%); }
  .fit-trainer-badge { position: absolute; bottom: -10px; left: 50%; transform: translateX(-50%); padding: 8px 20px; background: #ef4444; color: white; font-size: 12px; font-weight: 700; border-radius: 100px; text-transform: uppercase; white-space: nowrap; }
  .fit-trainer-name { font-size: 1.25rem; font-weight: 800; color: white; margin-bottom: 4px; text-transform: uppercase; }
  .fit-trainer-specialty { color: #71717a; font-size: 14px; }

  /* Transformations */
  .fit-transform { padding: 100px 24px; background: #111; }
  .fit-transform-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 32px; }
  .fit-transform-card { background: #0a0a0a; border-radius: 24px; overflow: hidden; border: 1px solid #222; }
  .fit-transform-images { display: grid; grid-template-columns: 1fr 1fr; }
  .fit-transform-img { width: 100%; aspect-ratio: 1; object-fit: cover; }
  .fit-transform-content { padding: 24px; }
  .fit-transform-name { font-size: 1.1rem; font-weight: 700; color: white; margin-bottom: 4px; }
  .fit-transform-result { color: #ef4444; font-size: 14px; font-weight: 600; margin-bottom: 12px; }
  .fit-transform-text { color: #71717a; font-size: 14px; line-height: 1.6; }

  /* Plans */
  .fit-plans { padding: 100px 24px; background: #0a0a0a; }
  .fit-plans-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; max-width: 1000px; margin: 0 auto; }
  .fit-plan { background: #111; border: 1px solid #222; border-radius: 24px; padding: 40px; text-align: center; transition: transform 0.3s, border-color 0.3s; }
  .fit-plan:hover { transform: translateY(-8px); }
  .fit-plan.popular { background: linear-gradient(135deg, #1a1a1a, #111); border-color: #ef4444; transform: scale(1.05); }
  .fit-plan.popular:hover { transform: scale(1.08); }
  .fit-plan-badge { display: inline-block; padding: 8px 20px; background: #ef4444; color: white; font-size: 12px; font-weight: 700; border-radius: 100px; margin-bottom: 24px; text-transform: uppercase; }
  .fit-plan-name { color: white; font-size: 1.5rem; font-weight: 800; margin-bottom: 24px; text-transform: uppercase; }
  .fit-plan-price { font-size: 4rem; font-weight: 900; color: white; line-height: 1; }
  .fit-plan-price span { font-size: 1rem; color: #71717a; font-weight: 500; }
  .fit-plan-features { list-style: none; margin: 32px 0; text-align: left; }
  .fit-plan-features li { padding: 14px 0; color: #a1a1aa; border-bottom: 1px solid #222; display: flex; align-items: center; gap: 12px; font-size: 15px; }
  .fit-plan-features li:last-child { border: none; }
  .fit-plan-features li span { color: #ef4444; }
  .fit-plan-btn { width: 100%; padding: 18px; background: #ef4444; color: white; font-weight: 700; font-size: 16px; border: none; border-radius: 12px; cursor: pointer; text-transform: uppercase; transition: background 0.2s; }
  .fit-plan-btn:hover { background: #dc2626; }
  .fit-plan-btn.secondary { background: #333; }
  .fit-plan-btn.secondary:hover { background: #444; }

  /* Testimonials */
  .fit-testimonials { padding: 100px 24px; background: #111; }
  .fit-testimonials-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 32px; }
  .fit-testimonial { background: #0a0a0a; padding: 32px; border-radius: 24px; border: 1px solid #222; }
  .fit-testimonial-stars { color: #ef4444; font-size: 20px; margin-bottom: 16px; }
  .fit-testimonial-text { color: #a1a1aa; line-height: 1.7; margin-bottom: 24px; font-size: 15px; }
  .fit-testimonial-author { display: flex; align-items: center; gap: 16px; }
  .fit-testimonial-avatar { width: 56px; height: 56px; border-radius: 50%; object-fit: cover; border: 2px solid #ef4444; }
  .fit-testimonial-name { font-weight: 700; color: white; }
  .fit-testimonial-plan { color: #ef4444; font-size: 14px; font-weight: 600; }

  /* CTA */
  .fit-cta { padding: 120px 24px; background: linear-gradient(135deg, rgba(239,68,68,0.9), rgba(220,38,38,0.95)), url('https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=1920&h=800&fit=crop') center/cover; text-align: center; }
  .fit-cta-title { font-size: 3.5rem; font-weight: 900; color: white; text-transform: uppercase; margin-bottom: 16px; line-height: 1.1; }
  .fit-cta-desc { color: rgba(255,255,255,0.9); font-size: 1.25rem; margin-bottom: 40px; max-width: 600px; margin-left: auto; margin-right: auto; }
  .fit-cta-btn { padding: 24px 60px; background: white; color: #ef4444; font-weight: 800; font-size: 18px; border-radius: 12px; text-decoration: none; display: inline-block; text-transform: uppercase; transition: transform 0.2s; }
  .fit-cta-btn:hover { transform: scale(1.05); }

  /* Contact */
  .fit-contact { padding: 100px 24px; background: #0a0a0a; }
  .fit-contact-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: start; }
  .fit-contact-label { color: #ef4444; font-weight: 700; font-size: 14px; text-transform: uppercase; letter-spacing: 2px; margin-bottom: 12px; }
  .fit-contact-title { font-size: 2.5rem; font-weight: 900; color: white; margin-bottom: 24px; text-transform: uppercase; line-height: 1.1; }
  .fit-contact-text { color: #71717a; line-height: 1.7; margin-bottom: 40px; }
  .fit-contact-info { display: flex; flex-direction: column; gap: 24px; }
  .fit-contact-item { display: flex; align-items: flex-start; gap: 16px; }
  .fit-contact-icon { width: 56px; height: 56px; background: #ef4444; border-radius: 16px; display: flex; align-items: center; justify-content: center; font-size: 24px; flex-shrink: 0; }
  .fit-contact-item-title { font-weight: 700; color: white; margin-bottom: 4px; }
  .fit-contact-item-text { color: #71717a; font-size: 15px; }
  .fit-contact-form { background: #111; padding: 40px; border-radius: 24px; border: 1px solid #222; }
  .fit-form-title { font-size: 1.5rem; font-weight: 800; color: white; margin-bottom: 24px; text-transform: uppercase; }
  .fit-form-row { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; margin-bottom: 16px; }
  .fit-form-group { margin-bottom: 16px; }
  .fit-form-label { display: block; font-weight: 600; color: #a1a1aa; margin-bottom: 8px; font-size: 14px; text-transform: uppercase; }
  .fit-form-input { width: 100%; padding: 16px 20px; background: #0a0a0a; border: 2px solid #222; border-radius: 12px; font-size: 16px; color: white; transition: border-color 0.2s; outline: none; }
  .fit-form-input:focus { border-color: #ef4444; }
  .fit-form-select { width: 100%; padding: 16px 20px; background: #0a0a0a; border: 2px solid #222; border-radius: 12px; font-size: 16px; color: white; outline: none; cursor: pointer; }
  .fit-form-btn { width: 100%; padding: 18px; background: #ef4444; color: white; font-weight: 700; font-size: 16px; border: none; border-radius: 12px; cursor: pointer; text-transform: uppercase; transition: background 0.2s; }
  .fit-form-btn:hover { background: #dc2626; }

  /* Footer */
  .fit-footer { padding: 60px 24px 40px; background: #000; }
  .fit-footer-grid { display: grid; grid-template-columns: 2fr 1fr 1fr 1fr; gap: 60px; margin-bottom: 60px; }
  .fit-footer-logo { font-size: 1.5rem; font-weight: 900; color: white; margin-bottom: 16px; display: flex; align-items: center; gap: 8px; text-transform: uppercase; }
  .fit-footer-logo span { color: #ef4444; }
  .fit-footer-desc { color: #71717a; line-height: 1.7; margin-bottom: 24px; font-size: 14px; }
  .fit-footer-social { display: flex; gap: 12px; }
  .fit-footer-social a { width: 44px; height: 44px; background: #111; border-radius: 12px; display: flex; align-items: center; justify-content: center; color: white; text-decoration: none; transition: background 0.2s; }
  .fit-footer-social a:hover { background: #ef4444; }
  .fit-footer-title { font-weight: 700; color: white; margin-bottom: 24px; font-size: 1rem; text-transform: uppercase; }
  .fit-footer-links { list-style: none; }
  .fit-footer-links li { margin-bottom: 12px; }
  .fit-footer-links a { color: #71717a; text-decoration: none; font-size: 14px; transition: color 0.2s; }
  .fit-footer-links a:hover { color: #ef4444; }
  .fit-footer-bottom { border-top: 1px solid #222; padding-top: 40px; text-align: center; }
  .fit-footer-copy { color: #52525b; font-size: 14px; }

  @media (max-width: 968px) {
    .fit-nav-links { display: none; }
    .fit-hero { padding: 100px 24px 60px; }
    .fit-title { font-size: 3rem; }
    .fit-stats { gap: 32px; flex-wrap: wrap; }
    .fit-features-grid { grid-template-columns: repeat(2, 1fr); }
    .fit-classes-grid { grid-template-columns: 1fr; }
    .fit-trainers-grid { grid-template-columns: repeat(2, 1fr); }
    .fit-transform-grid { grid-template-columns: 1fr; }
    .fit-plans-grid { grid-template-columns: 1fr; }
    .fit-plan.popular { transform: none; }
    .fit-testimonials-grid { grid-template-columns: 1fr; }
    .fit-contact-grid { grid-template-columns: 1fr; }
    .fit-form-row { grid-template-columns: 1fr; }
    .fit-footer-grid { grid-template-columns: 1fr 1fr; gap: 40px; }
    .fit-cta-title { font-size: 2.5rem; }
  }
</style>

<!-- NAVIGATION -->
<nav class="fit-nav">
  <div class="fit-nav-container">
    <a href="#" class="fit-nav-logo">Iron<span>Fit</span></a>
    <div class="fit-nav-links">
      <a href="#" class="fit-nav-link">Inicio</a>
      <a href="#" class="fit-nav-link">Modalidades</a>
      <a href="#" class="fit-nav-link">Professores</a>
      <a href="#" class="fit-nav-link">Planos</a>
      <a href="#" class="fit-nav-link">Contato</a>
    </div>
    <a href="#" class="fit-nav-cta">Matricule-se</a>
  </div>
</nav>

<!-- HERO -->
<section class="fit-hero">
  <div class="fit-container">
    <div class="fit-hero-content">
      <div class="fit-badge">🔥 Primeira semana gratis</div>
      <h1 class="fit-title">
        Transforme seu <span>corpo</span> transforme sua <span>vida</span>
      </h1>
      <p class="fit-desc">
        A maior academia da regiao com mais de 2.000m² de estrutura, equipamentos de ultima
        geracao, mais de 50 modalidades e professores altamente qualificados. Venha fazer parte
        dessa revolucao.
      </p>
      <div class="fit-ctas">
        <a href="#" class="fit-btn-primary">Comecar Agora →</a>
        <a href="#" class="fit-btn-secondary">Conhecer a Academia</a>
      </div>
      <div class="fit-stats">
        <div>
          <div class="fit-stat-value">5.000+</div>
          <div class="fit-stat-label">Alunos ativos</div>
        </div>
        <div>
          <div class="fit-stat-value">50+</div>
          <div class="fit-stat-label">Modalidades</div>
        </div>
        <div>
          <div class="fit-stat-value">24h</div>
          <div class="fit-stat-label">Funcionamento</div>
        </div>
        <div>
          <div class="fit-stat-value">15+</div>
          <div class="fit-stat-label">Anos de historia</div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- FEATURES -->
<section class="fit-features">
  <div class="fit-container">
    <div class="fit-features-grid">
      <div class="fit-feature">
        <div class="fit-feature-icon">💪</div>
        <h3 class="fit-feature-title">Musculacao</h3>
        <p class="fit-feature-desc">Equipamentos de ultima geracao para todos os niveis</p>
      </div>
      <div class="fit-feature">
        <div class="fit-feature-icon">🏃</div>
        <h3 class="fit-feature-title">Cardio</h3>
        <p class="fit-feature-desc">Area completa com esteiras, bikes e elipticos</p>
      </div>
      <div class="fit-feature">
        <div class="fit-feature-icon">🥊</div>
        <h3 class="fit-feature-title">Lutas</h3>
        <p class="fit-feature-desc">Muay Thai, Jiu-Jitsu, Boxe e muito mais</p>
      </div>
      <div class="fit-feature">
        <div class="fit-feature-icon">🧘</div>
        <h3 class="fit-feature-title">Bem-estar</h3>
        <p class="fit-feature-desc">Yoga, Pilates e meditacao guiada</p>
      </div>
    </div>
  </div>
</section>

<!-- CLASSES -->
<section class="fit-classes">
  <div class="fit-container">
    <div class="fit-section-header">
      <div class="fit-section-label">Modalidades</div>
      <h2 class="fit-section-title">Aulas para todos os estilos</h2>
      <p class="fit-section-desc">Mais de 50 modalidades diferentes para voce escolher e montar seu treino ideal.</p>
    </div>
    <div class="fit-classes-grid">
      <div class="fit-class">
        <img src="https://images.unsplash.com/photo-1518611012118-696072aa579a?w=600&h=500&fit=crop" class="fit-class-img" alt="Spinning" />
        <div class="fit-class-overlay">
          <h3 class="fit-class-title">Spinning</h3>
          <div class="fit-class-info">
            <span>🕐 45 min</span>
            <span>🔥 600 kcal</span>
            <span>📍 Sala 1</span>
          </div>
        </div>
      </div>
      <div class="fit-class">
        <img src="https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=600&h=500&fit=crop" class="fit-class-img" alt="CrossFit" />
        <div class="fit-class-overlay">
          <h3 class="fit-class-title">CrossFit</h3>
          <div class="fit-class-info">
            <span>🕐 60 min</span>
            <span>🔥 800 kcal</span>
            <span>📍 Box</span>
          </div>
        </div>
      </div>
      <div class="fit-class">
        <img src="https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=600&h=500&fit=crop" class="fit-class-img" alt="Yoga" />
        <div class="fit-class-overlay">
          <h3 class="fit-class-title">Yoga</h3>
          <div class="fit-class-info">
            <span>🕐 50 min</span>
            <span>🧘 Relaxamento</span>
            <span>📍 Sala 3</span>
          </div>
        </div>
      </div>
      <div class="fit-class">
        <img src="https://images.unsplash.com/photo-1549576490-b0b4831ef60a?w=600&h=500&fit=crop" class="fit-class-img" alt="Funcional" />
        <div class="fit-class-overlay">
          <h3 class="fit-class-title">Funcional</h3>
          <div class="fit-class-info">
            <span>🕐 45 min</span>
            <span>🔥 500 kcal</span>
            <span>📍 Area externa</span>
          </div>
        </div>
      </div>
      <div class="fit-class">
        <img src="https://images.unsplash.com/photo-1517438322307-e67111335449?w=600&h=500&fit=crop" class="fit-class-img" alt="Muay Thai" />
        <div class="fit-class-overlay">
          <h3 class="fit-class-title">Muay Thai</h3>
          <div class="fit-class-info">
            <span>🕐 60 min</span>
            <span>🔥 700 kcal</span>
            <span>📍 Sala de lutas</span>
          </div>
        </div>
      </div>
      <div class="fit-class">
        <img src="https://images.unsplash.com/photo-1518310383802-640c2de311b2?w=600&h=500&fit=crop" class="fit-class-img" alt="Dance" />
        <div class="fit-class-overlay">
          <h3 class="fit-class-title">Dance Fit</h3>
          <div class="fit-class-info">
            <span>🕐 50 min</span>
            <span>🔥 550 kcal</span>
            <span>📍 Sala 2</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- TRAINERS -->
<section class="fit-trainers">
  <div class="fit-container">
    <div class="fit-section-header">
      <div class="fit-section-label">Equipe</div>
      <h2 class="fit-section-title">Professores Especialistas</h2>
      <p class="fit-section-desc">Profissionais certificados e apaixonados prontos para guiar sua transformacao.</p>
    </div>
    <div class="fit-trainers-grid">
      <div class="fit-trainer">
        <div class="fit-trainer-img-wrap">
          <img src="https://images.unsplash.com/photo-1567013127542-490d757e51fc?w=400&h=500&fit=crop" class="fit-trainer-img" alt="Personal" />
          <span class="fit-trainer-badge">Personal Trainer</span>
        </div>
        <h3 class="fit-trainer-name">Carlos Ferreira</h3>
        <p class="fit-trainer-specialty">Musculacao e Hipertrofia</p>
      </div>
      <div class="fit-trainer">
        <div class="fit-trainer-img-wrap">
          <img src="https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=400&h=500&fit=crop" class="fit-trainer-img" alt="Personal" />
          <span class="fit-trainer-badge">CrossFit Coach</span>
        </div>
        <h3 class="fit-trainer-name">Ana Paula</h3>
        <p class="fit-trainer-specialty">CrossFit e Funcional</p>
      </div>
      <div class="fit-trainer">
        <div class="fit-trainer-img-wrap">
          <img src="https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=400&h=500&fit=crop" class="fit-trainer-img" alt="Personal" />
          <span class="fit-trainer-badge">Instrutor</span>
        </div>
        <h3 class="fit-trainer-name">Roberto Lima</h3>
        <p class="fit-trainer-specialty">Muay Thai e Boxe</p>
      </div>
      <div class="fit-trainer">
        <div class="fit-trainer-img-wrap">
          <img src="https://images.unsplash.com/photo-1518611012118-696072aa579a?w=400&h=500&fit=crop" class="fit-trainer-img" alt="Personal" />
          <span class="fit-trainer-badge">Instrutora</span>
        </div>
        <h3 class="fit-trainer-name">Marina Costa</h3>
        <p class="fit-trainer-specialty">Spinning e Dance</p>
      </div>
    </div>
  </div>
</section>

<!-- TRANSFORMATIONS -->
<section class="fit-transform">
  <div class="fit-container">
    <div class="fit-section-header">
      <div class="fit-section-label">Resultados</div>
      <h2 class="fit-section-title">Transformacoes Reais</h2>
      <p class="fit-section-desc">Veja os resultados incriveis que nossos alunos alcancaram.</p>
    </div>
    <div class="fit-transform-grid">
      <div class="fit-transform-card">
        <div class="fit-transform-images">
          <img src="https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=300&h=300&fit=crop" class="fit-transform-img" alt="Antes" />
          <img src="https://images.unsplash.com/photo-1583454110551-21f2fa2afe61?w=300&h=300&fit=crop" class="fit-transform-img" alt="Depois" />
        </div>
        <div class="fit-transform-content">
          <h4 class="fit-transform-name">Pedro Augusto</h4>
          <p class="fit-transform-result">-25kg em 8 meses</p>
          <p class="fit-transform-text">"A IronFit mudou minha vida. Com a ajuda dos profissionais consegui alcançar resultados que nunca imaginei."</p>
        </div>
      </div>
      <div class="fit-transform-card">
        <div class="fit-transform-images">
          <img src="https://images.unsplash.com/photo-1518310383802-640c2de311b2?w=300&h=300&fit=crop" class="fit-transform-img" alt="Antes" />
          <img src="https://images.unsplash.com/photo-1548690312-e3b507d8c110?w=300&h=300&fit=crop" class="fit-transform-img" alt="Depois" />
        </div>
        <div class="fit-transform-content">
          <h4 class="fit-transform-name">Juliana Santos</h4>
          <p class="fit-transform-result">-18kg em 6 meses</p>
          <p class="fit-transform-text">"Encontrei na academia nao so um lugar para treinar, mas uma familia que me apoia todos os dias."</p>
        </div>
      </div>
      <div class="fit-transform-card">
        <div class="fit-transform-images">
          <img src="https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=300&h=300&fit=crop" class="fit-transform-img" alt="Antes" />
          <img src="https://images.unsplash.com/photo-1567013127542-490d757e51fc?w=300&h=300&fit=crop" class="fit-transform-img" alt="Depois" />
        </div>
        <div class="fit-transform-content">
          <h4 class="fit-transform-name">Marcos Silva</h4>
          <p class="fit-transform-result">+12kg massa magra</p>
          <p class="fit-transform-text">"O acompanhamento personalizado fez toda diferenca. Resultados que parecem impossiveis se tornam reais."</p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- PLANS -->
<section class="fit-plans">
  <div class="fit-container">
    <div class="fit-section-header">
      <div class="fit-section-label">Planos</div>
      <h2 class="fit-section-title">Escolha o seu</h2>
      <p class="fit-section-desc">Planos flexiveis para todos os objetivos e bolsos.</p>
    </div>
    <div class="fit-plans-grid">
      <div class="fit-plan">
        <h3 class="fit-plan-name">Basic</h3>
        <div class="fit-plan-price">R$99<span>/mes</span></div>
        <ul class="fit-plan-features">
          <li><span>✓</span> Musculacao completa</li>
          <li><span>✓</span> Area de cardio</li>
          <li><span>✓</span> Vestiario com armario</li>
          <li><span>✓</span> Horario comercial</li>
          <li><span>✗</span> Aulas coletivas</li>
        </ul>
        <button class="fit-plan-btn secondary">Escolher Plano</button>
      </div>
      <div class="fit-plan popular">
        <div class="fit-plan-badge">Mais popular</div>
        <h3 class="fit-plan-name">Premium</h3>
        <div class="fit-plan-price">R$149<span>/mes</span></div>
        <ul class="fit-plan-features">
          <li><span>✓</span> Tudo do Basic</li>
          <li><span>✓</span> Todas aulas coletivas</li>
          <li><span>✓</span> Avaliacao fisica mensal</li>
          <li><span>✓</span> App exclusivo</li>
          <li><span>✓</span> Acesso 24 horas</li>
        </ul>
        <button class="fit-plan-btn">Escolher Plano</button>
      </div>
      <div class="fit-plan">
        <h3 class="fit-plan-name">Black</h3>
        <div class="fit-plan-price">R$249<span>/mes</span></div>
        <ul class="fit-plan-features">
          <li><span>✓</span> Tudo do Premium</li>
          <li><span>✓</span> Personal trainer incluso</li>
          <li><span>✓</span> Nutricionista mensal</li>
          <li><span>✓</span> Area VIP exclusiva</li>
          <li><span>✓</span> Convide 1 amigo</li>
        </ul>
        <button class="fit-plan-btn secondary">Escolher Plano</button>
      </div>
    </div>
  </div>
</section>

<!-- TESTIMONIALS -->
<section class="fit-testimonials">
  <div class="fit-container">
    <div class="fit-section-header">
      <div class="fit-section-label">Depoimentos</div>
      <h2 class="fit-section-title">O que nossos alunos dizem</h2>
    </div>
    <div class="fit-testimonials-grid">
      <div class="fit-testimonial">
        <div class="fit-testimonial-stars">★★★★★</div>
        <p class="fit-testimonial-text">"Melhor academia que ja treinei. Equipamentos novos, professores atenciosos e ambiente super motivador. Recomendo demais!"</p>
        <div class="fit-testimonial-author">
          <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop" class="fit-testimonial-avatar" alt="Aluno" />
          <div>
            <div class="fit-testimonial-name">Rafael Mendes</div>
            <div class="fit-testimonial-plan">Plano Premium</div>
          </div>
        </div>
      </div>
      <div class="fit-testimonial">
        <div class="fit-testimonial-stars">★★★★★</div>
        <p class="fit-testimonial-text">"As aulas de spinning sao incriveis! A Marina e uma professora excepcional que nos motiva a cada pedalada. Viciei!"</p>
        <div class="fit-testimonial-author">
          <img src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop" class="fit-testimonial-avatar" alt="Aluna" />
          <div>
            <div class="fit-testimonial-name">Camila Oliveira</div>
            <div class="fit-testimonial-plan">Plano Premium</div>
          </div>
        </div>
      </div>
      <div class="fit-testimonial">
        <div class="fit-testimonial-stars">★★★★★</div>
        <p class="fit-testimonial-text">"O plano Black vale cada centavo. Ter um personal e nutricionista fez toda diferenca nos meus resultados. Perdi 20kg!"</p>
        <div class="fit-testimonial-author">
          <img src="https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=100&h=100&fit=crop" class="fit-testimonial-avatar" alt="Aluna" />
          <div>
            <div class="fit-testimonial-name">Fernanda Lima</div>
            <div class="fit-testimonial-plan">Plano Black</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- CTA -->
<section class="fit-cta">
  <div class="fit-container">
    <h2 class="fit-cta-title">Sua transformacao comeca agora</h2>
    <p class="fit-cta-desc">Nao deixe para amanha o que pode mudar sua vida hoje. Junte-se a mais de 5.000 alunos que ja transformaram seus corpos e mentes.</p>
    <a href="#" class="fit-cta-btn">Agende sua aula experimental gratuita</a>
  </div>
</section>

<!-- CONTACT -->
<section class="fit-contact">
  <div class="fit-container">
    <div class="fit-contact-grid">
      <div>
        <div class="fit-contact-label">Fale Conosco</div>
        <h2 class="fit-contact-title">Pronto para comecar sua transformacao?</h2>
        <p class="fit-contact-text">
          Entre em contato conosco ou preencha o formulario para agendar sua visita
          e conhecer nossa estrutura. A primeira aula e por nossa conta!
        </p>
        <div class="fit-contact-info">
          <div class="fit-contact-item">
            <div class="fit-contact-icon">📍</div>
            <div>
              <div class="fit-contact-item-title">Endereco</div>
              <div class="fit-contact-item-text">Av. Brasil, 1500 - Centro<br/>Sao Paulo - SP, 01430-000</div>
            </div>
          </div>
          <div class="fit-contact-item">
            <div class="fit-contact-icon">📞</div>
            <div>
              <div class="fit-contact-item-title">Telefone</div>
              <div class="fit-contact-item-text">(11) 3456-7890<br/>WhatsApp: (11) 98765-4321</div>
            </div>
          </div>
          <div class="fit-contact-item">
            <div class="fit-contact-icon">🕐</div>
            <div>
              <div class="fit-contact-item-title">Horario</div>
              <div class="fit-contact-item-text">Segunda a Sexta: 24 horas<br/>Sabado e Domingo: 6h - 22h</div>
            </div>
          </div>
        </div>
      </div>
      <div class="fit-contact-form">
        <h3 class="fit-form-title">Agende sua visita</h3>
        <div class="fit-form-row">
          <div class="fit-form-group">
            <label class="fit-form-label">Nome</label>
            <input type="text" class="fit-form-input" placeholder="Seu nome" />
          </div>
          <div class="fit-form-group">
            <label class="fit-form-label">Telefone</label>
            <input type="tel" class="fit-form-input" placeholder="(11) 99999-9999" />
          </div>
        </div>
        <div class="fit-form-group">
          <label class="fit-form-label">E-mail</label>
          <input type="email" class="fit-form-input" placeholder="seu@email.com" />
        </div>
        <div class="fit-form-group">
          <label class="fit-form-label">Objetivo</label>
          <select class="fit-form-select">
            <option>Selecione seu objetivo</option>
            <option>Perder peso</option>
            <option>Ganhar massa muscular</option>
            <option>Condicionamento fisico</option>
            <option>Qualidade de vida</option>
            <option>Outro</option>
          </select>
        </div>
        <button class="fit-form-btn">Agendar Visita Gratuita</button>
      </div>
    </div>
  </div>
</section>

<!-- FOOTER -->
<footer class="fit-footer">
  <div class="fit-container">
    <div class="fit-footer-grid">
      <div>
        <div class="fit-footer-logo">Iron<span>Fit</span></div>
        <p class="fit-footer-desc">
          Ha mais de 15 anos transformando vidas atraves do fitness.
          Junte-se a nos e descubra seu potencial.
        </p>
        <div class="fit-footer-social">
          <a href="#">f</a>
          <a href="#">in</a>
          <a href="#">ig</a>
          <a href="#">yt</a>
        </div>
      </div>
      <div>
        <h4 class="fit-footer-title">Modalidades</h4>
        <ul class="fit-footer-links">
          <li><a href="#">Musculacao</a></li>
          <li><a href="#">CrossFit</a></li>
          <li><a href="#">Spinning</a></li>
          <li><a href="#">Lutas</a></li>
          <li><a href="#">Yoga</a></li>
        </ul>
      </div>
      <div>
        <h4 class="fit-footer-title">A Academia</h4>
        <ul class="fit-footer-links">
          <li><a href="#">Sobre</a></li>
          <li><a href="#">Estrutura</a></li>
          <li><a href="#">Professores</a></li>
          <li><a href="#">Planos</a></li>
          <li><a href="#">Blog</a></li>
        </ul>
      </div>
      <div>
        <h4 class="fit-footer-title">Suporte</h4>
        <ul class="fit-footer-links">
          <li><a href="#">Contato</a></li>
          <li><a href="#">FAQ</a></li>
          <li><a href="#">Trabalhe Conosco</a></li>
          <li><a href="#">Termos de Uso</a></li>
          <li><a href="#">Privacidade</a></li>
        </ul>
      </div>
    </div>
    <div class="fit-footer-bottom">
      <p class="fit-footer-copy">© 2024 IronFit Academia. Todos os direitos reservados. CREF 012345-G/SP</p>
    </div>
  </div>
</footer>
`,
    gjsCss: '',
    gjsComponents: '',
    gjsStyles: ''
  },

  // ============================================
  // 16. PODCAST
  // ============================================
  {
    id: 'podcast-show',
    name: 'Podcast',
    description: 'Landing page moderna para podcasts e shows',
    thumbnail: 'https://images.unsplash.com/photo-1478737270239-2f02b77fc618?w=400&h=300&fit=crop',
    category: 'lead-magnet',
    gjsHtml: `
<style>
  * { box-sizing: border-box; margin: 0; padding: 0; }

  /* Base */
  .pod-page { background: #0a0a0a; min-height: 100vh; font-family: system-ui, -apple-system, sans-serif; }

  /* Navigation */
  .pod-nav { position: fixed; top: 0; left: 0; right: 0; z-index: 100; padding: 16px 24px; background: rgba(10,10,10,0.9); backdrop-filter: blur(10px); border-bottom: 1px solid rgba(255,255,255,0.05); }
  .pod-nav-container { max-width: 1100px; margin: 0 auto; display: flex; align-items: center; justify-content: space-between; }
  .pod-nav-logo { font-size: 1.5rem; font-weight: 800; color: white; text-decoration: none; display: flex; align-items: center; gap: 8px; }
  .pod-nav-logo span { background: linear-gradient(135deg, #8b5cf6, #d946ef); -webkit-background-clip: text; -webkit-text-fill-color: transparent; }
  .pod-nav-links { display: flex; gap: 32px; }
  .pod-nav-link { color: rgba(255,255,255,0.6); font-weight: 500; text-decoration: none; font-size: 14px; transition: color 0.2s; }
  .pod-nav-link:hover { color: #a78bfa; }
  .pod-nav-cta { padding: 10px 20px; background: linear-gradient(135deg, #8b5cf6, #d946ef); color: white; font-weight: 600; border-radius: 10px; text-decoration: none; font-size: 14px; }

  /* Hero */
  .pod-hero { padding: 140px 24px 100px; background: linear-gradient(180deg, #0a0a0a 0%, #111 100%); }
  .pod-container { max-width: 1100px; margin: 0 auto; }
  .pod-hero-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: center; }
  .pod-badge { display: inline-flex; align-items: center; gap: 8px; padding: 12px 24px; background: rgba(139, 92, 246, 0.15); border: 1px solid rgba(139, 92, 246, 0.3); border-radius: 100px; color: #a78bfa; font-size: 14px; font-weight: 600; margin-bottom: 24px; }
  .pod-title { font-size: 3.5rem; font-weight: 800; color: white; line-height: 1.1; margin-bottom: 24px; }
  .pod-title span { background: linear-gradient(135deg, #8b5cf6, #d946ef); -webkit-background-clip: text; -webkit-text-fill-color: transparent; }
  .pod-desc { font-size: 1.2rem; color: #a1a1aa; line-height: 1.7; margin-bottom: 32px; }
  .pod-platforms { display: flex; gap: 12px; flex-wrap: wrap; margin-bottom: 40px; }
  .pod-platform { display: flex; align-items: center; gap: 10px; padding: 14px 24px; background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1); border-radius: 12px; color: white; text-decoration: none; font-weight: 600; font-size: 15px; transition: all 0.2s; }
  .pod-platform:hover { background: rgba(139, 92, 246, 0.2); border-color: #8b5cf6; }
  .pod-platform-icon { font-size: 20px; }
  .pod-stats { display: flex; gap: 48px; }
  .pod-stat-value { font-size: 2.5rem; font-weight: 800; color: white; line-height: 1; }
  .pod-stat-label { color: #71717a; font-size: 14px; margin-top: 4px; }
  .pod-cover { position: relative; }
  .pod-cover img { width: 100%; border-radius: 24px; box-shadow: 0 30px 60px rgba(139, 92, 246, 0.25); }
  .pod-cover-badge { position: absolute; top: -16px; right: -16px; width: 80px; height: 80px; background: linear-gradient(135deg, #8b5cf6, #d946ef); border-radius: 50%; display: flex; flex-direction: column; align-items: center; justify-content: center; color: white; font-weight: 800; box-shadow: 0 10px 30px rgba(139, 92, 246, 0.4); }
  .pod-cover-badge-num { font-size: 1.5rem; line-height: 1; }
  .pod-cover-badge-text { font-size: 10px; text-transform: uppercase; }

  /* About Host */
  .pod-about { padding: 100px 24px; background: #0f0f0f; }
  .pod-about-grid { display: grid; grid-template-columns: 400px 1fr; gap: 80px; align-items: center; }
  .pod-about-image { position: relative; }
  .pod-about-img { width: 100%; border-radius: 24px; }
  .pod-about-social { position: absolute; bottom: -20px; left: 50%; transform: translateX(-50%); display: flex; gap: 12px; }
  .pod-about-social a { width: 44px; height: 44px; background: linear-gradient(135deg, #8b5cf6, #d946ef); border-radius: 12px; display: flex; align-items: center; justify-content: center; color: white; text-decoration: none; font-size: 18px; }
  .pod-section-label { color: #8b5cf6; font-weight: 600; font-size: 14px; text-transform: uppercase; letter-spacing: 2px; margin-bottom: 12px; }
  .pod-section-title { font-size: 2.5rem; font-weight: 800; color: white; margin-bottom: 24px; line-height: 1.2; }
  .pod-about-text { color: #a1a1aa; line-height: 1.8; margin-bottom: 24px; font-size: 1.05rem; }
  .pod-about-highlights { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; margin-top: 32px; }
  .pod-about-highlight { display: flex; align-items: center; gap: 12px; padding: 16px; background: rgba(139, 92, 246, 0.1); border-radius: 12px; }
  .pod-about-highlight-icon { font-size: 24px; }
  .pod-about-highlight-text { color: white; font-weight: 600; }

  /* Topics */
  .pod-topics { padding: 100px 24px; background: #111; }
  .pod-section-header { text-align: center; margin-bottom: 60px; }
  .pod-section-desc { color: #71717a; font-size: 1.1rem; max-width: 600px; margin: 0 auto; }
  .pod-topics-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 24px; }
  .pod-topic { background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.08); border-radius: 20px; padding: 32px; text-align: center; transition: all 0.3s; }
  .pod-topic:hover { background: rgba(139, 92, 246, 0.1); border-color: rgba(139, 92, 246, 0.3); transform: translateY(-8px); }
  .pod-topic-icon { width: 72px; height: 72px; background: linear-gradient(135deg, rgba(139, 92, 246, 0.2), rgba(217, 70, 239, 0.2)); border-radius: 20px; display: flex; align-items: center; justify-content: center; margin: 0 auto 20px; font-size: 32px; }
  .pod-topic-title { font-size: 1.1rem; font-weight: 700; color: white; margin-bottom: 8px; }
  .pod-topic-count { color: #8b5cf6; font-size: 14px; font-weight: 600; }

  /* Episodes */
  .pod-episodes { padding: 100px 24px; background: #0a0a0a; }
  .pod-episodes-tabs { display: flex; justify-content: center; gap: 12px; margin-bottom: 48px; }
  .pod-tab { padding: 12px 24px; background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1); border-radius: 100px; color: #71717a; font-weight: 600; cursor: pointer; transition: all 0.2s; }
  .pod-tab.active { background: linear-gradient(135deg, #8b5cf6, #d946ef); border-color: transparent; color: white; }
  .pod-episodes-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 24px; max-width: 1000px; margin: 0 auto; }
  .pod-episode { display: flex; align-items: center; gap: 20px; padding: 24px; background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.08); border-radius: 20px; transition: all 0.3s; }
  .pod-episode:hover { background: rgba(139, 92, 246, 0.1); border-color: rgba(139, 92, 246, 0.3); }
  .pod-episode-num { width: 56px; height: 56px; background: linear-gradient(135deg, #8b5cf6, #d946ef); border-radius: 16px; display: flex; align-items: center; justify-content: center; color: white; font-weight: 800; font-size: 18px; flex-shrink: 0; }
  .pod-episode-content { flex: 1; min-width: 0; }
  .pod-episode-title { color: white; font-weight: 600; font-size: 1rem; margin-bottom: 6px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .pod-episode-meta { display: flex; gap: 16px; color: #71717a; font-size: 13px; }
  .pod-episode-play { width: 48px; height: 48px; background: rgba(139, 92, 246, 0.2); border-radius: 50%; display: flex; align-items: center; justify-content: center; color: #8b5cf6; cursor: pointer; transition: all 0.2s; flex-shrink: 0; }
  .pod-episode-play:hover { background: #8b5cf6; color: white; }
  .pod-episodes-cta { text-align: center; margin-top: 48px; }
  .pod-btn-secondary { display: inline-flex; align-items: center; gap: 8px; padding: 16px 32px; background: transparent; border: 2px solid rgba(139, 92, 246, 0.5); color: #a78bfa; font-weight: 600; border-radius: 12px; text-decoration: none; transition: all 0.2s; }
  .pod-btn-secondary:hover { background: rgba(139, 92, 246, 0.1); border-color: #8b5cf6; }

  /* Guests */
  .pod-guests { padding: 100px 24px; background: #111; }
  .pod-guests-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 32px; }
  .pod-guest { text-align: center; }
  .pod-guest-img { width: 120px; height: 120px; border-radius: 50%; object-fit: cover; margin: 0 auto 16px; border: 3px solid rgba(139, 92, 246, 0.3); transition: all 0.3s; }
  .pod-guest:hover .pod-guest-img { border-color: #8b5cf6; transform: scale(1.05); }
  .pod-guest-name { font-weight: 700; color: white; margin-bottom: 4px; }
  .pod-guest-role { color: #71717a; font-size: 14px; }

  /* Newsletter */
  .pod-newsletter { padding: 100px 24px; background: linear-gradient(135deg, rgba(139, 92, 246, 0.15), rgba(217, 70, 239, 0.15)); }
  .pod-newsletter-box { max-width: 700px; margin: 0 auto; text-align: center; }
  .pod-newsletter-title { font-size: 2.5rem; font-weight: 800; color: white; margin-bottom: 16px; }
  .pod-newsletter-desc { color: #a1a1aa; font-size: 1.1rem; margin-bottom: 32px; }
  .pod-newsletter-form { display: flex; gap: 12px; max-width: 500px; margin: 0 auto; }
  .pod-newsletter-input { flex: 1; padding: 18px 24px; background: rgba(255,255,255,0.1); border: 2px solid rgba(255,255,255,0.1); border-radius: 12px; font-size: 16px; color: white; outline: none; }
  .pod-newsletter-input::placeholder { color: #71717a; }
  .pod-newsletter-input:focus { border-color: #8b5cf6; }
  .pod-newsletter-btn { padding: 18px 32px; background: linear-gradient(135deg, #8b5cf6, #d946ef); color: white; font-weight: 700; font-size: 16px; border: none; border-radius: 12px; cursor: pointer; white-space: nowrap; }

  /* Testimonials */
  .pod-testimonials { padding: 100px 24px; background: #0a0a0a; }
  .pod-testimonials-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 32px; }
  .pod-testimonial { background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.08); border-radius: 24px; padding: 32px; }
  .pod-testimonial-stars { color: #fbbf24; font-size: 18px; margin-bottom: 16px; }
  .pod-testimonial-text { color: #a1a1aa; line-height: 1.7; margin-bottom: 24px; font-size: 15px; }
  .pod-testimonial-author { display: flex; align-items: center; gap: 16px; }
  .pod-testimonial-avatar { width: 48px; height: 48px; border-radius: 50%; object-fit: cover; }
  .pod-testimonial-name { font-weight: 700; color: white; }
  .pod-testimonial-handle { color: #8b5cf6; font-size: 14px; }

  /* Sponsors */
  .pod-sponsors { padding: 80px 24px; background: #111; }
  .pod-sponsors-label { text-align: center; color: #52525b; font-size: 14px; text-transform: uppercase; letter-spacing: 2px; margin-bottom: 40px; }
  .pod-sponsors-grid { display: flex; justify-content: center; align-items: center; gap: 60px; flex-wrap: wrap; opacity: 0.5; }
  .pod-sponsor { font-size: 1.5rem; font-weight: 800; color: white; }

  /* CTA */
  .pod-cta { padding: 100px 24px; background: linear-gradient(135deg, #8b5cf6, #d946ef); text-align: center; }
  .pod-cta-title { font-size: 3rem; font-weight: 800; color: white; margin-bottom: 16px; }
  .pod-cta-desc { color: rgba(255,255,255,0.9); font-size: 1.2rem; margin-bottom: 40px; max-width: 600px; margin-left: auto; margin-right: auto; }
  .pod-cta-platforms { display: flex; justify-content: center; gap: 16px; flex-wrap: wrap; }
  .pod-cta-platform { display: flex; align-items: center; gap: 10px; padding: 16px 32px; background: white; color: #8b5cf6; font-weight: 700; font-size: 16px; border-radius: 12px; text-decoration: none; transition: transform 0.2s; }
  .pod-cta-platform:hover { transform: scale(1.05); }

  /* Footer */
  .pod-footer { padding: 60px 24px 40px; background: #0a0a0a; border-top: 1px solid rgba(255,255,255,0.05); }
  .pod-footer-grid { display: grid; grid-template-columns: 2fr 1fr 1fr 1fr; gap: 60px; margin-bottom: 60px; }
  .pod-footer-logo { font-size: 1.5rem; font-weight: 800; color: white; margin-bottom: 16px; display: flex; align-items: center; gap: 8px; }
  .pod-footer-logo span { background: linear-gradient(135deg, #8b5cf6, #d946ef); -webkit-background-clip: text; -webkit-text-fill-color: transparent; }
  .pod-footer-desc { color: #71717a; line-height: 1.7; margin-bottom: 24px; font-size: 14px; }
  .pod-footer-social { display: flex; gap: 12px; }
  .pod-footer-social a { width: 40px; height: 40px; background: rgba(255,255,255,0.05); border-radius: 10px; display: flex; align-items: center; justify-content: center; color: white; text-decoration: none; transition: background 0.2s; }
  .pod-footer-social a:hover { background: #8b5cf6; }
  .pod-footer-title { font-weight: 700; color: white; margin-bottom: 20px; font-size: 1rem; }
  .pod-footer-links { list-style: none; }
  .pod-footer-links li { margin-bottom: 12px; }
  .pod-footer-links a { color: #71717a; text-decoration: none; font-size: 14px; transition: color 0.2s; }
  .pod-footer-links a:hover { color: #a78bfa; }
  .pod-footer-bottom { border-top: 1px solid rgba(255,255,255,0.05); padding-top: 40px; text-align: center; }
  .pod-footer-copy { color: #52525b; font-size: 14px; }

  @media (max-width: 968px) {
    .pod-nav-links { display: none; }
    .pod-hero { padding: 100px 24px 60px; }
    .pod-hero-grid { grid-template-columns: 1fr; gap: 40px; }
    .pod-title { font-size: 2.5rem; }
    .pod-cover { order: -1; }
    .pod-about-grid { grid-template-columns: 1fr; gap: 40px; }
    .pod-about-image { order: -1; max-width: 300px; margin: 0 auto; }
    .pod-topics-grid { grid-template-columns: repeat(2, 1fr); }
    .pod-episodes-grid { grid-template-columns: 1fr; }
    .pod-guests-grid { grid-template-columns: repeat(2, 1fr); }
    .pod-testimonials-grid { grid-template-columns: 1fr; }
    .pod-newsletter-form { flex-direction: column; }
    .pod-cta-title { font-size: 2rem; }
    .pod-footer-grid { grid-template-columns: 1fr 1fr; gap: 40px; }
  }
</style>

<div class="pod-page">
  <!-- NAVIGATION -->
  <nav class="pod-nav">
    <div class="pod-nav-container">
      <a href="#" class="pod-nav-logo">🎙️ Startup<span>Cast</span></a>
      <div class="pod-nav-links">
        <a href="#" class="pod-nav-link">Episodios</a>
        <a href="#" class="pod-nav-link">Sobre</a>
        <a href="#" class="pod-nav-link">Convidados</a>
        <a href="#" class="pod-nav-link">Newsletter</a>
        <a href="#" class="pod-nav-link">Contato</a>
      </div>
      <a href="#" class="pod-nav-cta">Ouvir Agora</a>
    </div>
  </nav>

  <!-- HERO -->
  <section class="pod-hero">
    <div class="pod-container">
      <div class="pod-hero-grid">
        <div>
          <div class="pod-badge">🎙️ Novo episodio toda segunda-feira</div>
          <h1 class="pod-title">
            O podcast sobre <span>startups e negocios</span> que voce precisa ouvir
          </h1>
          <p class="pod-desc">
            Conversas honestas e sem filtro com empreendedores de sucesso sobre os bastidores
            de construir empresas de alto crescimento. Insights reais, historias inspiradoras e
            licoes que voce nao encontra em nenhum livro.
          </p>
          <div class="pod-platforms">
            <a href="#" class="pod-platform"><span class="pod-platform-icon">🎵</span> Spotify</a>
            <a href="#" class="pod-platform"><span class="pod-platform-icon">🍎</span> Apple Podcasts</a>
            <a href="#" class="pod-platform"><span class="pod-platform-icon">▶️</span> YouTube</a>
            <a href="#" class="pod-platform"><span class="pod-platform-icon">🎧</span> Google Podcasts</a>
          </div>
          <div class="pod-stats">
            <div>
              <div class="pod-stat-value">500K+</div>
              <div class="pod-stat-label">Downloads/mes</div>
            </div>
            <div>
              <div class="pod-stat-value">200+</div>
              <div class="pod-stat-label">Episodios</div>
            </div>
            <div>
              <div class="pod-stat-value">4.9★</div>
              <div class="pod-stat-label">Avaliacao</div>
            </div>
          </div>
        </div>
        <div class="pod-cover">
          <img src="https://images.unsplash.com/photo-1478737270239-2f02b77fc618?w=600&h=600&fit=crop" alt="Podcast Cover" />
          <div class="pod-cover-badge">
            <span class="pod-cover-badge-num">#1</span>
            <span class="pod-cover-badge-text">Negocios</span>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ABOUT HOST -->
  <section class="pod-about">
    <div class="pod-container">
      <div class="pod-about-grid">
        <div class="pod-about-image">
          <img src="https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&h=500&fit=crop" class="pod-about-img" alt="Host" />
          <div class="pod-about-social">
            <a href="#">in</a>
            <a href="#">ig</a>
            <a href="#">tw</a>
          </div>
        </div>
        <div>
          <div class="pod-section-label">Seu Host</div>
          <h2 class="pod-section-title">Carlos Mendes</h2>
          <p class="pod-about-text">
            Empreendedor serial, investidor anjo e apaixonado por startups. Fundou 3 empresas
            que juntas ja faturaram mais de R$100 milhoes. Agora, sua missao e compartilhar
            tudo que aprendeu nos bastidores do empreendedorismo.
          </p>
          <p class="pod-about-text">
            No StartupCast, ele entrevista fundadores, investidores e executivos para extrair
            os insights mais valiosos sobre como construir negocios de sucesso no Brasil.
          </p>
          <div class="pod-about-highlights">
            <div class="pod-about-highlight">
              <span class="pod-about-highlight-icon">🚀</span>
              <span class="pod-about-highlight-text">3 exits bem-sucedidos</span>
            </div>
            <div class="pod-about-highlight">
              <span class="pod-about-highlight-icon">💰</span>
              <span class="pod-about-highlight-text">+R$50M investidos</span>
            </div>
            <div class="pod-about-highlight">
              <span class="pod-about-highlight-icon">👥</span>
              <span class="pod-about-highlight-text">+15 anos de experiencia</span>
            </div>
            <div class="pod-about-highlight">
              <span class="pod-about-highlight-icon">🎤</span>
              <span class="pod-about-highlight-text">+200 entrevistas</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- TOPICS -->
  <section class="pod-topics">
    <div class="pod-container">
      <div class="pod-section-header">
        <div class="pod-section-label">Temas</div>
        <h2 class="pod-section-title">O que voce vai aprender</h2>
        <p class="pod-section-desc">Conteudo pratico e relevante para quem quer empreender ou crescer no mundo dos negocios.</p>
      </div>
      <div class="pod-topics-grid">
        <div class="pod-topic">
          <div class="pod-topic-icon">🚀</div>
          <h3 class="pod-topic-title">Startups</h3>
          <p class="pod-topic-count">45 episodios</p>
        </div>
        <div class="pod-topic">
          <div class="pod-topic-icon">💰</div>
          <h3 class="pod-topic-title">Investimentos</h3>
          <p class="pod-topic-count">32 episodios</p>
        </div>
        <div class="pod-topic">
          <div class="pod-topic-icon">📈</div>
          <h3 class="pod-topic-title">Growth</h3>
          <p class="pod-topic-count">28 episodios</p>
        </div>
        <div class="pod-topic">
          <div class="pod-topic-icon">🧠</div>
          <h3 class="pod-topic-title">Lideranca</h3>
          <p class="pod-topic-count">35 episodios</p>
        </div>
        <div class="pod-topic">
          <div class="pod-topic-icon">💡</div>
          <h3 class="pod-topic-title">Inovacao</h3>
          <p class="pod-topic-count">22 episodios</p>
        </div>
        <div class="pod-topic">
          <div class="pod-topic-icon">🎯</div>
          <h3 class="pod-topic-title">Vendas</h3>
          <p class="pod-topic-count">18 episodios</p>
        </div>
        <div class="pod-topic">
          <div class="pod-topic-icon">🤝</div>
          <h3 class="pod-topic-title">Cultura</h3>
          <p class="pod-topic-count">15 episodios</p>
        </div>
        <div class="pod-topic">
          <div class="pod-topic-icon">⚡</div>
          <h3 class="pod-topic-title">Produtividade</h3>
          <p class="pod-topic-count">12 episodios</p>
        </div>
      </div>
    </div>
  </section>

  <!-- EPISODES -->
  <section class="pod-episodes">
    <div class="pod-container">
      <div class="pod-section-header">
        <div class="pod-section-label">Episodios</div>
        <h2 class="pod-section-title">Ultimos lancamentos</h2>
      </div>
      <div class="pod-episodes-tabs">
        <button class="pod-tab active">Mais recentes</button>
        <button class="pod-tab">Mais ouvidos</button>
        <button class="pod-tab">Startups</button>
        <button class="pod-tab">Investimentos</button>
      </div>
      <div class="pod-episodes-grid">
        <div class="pod-episode">
          <div class="pod-episode-num">203</div>
          <div class="pod-episode-content">
            <h3 class="pod-episode-title">Como captar R$50M para sua startup</h3>
            <div class="pod-episode-meta">
              <span>🕐 58 min</span>
              <span>📅 2 dias atras</span>
            </div>
          </div>
          <div class="pod-episode-play">▶</div>
        </div>
        <div class="pod-episode">
          <div class="pod-episode-num">202</div>
          <div class="pod-episode-content">
            <h3 class="pod-episode-title">Os segredos do product-market fit</h3>
            <div class="pod-episode-meta">
              <span>🕐 45 min</span>
              <span>📅 1 semana atras</span>
            </div>
          </div>
          <div class="pod-episode-play">▶</div>
        </div>
        <div class="pod-episode">
          <div class="pod-episode-num">201</div>
          <div class="pod-episode-content">
            <h3 class="pod-episode-title">De CLT a empreendedor: minha jornada</h3>
            <div class="pod-episode-meta">
              <span>🕐 52 min</span>
              <span>📅 2 semanas atras</span>
            </div>
          </div>
          <div class="pod-episode-play">▶</div>
        </div>
        <div class="pod-episode">
          <div class="pod-episode-num">200</div>
          <div class="pod-episode-content">
            <h3 class="pod-episode-title">Especial: 200 episodios de aprendizados</h3>
            <div class="pod-episode-meta">
              <span>🕐 72 min</span>
              <span>📅 3 semanas atras</span>
            </div>
          </div>
          <div class="pod-episode-play">▶</div>
        </div>
        <div class="pod-episode">
          <div class="pod-episode-num">199</div>
          <div class="pod-episode-content">
            <h3 class="pod-episode-title">Vendendo sua empresa: o que aprendi</h3>
            <div class="pod-episode-meta">
              <span>🕐 63 min</span>
              <span>📅 1 mes atras</span>
            </div>
          </div>
          <div class="pod-episode-play">▶</div>
        </div>
        <div class="pod-episode">
          <div class="pod-episode-num">198</div>
          <div class="pod-episode-content">
            <h3 class="pod-episode-title">Como montar um time de alta performance</h3>
            <div class="pod-episode-meta">
              <span>🕐 48 min</span>
              <span>📅 1 mes atras</span>
            </div>
          </div>
          <div class="pod-episode-play">▶</div>
        </div>
      </div>
      <div class="pod-episodes-cta">
        <a href="#" class="pod-btn-secondary">Ver todos os episodios →</a>
      </div>
    </div>
  </section>

  <!-- GUESTS -->
  <section class="pod-guests">
    <div class="pod-container">
      <div class="pod-section-header">
        <div class="pod-section-label">Convidados</div>
        <h2 class="pod-section-title">Quem ja passou por aqui</h2>
        <p class="pod-section-desc">Fundadores, investidores e executivos compartilhando suas experiencias.</p>
      </div>
      <div class="pod-guests-grid">
        <div class="pod-guest">
          <img src="https://images.unsplash.com/photo-1560250097-0b93528c311a?w=200&h=200&fit=crop" class="pod-guest-img" alt="Convidado" />
          <h4 class="pod-guest-name">Pedro Augusto</h4>
          <p class="pod-guest-role">CEO, TechStartup</p>
        </div>
        <div class="pod-guest">
          <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=200&h=200&fit=crop" class="pod-guest-img" alt="Convidada" />
          <h4 class="pod-guest-name">Ana Carolina</h4>
          <p class="pod-guest-role">Fundadora, FintechX</p>
        </div>
        <div class="pod-guest">
          <img src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=200&h=200&fit=crop" class="pod-guest-img" alt="Convidado" />
          <h4 class="pod-guest-name">Roberto Lima</h4>
          <p class="pod-guest-role">Partner, VC Fund</p>
        </div>
        <div class="pod-guest">
          <img src="https://images.unsplash.com/photo-1580489944761-15a19d654956?w=200&h=200&fit=crop" class="pod-guest-img" alt="Convidada" />
          <h4 class="pod-guest-name">Marina Costa</h4>
          <p class="pod-guest-role">CMO, Unicornio</p>
        </div>
        <div class="pod-guest">
          <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop" class="pod-guest-img" alt="Convidado" />
          <h4 class="pod-guest-name">Lucas Ferreira</h4>
          <p class="pod-guest-role">Founder, SaaS Co</p>
        </div>
        <div class="pod-guest">
          <img src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&h=200&fit=crop" class="pod-guest-img" alt="Convidada" />
          <h4 class="pod-guest-name">Julia Santos</h4>
          <p class="pod-guest-role">Angel Investor</p>
        </div>
        <div class="pod-guest">
          <img src="https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=200&h=200&fit=crop" class="pod-guest-img" alt="Convidado" />
          <h4 class="pod-guest-name">Fernando Alves</h4>
          <p class="pod-guest-role">Serial Entrepreneur</p>
        </div>
        <div class="pod-guest">
          <img src="https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=200&h=200&fit=crop" class="pod-guest-img" alt="Convidada" />
          <h4 class="pod-guest-name">Beatriz Ramos</h4>
          <p class="pod-guest-role">VP Growth, ScaleUp</p>
        </div>
      </div>
    </div>
  </section>

  <!-- NEWSLETTER -->
  <section class="pod-newsletter">
    <div class="pod-container">
      <div class="pod-newsletter-box">
        <h2 class="pod-newsletter-title">Receba os melhores insights</h2>
        <p class="pod-newsletter-desc">
          Toda semana, um resumo dos melhores momentos do podcast + conteudo exclusivo
          direto na sua caixa de entrada. Junte-se a +50.000 assinantes.
        </p>
        <div class="pod-newsletter-form">
          <input type="email" class="pod-newsletter-input" placeholder="Seu melhor e-mail" />
          <button class="pod-newsletter-btn">Inscrever-se</button>
        </div>
      </div>
    </div>
  </section>

  <!-- TESTIMONIALS -->
  <section class="pod-testimonials">
    <div class="pod-container">
      <div class="pod-section-header">
        <div class="pod-section-label">Avaliacoes</div>
        <h2 class="pod-section-title">O que os ouvintes dizem</h2>
      </div>
      <div class="pod-testimonials-grid">
        <div class="pod-testimonial">
          <div class="pod-testimonial-stars">★★★★★</div>
          <p class="pod-testimonial-text">"O melhor podcast de negocios do Brasil. Os insights sao incriveis e as entrevistas sao super profundas. Escuto todos os episodios."</p>
          <div class="pod-testimonial-author">
            <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop" class="pod-testimonial-avatar" alt="Ouvinte" />
            <div>
              <div class="pod-testimonial-name">Rafael Mendes</div>
              <div class="pod-testimonial-handle">@rafaelmendes</div>
            </div>
          </div>
        </div>
        <div class="pod-testimonial">
          <div class="pod-testimonial-stars">★★★★★</div>
          <p class="pod-testimonial-text">"Obrigada por criar esse conteudo incrivel! Aprendo mais ouvindo um episodio do que lendo varios livros de negocios."</p>
          <div class="pod-testimonial-author">
            <img src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop" class="pod-testimonial-avatar" alt="Ouvinte" />
            <div>
              <div class="pod-testimonial-name">Camila Oliveira</div>
              <div class="pod-testimonial-handle">@camilaoliveira</div>
            </div>
          </div>
        </div>
        <div class="pod-testimonial">
          <div class="pod-testimonial-stars">★★★★★</div>
          <p class="pod-testimonial-text">"As perguntas que o Carlos faz sao cirurgicas. Ele consegue extrair dos convidados informacoes que voce nao acha em nenhum outro lugar."</p>
          <div class="pod-testimonial-author">
            <img src="https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=100&h=100&fit=crop" class="pod-testimonial-avatar" alt="Ouvinte" />
            <div>
              <div class="pod-testimonial-name">Fernanda Lima</div>
              <div class="pod-testimonial-handle">@fernandal</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- SPONSORS -->
  <section class="pod-sponsors">
    <div class="pod-container">
      <p class="pod-sponsors-label">Apoiadores do Podcast</p>
      <div class="pod-sponsors-grid">
        <span class="pod-sponsor">TechCorp</span>
        <span class="pod-sponsor">StartupHub</span>
        <span class="pod-sponsor">VentureX</span>
        <span class="pod-sponsor">GrowthCo</span>
        <span class="pod-sponsor">InnovateLab</span>
      </div>
    </div>
  </section>

  <!-- CTA -->
  <section class="pod-cta">
    <div class="pod-container">
      <h2 class="pod-cta-title">Comece a ouvir agora</h2>
      <p class="pod-cta-desc">Escolha sua plataforma favorita e junte-se a +500.000 ouvintes mensais que estao transformando suas carreiras.</p>
      <div class="pod-cta-platforms">
        <a href="#" class="pod-cta-platform">🎵 Spotify</a>
        <a href="#" class="pod-cta-platform">🍎 Apple Podcasts</a>
        <a href="#" class="pod-cta-platform">▶️ YouTube</a>
      </div>
    </div>
  </section>

  <!-- FOOTER -->
  <footer class="pod-footer">
    <div class="pod-container">
      <div class="pod-footer-grid">
        <div>
          <div class="pod-footer-logo">🎙️ Startup<span>Cast</span></div>
          <p class="pod-footer-desc">
            O podcast sobre startups e negocios que voce precisa ouvir.
            Novos episodios toda segunda-feira.
          </p>
          <div class="pod-footer-social">
            <a href="#">in</a>
            <a href="#">ig</a>
            <a href="#">tw</a>
            <a href="#">yt</a>
          </div>
        </div>
        <div>
          <h4 class="pod-footer-title">Podcast</h4>
          <ul class="pod-footer-links">
            <li><a href="#">Todos Episodios</a></li>
            <li><a href="#">Startups</a></li>
            <li><a href="#">Investimentos</a></li>
            <li><a href="#">Growth</a></li>
            <li><a href="#">Lideranca</a></li>
          </ul>
        </div>
        <div>
          <h4 class="pod-footer-title">Sobre</h4>
          <ul class="pod-footer-links">
            <li><a href="#">O Host</a></li>
            <li><a href="#">Convidados</a></li>
            <li><a href="#">Imprensa</a></li>
            <li><a href="#">Parcerias</a></li>
            <li><a href="#">Contato</a></li>
          </ul>
        </div>
        <div>
          <h4 class="pod-footer-title">Plataformas</h4>
          <ul class="pod-footer-links">
            <li><a href="#">Spotify</a></li>
            <li><a href="#">Apple Podcasts</a></li>
            <li><a href="#">Google Podcasts</a></li>
            <li><a href="#">YouTube</a></li>
            <li><a href="#">RSS Feed</a></li>
          </ul>
        </div>
      </div>
      <div class="pod-footer-bottom">
        <p class="pod-footer-copy">© 2024 StartupCast. Todos os direitos reservados.</p>
      </div>
    </div>
  </footer>
</div>
`,
    gjsCss: '',
    gjsComponents: '',
    gjsStyles: ''
  },

  // ============================================
  // 17. EVENTO / CONFERÊNCIA
  // ============================================
  {
    id: 'event-conference',
    name: 'Evento & Conferência',
    description: 'Landing page impactante para eventos e conferências',
    thumbnail: 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=400&h=300&fit=crop',
    category: 'webinar',
    gjsHtml: `
<style>
  * { box-sizing: border-box; margin: 0; padding: 0; }
  .ev-hero { min-height: 100vh; background: linear-gradient(135deg, #0c0a09 0%, #1c1917 50%, #292524 100%); padding: 80px 24px; display: flex; align-items: center; position: relative; overflow: hidden; }
  .ev-hero::before { content: ''; position: absolute; top: -50%; left: -50%; width: 200%; height: 200%; background: radial-gradient(circle at 30% 70%, rgba(234, 179, 8, 0.1) 0%, transparent 50%); }
  .ev-container { max-width: 1100px; margin: 0 auto; position: relative; z-index: 1; text-align: center; }
  .ev-date { display: inline-flex; align-items: center; gap: 12px; padding: 12px 24px; background: linear-gradient(135deg, #eab308, #f59e0b); border-radius: 100px; color: #0c0a09; font-size: 14px; font-weight: 700; margin-bottom: 32px; }
  .ev-title { font-size: 5rem; font-weight: 900; color: white; line-height: 1; margin-bottom: 24px; text-transform: uppercase; letter-spacing: -0.03em; }
  .ev-title span { display: block; background: linear-gradient(135deg, #eab308, #fbbf24); -webkit-background-clip: text; -webkit-text-fill-color: transparent; }
  .ev-desc { font-size: 1.25rem; color: #a8a29e; line-height: 1.7; margin-bottom: 48px; max-width: 600px; margin-left: auto; margin-right: auto; }
  .ev-ctas { display: flex; gap: 16px; justify-content: center; margin-bottom: 60px; }
  .ev-btn-primary { padding: 20px 48px; background: #eab308; color: #0c0a09; font-weight: 800; font-size: 18px; border: none; border-radius: 14px; cursor: pointer; text-decoration: none; }
  .ev-btn-secondary { padding: 20px 48px; background: transparent; color: white; font-weight: 600; font-size: 18px; border: 2px solid rgba(255,255,255,0.3); border-radius: 14px; cursor: pointer; text-decoration: none; }
  .ev-countdown { display: flex; justify-content: center; gap: 24px; }
  .ev-countdown-item { text-align: center; }
  .ev-countdown-value { width: 80px; height: 80px; background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1); border-radius: 16px; display: flex; align-items: center; justify-content: center; font-size: 2.5rem; font-weight: 800; color: white; margin-bottom: 8px; }
  .ev-countdown-label { color: #78716c; font-size: 14px; text-transform: uppercase; letter-spacing: 1px; }
  .ev-speakers { padding: 100px 24px; background: #fafaf9; }
  .ev-speakers-header { text-align: center; margin-bottom: 60px; }
  .ev-speakers-label { color: #eab308; font-weight: 600; font-size: 14px; text-transform: uppercase; letter-spacing: 2px; margin-bottom: 12px; }
  .ev-speakers-title { font-size: 2.5rem; font-weight: 800; color: #0c0a09; }
  .ev-speakers-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 32px; }
  .ev-speaker { text-align: center; }
  .ev-speaker-img { width: 150px; height: 150px; border-radius: 50%; object-fit: cover; margin: 0 auto 20px; border: 4px solid #eab308; }
  .ev-speaker-name { font-size: 1.1rem; font-weight: 700; color: #0c0a09; margin-bottom: 4px; }
  .ev-speaker-role { color: #78716c; font-size: 14px; }
  @media (max-width: 968px) {
    .ev-title { font-size: 3rem; }
    .ev-speakers-grid { grid-template-columns: repeat(2, 1fr); }
    .ev-countdown { flex-wrap: wrap; }
  }
</style>

<!-- HERO -->
<section class="ev-hero">
  <div class="ev-container">
    <div class="ev-date">📅 15-16 Março 2025 • São Paulo</div>
    <h1 class="ev-title">
      Summit <span>2025</span>
    </h1>
    <p class="ev-desc">
      O maior evento de negócios e tecnologia do Brasil. Dois dias de conteúdo transformador com os maiores nomes do mercado.
    </p>
    <div class="ev-ctas">
      <a href="#" class="ev-btn-primary">Garantir Ingresso</a>
      <a href="#" class="ev-btn-secondary">Ver Programação</a>
    </div>
    <div class="ev-countdown">
      <div class="ev-countdown-item">
        <div class="ev-countdown-value">45</div>
        <div class="ev-countdown-label">Dias</div>
      </div>
      <div class="ev-countdown-item">
        <div class="ev-countdown-value">12</div>
        <div class="ev-countdown-label">Horas</div>
      </div>
      <div class="ev-countdown-item">
        <div class="ev-countdown-value">30</div>
        <div class="ev-countdown-label">Min</div>
      </div>
      <div class="ev-countdown-item">
        <div class="ev-countdown-value">15</div>
        <div class="ev-countdown-label">Seg</div>
      </div>
    </div>
  </div>
</section>

<!-- SPEAKERS -->
<section class="ev-speakers">
  <div class="ev-container">
    <div class="ev-speakers-header">
      <div class="ev-speakers-label">Line-up</div>
      <h2 class="ev-speakers-title">Palestrantes Confirmados</h2>
    </div>
    <div class="ev-speakers-grid">
      <div class="ev-speaker">
        <img src="https://images.unsplash.com/photo-1560250097-0b93528c311a?w=300&h=300&fit=crop" class="ev-speaker-img" alt="Speaker" />
        <h3 class="ev-speaker-name">Carlos Silva</h3>
        <p class="ev-speaker-role">CEO, TechCorp</p>
      </div>
      <div class="ev-speaker">
        <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=300&h=300&fit=crop" class="ev-speaker-img" alt="Speaker" />
        <h3 class="ev-speaker-name">Ana Santos</h3>
        <p class="ev-speaker-role">Fundadora, StartupXYZ</p>
      </div>
      <div class="ev-speaker">
        <img src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=300&h=300&fit=crop" class="ev-speaker-img" alt="Speaker" />
        <h3 class="ev-speaker-name">Pedro Lima</h3>
        <p class="ev-speaker-role">Investidor Anjo</p>
      </div>
      <div class="ev-speaker">
        <img src="https://images.unsplash.com/photo-1580489944761-15a19d654956?w=300&h=300&fit=crop" class="ev-speaker-img" alt="Speaker" />
        <h3 class="ev-speaker-name">Maria Costa</h3>
        <p class="ev-speaker-role">CMO, BigCompany</p>
      </div>
    </div>
  </div>
</section>
`,
    gjsCss: '',
    gjsComponents: '',
    gjsStyles: ''
  },

  // ============================================
  // 18. LANÇAMENTO DE LIVRO
  // ============================================
  {
    id: 'book-launch',
    name: 'Lançamento de Livro',
    description: 'Landing page elegante para lançamento de livros e autores',
    thumbnail: 'https://images.unsplash.com/photo-1544947950-fa07a98d237f?w=400&h=300&fit=crop',
    category: 'product-launch',
    gjsHtml: `
<style>
  * { box-sizing: border-box; margin: 0; padding: 0; }
  .book-hero { min-height: 100vh; background: linear-gradient(135deg, #1e3a5f 0%, #0f172a 100%); padding: 80px 24px; display: flex; align-items: center; }
  .book-container { max-width: 1100px; margin: 0 auto; }
  .book-grid { display: grid; grid-template-columns: 1fr 1.2fr; gap: 80px; align-items: center; }
  .book-cover { position: relative; }
  .book-cover img { width: 100%; max-width: 350px; border-radius: 8px; box-shadow: 0 50px 100px rgba(0,0,0,0.5); }
  .book-bestseller { position: absolute; top: -20px; right: -20px; width: 100px; height: 100px; background: #eab308; border-radius: 50%; display: flex; align-items: center; justify-content: center; text-align: center; font-weight: 800; font-size: 14px; color: #0f172a; line-height: 1.2; }
  .book-badge { display: inline-block; padding: 8px 16px; background: rgba(234, 179, 8, 0.2); border: 1px solid rgba(234, 179, 8, 0.3); border-radius: 100px; color: #fcd34d; font-size: 13px; font-weight: 600; margin-bottom: 24px; }
  .book-title { font-size: 3rem; font-weight: 800; color: white; line-height: 1.15; margin-bottom: 16px; font-family: Georgia, serif; }
  .book-subtitle { font-size: 1.25rem; color: #94a3b8; font-style: italic; margin-bottom: 24px; }
  .book-author { display: flex; align-items: center; gap: 16px; margin-bottom: 32px; }
  .book-author-img { width: 56px; height: 56px; border-radius: 50%; object-fit: cover; }
  .book-author-name { color: white; font-weight: 600; }
  .book-author-role { color: #64748b; font-size: 14px; }
  .book-desc { color: #94a3b8; line-height: 1.8; margin-bottom: 32px; font-size: 1.05rem; }
  .book-ctas { display: flex; gap: 16px; flex-wrap: wrap; margin-bottom: 40px; }
  .book-btn-primary { padding: 18px 36px; background: #eab308; color: #0f172a; font-weight: 700; font-size: 16px; border-radius: 12px; text-decoration: none; display: inline-flex; align-items: center; gap: 8px; }
  .book-btn-secondary { padding: 18px 36px; background: transparent; color: white; font-weight: 600; font-size: 16px; border: 2px solid rgba(255,255,255,0.3); border-radius: 12px; text-decoration: none; }
  .book-stores { display: flex; gap: 24px; }
  .book-store { color: #64748b; font-size: 14px; display: flex; align-items: center; gap: 8px; }
  @media (max-width: 968px) {
    .book-grid { grid-template-columns: 1fr; text-align: center; }
    .book-cover { order: -1; display: flex; justify-content: center; }
    .book-title { font-size: 2.25rem; }
    .book-author { justify-content: center; }
    .book-ctas { justify-content: center; }
    .book-stores { justify-content: center; }
  }
</style>

<!-- HERO -->
<section class="book-hero">
  <div class="book-container">
    <div class="book-grid">
      <div class="book-cover">
        <img src="https://images.unsplash.com/photo-1544947950-fa07a98d237f?w=400&h=600&fit=crop" alt="Book Cover" />
        <div class="book-bestseller">#1 Best Seller</div>
      </div>
      <div>
        <div class="book-badge">📚 Novo Lançamento</div>
        <h1 class="book-title">A Arte de Empreender no Caos</h1>
        <p class="book-subtitle">Como transformar crises em oportunidades de crescimento</p>
        <div class="book-author">
          <img src="https://images.unsplash.com/photo-1560250097-0b93528c311a?w=100&h=100&fit=crop" class="book-author-img" alt="Author" />
          <div>
            <div class="book-author-name">João Silva</div>
            <div class="book-author-role">Empreendedor e Autor Bestseller</div>
          </div>
        </div>
        <p class="book-desc">
          Depois de construir 5 empresas de sucesso, João Silva revela neste livro as estratégias e mentalidades que o ajudaram a prosperar mesmo nos momentos mais difíceis do mercado.
        </p>
        <div class="book-ctas">
          <a href="#" class="book-btn-primary">Comprar Agora - R$ 59,90</a>
          <a href="#" class="book-btn-secondary">Ler Primeiro Capítulo</a>
        </div>
        <div class="book-stores">
          <span class="book-store">📦 Amazon</span>
          <span class="book-store">📦 Saraiva</span>
          <span class="book-store">📦 Livraria Cultura</span>
        </div>
      </div>
    </div>
  </div>
</section>
`,
    gjsCss: '',
    gjsComponents: '',
    gjsStyles: ''
  },

  // ============================================
  // 19. BLACK FRIDAY / PROMOÇÃO
  // ============================================
  {
    id: 'black-friday',
    name: 'Black Friday / Promoção',
    description: 'Landing page de alta conversão para promoções e ofertas',
    thumbnail: 'https://images.unsplash.com/photo-1607083206869-4c7672e72a8a?w=400&h=300&fit=crop',
    category: 'ecommerce',
    gjsHtml: `
<style>
  * { box-sizing: border-box; margin: 0; padding: 0; }
  .bf-page { background: #000; min-height: 100vh; }
  .bf-hero { padding: 80px 24px; text-align: center; position: relative; overflow: hidden; }
  .bf-hero::before { content: ''; position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: radial-gradient(circle at 50% 50%, rgba(239, 68, 68, 0.15) 0%, transparent 50%); }
  .bf-container { max-width: 900px; margin: 0 auto; position: relative; z-index: 1; }
  .bf-badge { display: inline-flex; align-items: center; gap: 8px; padding: 12px 24px; background: #ef4444; border-radius: 100px; color: white; font-size: 14px; font-weight: 800; margin-bottom: 32px; text-transform: uppercase; letter-spacing: 2px; animation: pulse 2s infinite; }
  @keyframes pulse { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.05); } }
  .bf-title { font-size: 6rem; font-weight: 900; color: white; line-height: 0.9; margin-bottom: 24px; text-transform: uppercase; }
  .bf-title span { display: block; background: linear-gradient(135deg, #ef4444, #f97316); -webkit-background-clip: text; -webkit-text-fill-color: transparent; }
  .bf-discount { font-size: 8rem; font-weight: 900; color: #ef4444; margin-bottom: 24px; }
  .bf-desc { font-size: 1.5rem; color: #a1a1aa; margin-bottom: 48px; }
  .bf-countdown { display: flex; justify-content: center; gap: 24px; margin-bottom: 48px; }
  .bf-countdown-item { text-align: center; }
  .bf-countdown-value { width: 90px; height: 90px; background: linear-gradient(135deg, #1f1f1f, #111); border: 2px solid #333; border-radius: 16px; display: flex; align-items: center; justify-content: center; font-size: 2.5rem; font-weight: 900; color: white; margin-bottom: 8px; }
  .bf-countdown-label { color: #71717a; font-size: 12px; text-transform: uppercase; letter-spacing: 1px; }
  .bf-btn { padding: 24px 64px; background: linear-gradient(135deg, #ef4444, #dc2626); color: white; font-weight: 800; font-size: 20px; border: none; border-radius: 16px; cursor: pointer; text-transform: uppercase; letter-spacing: 1px; display: inline-block; text-decoration: none; box-shadow: 0 20px 40px rgba(239, 68, 68, 0.4); }
  .bf-terms { margin-top: 24px; color: #525252; font-size: 14px; }
  .bf-products { padding: 80px 24px; background: #0a0a0a; }
  .bf-products-title { text-align: center; font-size: 2rem; font-weight: 800; color: white; margin-bottom: 48px; }
  .bf-products-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; max-width: 1100px; margin: 0 auto; }
  .bf-product { background: #111; border: 1px solid #222; border-radius: 20px; padding: 24px; position: relative; }
  .bf-product-badge { position: absolute; top: 16px; right: 16px; padding: 6px 12px; background: #ef4444; color: white; font-size: 12px; font-weight: 700; border-radius: 6px; }
  .bf-product-img { width: 100%; height: 200px; object-fit: cover; border-radius: 12px; margin-bottom: 20px; }
  .bf-product-name { color: white; font-weight: 600; margin-bottom: 12px; }
  .bf-product-price-old { color: #525252; text-decoration: line-through; font-size: 14px; }
  .bf-product-price { color: #ef4444; font-size: 1.5rem; font-weight: 800; }
  @media (max-width: 768px) {
    .bf-title { font-size: 3.5rem; }
    .bf-discount { font-size: 5rem; }
    .bf-products-grid { grid-template-columns: 1fr; }
    .bf-countdown { flex-wrap: wrap; }
  }
</style>

<div class="bf-page">
  <!-- HERO -->
  <section class="bf-hero">
    <div class="bf-container">
      <div class="bf-badge">🔥 Oferta por tempo limitado</div>
      <h1 class="bf-title">
        Black <span>Friday</span>
      </h1>
      <div class="bf-discount">-70%</div>
      <p class="bf-desc">Os maiores descontos do ano. Só até domingo!</p>
      <div class="bf-countdown">
        <div class="bf-countdown-item">
          <div class="bf-countdown-value">02</div>
          <div class="bf-countdown-label">Dias</div>
        </div>
        <div class="bf-countdown-item">
          <div class="bf-countdown-value">14</div>
          <div class="bf-countdown-label">Horas</div>
        </div>
        <div class="bf-countdown-item">
          <div class="bf-countdown-value">37</div>
          <div class="bf-countdown-label">Min</div>
        </div>
        <div class="bf-countdown-item">
          <div class="bf-countdown-value">52</div>
          <div class="bf-countdown-label">Seg</div>
        </div>
      </div>
      <a href="#" class="bf-btn">Ver Ofertas →</a>
      <p class="bf-terms">*Válido enquanto durarem os estoques</p>
    </div>
  </section>

  <!-- PRODUCTS -->
  <section class="bf-products">
    <h2 class="bf-products-title">Ofertas em Destaque</h2>
    <div class="bf-products-grid">
      <div class="bf-product">
        <div class="bf-product-badge">-60%</div>
        <img src="https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=400&h=300&fit=crop" class="bf-product-img" alt="Product" />
        <h3 class="bf-product-name">Smart Watch Pro</h3>
        <div class="bf-product-price-old">R$ 999</div>
        <div class="bf-product-price">R$ 399</div>
      </div>
      <div class="bf-product">
        <div class="bf-product-badge">-50%</div>
        <img src="https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=400&h=300&fit=crop" class="bf-product-img" alt="Product" />
        <h3 class="bf-product-name">Headphone Wireless</h3>
        <div class="bf-product-price-old">R$ 599</div>
        <div class="bf-product-price">R$ 299</div>
      </div>
      <div class="bf-product">
        <div class="bf-product-badge">-70%</div>
        <img src="https://images.unsplash.com/photo-1585386959984-a4155224a1ad?w=400&h=300&fit=crop" class="bf-product-img" alt="Product" />
        <h3 class="bf-product-name">Perfume Premium</h3>
        <div class="bf-product-price-old">R$ 450</div>
        <div class="bf-product-price">R$ 135</div>
      </div>
    </div>
  </section>
</div>
`,
    gjsCss: '',
    gjsComponents: '',
    gjsStyles: ''
  },

  // ============================================
  // 20. CONSULTA / AGENDAMENTO
  // ============================================
  {
    id: 'booking-consultation',
    name: 'Agendamento & Consulta',
    description: 'Landing page para profissionais que agendam consultas',
    thumbnail: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=400&h=300&fit=crop',
    category: 'agency',
    gjsHtml: `
<style>
  * { box-sizing: border-box; margin: 0; padding: 0; }
  .bk-hero { padding: 100px 24px; background: linear-gradient(180deg, #f8fafc 0%, #ffffff 100%); }
  .bk-container { max-width: 1100px; margin: 0 auto; }
  .bk-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: center; }
  .bk-badge { display: inline-flex; align-items: center; gap: 8px; padding: 10px 20px; background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 100px; color: #16a34a; font-size: 14px; font-weight: 600; margin-bottom: 24px; }
  .bk-title { font-size: 3.5rem; font-weight: 800; color: #0f172a; line-height: 1.1; margin-bottom: 24px; }
  .bk-title span { color: #6366f1; }
  .bk-desc { font-size: 1.2rem; color: #64748b; line-height: 1.7; margin-bottom: 32px; }
  .bk-features { margin-bottom: 40px; }
  .bk-feature { display: flex; align-items: center; gap: 16px; padding: 16px 0; }
  .bk-feature-icon { width: 48px; height: 48px; background: linear-gradient(135deg, #6366f1, #8b5cf6); border-radius: 14px; display: flex; align-items: center; justify-content: center; font-size: 20px; }
  .bk-feature-text { font-size: 1rem; color: #334155; font-weight: 500; }
  .bk-form-card { background: white; padding: 40px; border-radius: 24px; box-shadow: 0 25px 60px rgba(0,0,0,0.1); border: 1px solid #e2e8f0; }
  .bk-form-title { font-size: 1.5rem; font-weight: 700; color: #0f172a; margin-bottom: 8px; }
  .bk-form-desc { color: #64748b; margin-bottom: 32px; }
  .bk-input-group { margin-bottom: 20px; }
  .bk-label { display: block; font-size: 14px; font-weight: 600; color: #334155; margin-bottom: 8px; }
  .bk-input { width: 100%; padding: 16px 20px; border: 2px solid #e2e8f0; border-radius: 12px; font-size: 16px; outline: none; transition: border-color 0.2s; }
  .bk-input:focus { border-color: #6366f1; }
  .bk-select { width: 100%; padding: 16px 20px; border: 2px solid #e2e8f0; border-radius: 12px; font-size: 16px; outline: none; background: white; cursor: pointer; }
  .bk-btn { width: 100%; padding: 18px; background: #6366f1; color: white; font-weight: 700; font-size: 16px; border: none; border-radius: 12px; cursor: pointer; }
  .bk-trust { display: flex; align-items: center; justify-content: center; gap: 8px; margin-top: 20px; color: #64748b; font-size: 14px; }
  @media (max-width: 968px) {
    .bk-grid { grid-template-columns: 1fr; }
    .bk-title { font-size: 2.5rem; }
  }
</style>

<!-- HERO -->
<section class="bk-hero">
  <div class="bk-container">
    <div class="bk-grid">
      <div>
        <div class="bk-badge">📅 Agende sua consulta</div>
        <h1 class="bk-title">
          Transforme sua carreira com <span>mentoria especializada</span>
        </h1>
        <p class="bk-desc">
          Sessões personalizadas de 1 hora para acelerar seus resultados profissionais. Mais de 500 profissionais já transformaram suas carreiras.
        </p>
        <div class="bk-features">
          <div class="bk-feature">
            <div class="bk-feature-icon">⏰</div>
            <span class="bk-feature-text">Sessões de 60 minutos via Zoom</span>
          </div>
          <div class="bk-feature">
            <div class="bk-feature-icon">📋</div>
            <span class="bk-feature-text">Plano de ação personalizado</span>
          </div>
          <div class="bk-feature">
            <div class="bk-feature-icon">💬</div>
            <span class="bk-feature-text">Suporte por WhatsApp por 7 dias</span>
          </div>
        </div>
      </div>
      <div>
        <div class="bk-form-card">
          <h2 class="bk-form-title">Agende sua sessão</h2>
          <p class="bk-form-desc">Escolha o melhor horário para você</p>
          <form data-success-message="Agendamento solicitado! Enviaremos a confirmacao por e-mail.">
            <div class="bk-input-group">
              <label class="bk-label">Nome completo</label>
              <input type="text" name="name" class="bk-input" placeholder="Seu nome" required />
            </div>
            <div class="bk-input-group">
              <label class="bk-label">E-mail</label>
              <input type="email" name="email" class="bk-input" placeholder="seu@email.com" required />
            </div>
            <div class="bk-input-group">
              <label class="bk-label">Serviço</label>
              <select name="service" class="bk-select">
                <option value="mentoria">Mentoria de Carreira - R$ 297</option>
                <option value="curriculo">Revisão de Currículo - R$ 147</option>
                <option value="entrevista">Preparação para Entrevista - R$ 197</option>
              </select>
            </div>
            <div class="bk-input-group">
              <label class="bk-label">Data preferida</label>
              <input type="date" name="date" class="bk-input" required />
            </div>
            <button type="submit" class="bk-btn">Agendar Agora →</button>
          </form>
          <p class="bk-trust">🔒 Pagamento seguro • Satisfação garantida</p>
        </div>
      </div>
    </div>
  </div>
</section>
`,
    gjsCss: '',
    gjsComponents: '',
    gjsStyles: ''
  },

  // ============================================
  // PETSHOP - Template Completo
  // ============================================
  {
    id: 'petshop-premium',
    name: 'PetShop Premium',
    description: 'Landing page completa para petshops, clínicas veterinárias e serviços para pets',
    thumbnail: 'https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=400&h=300&fit=crop',
    category: 'pet',
    gjsHtml: `<!DOCTYPE html>
<html lang="pt-BR">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>PetCare Plus - O melhor cuidado para seu pet</title>
    <script src="https://cdn.tailwindcss.com"></script>
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css">
</head>
<body class="antialiased">
    <!-- Hero Section -->
    <section class="min-h-screen bg-gradient-to-br from-green-600 via-green-700 to-yellow-600 relative overflow-hidden">
        <div class="container mx-auto px-6 py-12">
            <div class="grid lg:grid-cols-2 gap-12 items-center min-h-screen">
                <div class="text-white space-y-8 z-10">
                    <h1 class="text-5xl lg:text-7xl font-bold leading-tight">
                        Cuidado Premium para
                        <span class="bg-gradient-to-r from-yellow-300 to-orange-300 bg-clip-text text-transparent">Seu Pet</span>
                    </h1>
                    <p class="text-xl lg:text-2xl text-green-100 leading-relaxed">
                        Petshop completo com serviços veterinários, banho e tosa, produtos premium e muito carinho para seu melhor amigo.
                    </p>
                    <div class="flex flex-col sm:flex-row gap-4">
                        <button class="bg-gradient-to-r from-yellow-400 to-orange-500 text-white px-8 py-4 rounded-xl font-semibold text-lg hover:scale-105 transition-transform shadow-xl">
                            <i class="fas fa-calendar-alt mr-2"></i>Agendar Consulta
                        </button>
                        <button class="border-2 border-white text-white px-8 py-4 rounded-xl font-semibold text-lg hover:bg-white hover:text-green-600 transition-all">
                            <i class="fas fa-phone mr-2"></i>(11) 99999-9999
                        </button>
                    </div>
                    <div class="flex items-center gap-4 pt-8">
                        <div class="flex -space-x-2">
                            <img src="https://i.pravatar.cc/60?img=1" class="w-12 h-12 rounded-full border-2 border-white" alt="Cliente">
                            <img src="https://i.pravatar.cc/60?img=2" class="w-12 h-12 rounded-full border-2 border-white" alt="Cliente">
                            <img src="https://i.pravatar.cc/60?img=3" class="w-12 h-12 rounded-full border-2 border-white" alt="Cliente">
                        </div>
                        <div>
                            <div class="flex text-yellow-300 text-lg">★★★★★</div>
                            <p class="text-green-100">+2.500 pets atendidos</p>
                        </div>
                    </div>
                </div>
                <div class="relative">
                    <img src="https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=600&h=700&fit=crop" class="rounded-3xl shadow-2xl w-full h-[500px] object-cover" alt="Pet feliz">
                    <div class="absolute -bottom-6 -left-6 bg-white p-6 rounded-2xl shadow-2xl">
                        <div class="flex items-center gap-4">
                            <div class="bg-gradient-to-r from-green-500 to-yellow-500 p-3 rounded-xl">
                                <i class="fas fa-heart text-white text-2xl"></i>
                            </div>
                            <div>
                                <p class="text-2xl font-bold text-gray-800">15+</p>
                                <p class="text-gray-600">Anos de experiência</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Features Section -->
    <section class="py-24 bg-white">
        <div class="container mx-auto px-6">
            <div class="text-center mb-16">
                <span class="bg-gradient-to-r from-green-500 to-yellow-500 text-white px-4 py-2 rounded-full text-sm font-semibold">NOSSOS DIFERENCIAIS</span>
                <h2 class="text-4xl lg:text-5xl font-bold text-gray-800 mt-6">Por que escolher a PetCare Plus?</h2>
            </div>
            <div class="grid md:grid-cols-3 gap-8">
                <div class="bg-white p-8 rounded-2xl shadow-xl hover:shadow-2xl transition-all hover:-translate-y-2 border border-gray-100">
                    <div class="bg-gradient-to-r from-green-500 to-emerald-500 p-4 rounded-xl w-16 h-16 flex items-center justify-center mb-6">
                        <i class="fas fa-user-md text-white text-2xl"></i>
                    </div>
                    <h3 class="text-2xl font-bold text-gray-800 mb-4">Veterinários Especializados</h3>
                    <p class="text-gray-600 leading-relaxed">Equipe de veterinários experientes e apaixonados por animais.</p>
                </div>
                <div class="bg-white p-8 rounded-2xl shadow-xl hover:shadow-2xl transition-all hover:-translate-y-2 border border-gray-100">
                    <div class="bg-gradient-to-r from-yellow-500 to-orange-500 p-4 rounded-xl w-16 h-16 flex items-center justify-center mb-6">
                        <i class="fas fa-cut text-white text-2xl"></i>
                    </div>
                    <h3 class="text-2xl font-bold text-gray-800 mb-4">Banho & Tosa Premium</h3>
                    <p class="text-gray-600 leading-relaxed">Serviços de estética completos com produtos premium.</p>
                </div>
                <div class="bg-white p-8 rounded-2xl shadow-xl hover:shadow-2xl transition-all hover:-translate-y-2 border border-gray-100">
                    <div class="bg-gradient-to-r from-blue-500 to-purple-500 p-4 rounded-xl w-16 h-16 flex items-center justify-center mb-6">
                        <i class="fas fa-shopping-cart text-white text-2xl"></i>
                    </div>
                    <h3 class="text-2xl font-bold text-gray-800 mb-4">Pet Shop Completo</h3>
                    <p class="text-gray-600 leading-relaxed">Rações premium, medicamentos, brinquedos e acessórios.</p>
                </div>
            </div>
        </div>
    </section>

    <!-- Testimonials -->
    <section class="py-24 bg-gradient-to-br from-gray-900 via-green-900 to-gray-900 relative overflow-hidden">
        <div class="container mx-auto px-6 relative z-10">
            <div class="text-center mb-16">
                <h2 class="text-4xl lg:text-5xl font-bold text-white mb-6">O que nossos clientes falam</h2>
            </div>
            <div class="grid md:grid-cols-3 gap-8">
                <div class="bg-white p-8 rounded-2xl shadow-2xl">
                    <div class="flex text-yellow-500 text-lg mb-4">★★★★★</div>
                    <p class="text-gray-600 mb-6 italic">"A PetCare Plus salvou a vida da minha gatinha! Super recomendo!"</p>
                    <div class="flex items-center gap-4">
                        <img src="https://i.pravatar.cc/60?img=5" class="w-12 h-12 rounded-full" alt="Ana Silva">
                        <div><p class="font-semibold text-gray-800">Ana Silva</p><p class="text-gray-500">Tutora da Mimi</p></div>
                    </div>
                </div>
                <div class="bg-white p-8 rounded-2xl shadow-2xl">
                    <div class="flex text-yellow-500 text-lg mb-4">★★★★★</div>
                    <p class="text-gray-600 mb-6 italic">"Meu Thor adora ir na PetCare! Banho e tosa perfeitos."</p>
                    <div class="flex items-center gap-4">
                        <img src="https://i.pravatar.cc/60?img=6" class="w-12 h-12 rounded-full" alt="Carlos Mendes">
                        <div><p class="font-semibold text-gray-800">Carlos Mendes</p><p class="text-gray-500">Tutor do Thor</p></div>
                    </div>
                </div>
                <div class="bg-white p-8 rounded-2xl shadow-2xl">
                    <div class="flex text-yellow-500 text-lg mb-4">★★★★★</div>
                    <p class="text-gray-600 mb-6 italic">"Atendimento humanizado e profissionais competentes."</p>
                    <div class="flex items-center gap-4">
                        <img src="https://i.pravatar.cc/60?img=7" class="w-12 h-12 rounded-full" alt="Maria Santos">
                        <div><p class="font-semibold text-gray-800">Maria Santos</p><p class="text-gray-500">Tutora da Luna</p></div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Pricing -->
    <section class="py-24 bg-gray-50">
        <div class="container mx-auto px-6">
            <div class="text-center mb-16">
                <h2 class="text-4xl lg:text-5xl font-bold text-gray-800 mb-6">Planos de Cuidado</h2>
            </div>
            <div class="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
                <div class="bg-white p-8 rounded-2xl shadow-xl border border-gray-200">
                    <h3 class="text-2xl font-bold text-gray-800 mb-4">Cuidado Básico</h3>
                    <div class="mb-6"><span class="text-4xl font-bold text-green-600">R\$ 89</span><span class="text-gray-600">/mês</span></div>
                    <ul class="space-y-3 mb-8">
                        <li class="flex items-center gap-3"><i class="fas fa-check text-green-500"></i><span>1 consulta veterinária</span></li>
                        <li class="flex items-center gap-3"><i class="fas fa-check text-green-500"></i><span>Banho básico mensal</span></li>
                        <li class="flex items-center gap-3"><i class="fas fa-check text-green-500"></i><span>10% desconto em produtos</span></li>
                    </ul>
                    <button class="w-full bg-green-500 text-white py-3 rounded-xl font-semibold hover:bg-green-600 transition-colors">Escolher Plano</button>
                </div>
                <div class="bg-gradient-to-br from-green-500 to-yellow-500 p-8 rounded-2xl shadow-2xl transform scale-105 relative">
                    <div class="absolute -top-4 left-1/2 transform -translate-x-1/2"><span class="bg-yellow-400 text-gray-800 px-4 py-2 rounded-full text-sm font-bold">MAIS POPULAR</span></div>
                    <h3 class="text-2xl font-bold text-white mb-4">Cuidado Premium</h3>
                    <div class="mb-6"><span class="text-4xl font-bold text-white">R\$ 159</span><span class="text-green-100">/mês</span></div>
                    <ul class="space-y-3 mb-8 text-white">
                        <li class="flex items-center gap-3"><i class="fas fa-check text-yellow-300"></i><span>3 consultas veterinárias</span></li>
                        <li class="flex items-center gap-3"><i class="fas fa-check text-yellow-300"></i><span>Banho e tosa completa</span></li>
                        <li class="flex items-center gap-3"><i class="fas fa-check text-yellow-300"></i><span>20% desconto em produtos</span></li>
                    </ul>
                    <button class="w-full bg-white text-green-600 py-3 rounded-xl font-semibold hover:bg-gray-100 transition-colors">Escolher Plano</button>
                </div>
                <div class="bg-white p-8 rounded-2xl shadow-xl border border-gray-200">
                    <h3 class="text-2xl font-bold text-gray-800 mb-4">Cuidado VIP</h3>
                    <div class="mb-6"><span class="text-4xl font-bold text-green-600">R\$ 259</span><span class="text-gray-600">/mês</span></div>
                    <ul class="space-y-3 mb-8">
                        <li class="flex items-center gap-3"><i class="fas fa-check text-green-500"></i><span>Consultas ilimitadas</span></li>
                        <li class="flex items-center gap-3"><i class="fas fa-check text-green-500"></i><span>Banho e tosa premium</span></li>
                        <li class="flex items-center gap-3"><i class="fas fa-check text-green-500"></i><span>30% desconto + emergência 24h</span></li>
                    </ul>
                    <button class="w-full bg-green-500 text-white py-3 rounded-xl font-semibold hover:bg-green-600 transition-colors">Escolher Plano</button>
                </div>
            </div>
        </div>
    </section>

    <!-- CTA -->
    <section class="py-24 bg-gradient-to-r from-green-600 via-green-700 to-yellow-600">
        <div class="container mx-auto px-6 text-center">
            <h2 class="text-4xl lg:text-6xl font-bold text-white mb-6">Pronto para cuidar melhor do seu pet?</h2>
            <div class="flex flex-col sm:flex-row gap-4 justify-center">
                <button class="bg-white text-green-600 px-8 py-4 rounded-xl font-semibold text-lg hover:scale-105 transition-transform shadow-xl">
                    <i class="fas fa-calendar-alt mr-2"></i>Agendar Agora
                </button>
                <button class="border-2 border-white text-white px-8 py-4 rounded-xl font-semibold text-lg hover:bg-white hover:text-green-600 transition-all">
                    <i class="fab fa-whatsapp mr-2"></i>WhatsApp
                </button>
            </div>
        </div>
    </section>

    <!-- Footer -->
    <footer class="bg-slate-950 text-white py-16">
        <div class="container mx-auto px-6">
            <div class="grid md:grid-cols-4 gap-8 mb-8">
                <div><h3 class="text-2xl font-bold mb-4 text-green-400">PetCare Plus</h3><p class="text-gray-400">Cuidando do seu pet com amor há mais de 15 anos.</p></div>
                <div><h4 class="text-lg font-semibold mb-4">Links</h4><ul class="space-y-2 text-gray-400"><li><a href="#" class="hover:text-green-400">Sobre Nós</a></li><li><a href="#" class="hover:text-green-400">Serviços</a></li></ul></div>
                <div><h4 class="text-lg font-semibold mb-4">Serviços</h4><ul class="space-y-2 text-gray-400"><li><a href="#" class="hover:text-green-400">Veterinário</a></li><li><a href="#" class="hover:text-green-400">Banho e Tosa</a></li></ul></div>
                <div><h4 class="text-lg font-semibold mb-4">Contato</h4><div class="space-y-2 text-gray-400"><p>(11) 99999-9999</p><p>contato@petcareplus.com.br</p></div></div>
            </div>
            <div class="border-t border-gray-800 pt-8 text-center text-gray-400">© 2024 PetCare Plus. Todos os direitos reservados.</div>
        </div>
    </footer>
</body>
</html>`,
    gjsCss: '',
    gjsComponents: '',
    gjsStyles: ''
  }
];
